
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("foVrt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4acD6 = parcelRequire("4acD6");


var $ihTS4 = parcelRequire("ihTS4");


var $jhcFr = parcelRequire("jhcFr");


var $9Tkc6 = parcelRequire("9Tkc6");


var $2Yc46 = parcelRequire("2Yc46");


var $9wGTI = parcelRequire("9wGTI");


var $7QM6o = parcelRequire("7QM6o");


var $bQm3c = parcelRequire("bQm3c");


var $02cx8 = parcelRequire("02cx8");


var $lmEhP = parcelRequire("lmEhP");


var $hfIjM = parcelRequire("hfIjM");

const $820a39291628bd44$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $820a39291628bd44$var$defaultOptions = {
    appearance: 'full-page',
    onFeedbackClicked: ()=>{},
    onReviewStateEntered: ()=>{},
    onExperienceComplete: ()=>{},
    aiGlobalOptIn: {
        status: 'disabled',
        triggerOptInFlow: ()=>{}
    }
};
const $820a39291628bd44$export$ac968d961305af39 = (options)=>{
    const optionsToUse = options || $820a39291628bd44$var$defaultOptions;
    const createEditorPluginAIOptions = (0, $42omo.useMemo)(()=>optionsToUse.appearance === 'page-comment' ? (0, $9Tkc6.createPageCommentEditorPluginAIOptions) : (0, $9Tkc6.createPageEditorPluginAIOptions), [
        optionsToUse.appearance
    ]);
    const optionsToUseRef = (0, $42omo.useRef)(optionsToUse);
    optionsToUseRef.current = optionsToUse;
    const { cloudId: cloudId, userId: userId, isRovoEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = (0, $9wGTI.fg)('platform_editor_rovo_availability') ? isRovoLLMEnabled : undefined;
    // Memoize session data to avoid recreating the object on every render
    const sessionData = (0, $42omo.useMemo)(()=>userId && cloudId ? {
            userId: userId,
            cloudId: cloudId
        } : undefined, [
        userId,
        cloudId
    ]);
    // Use the dedicated hook for auto-apply state management
    const autoApplyState = (0, $2Yc46.useAutoApplyState)((0, $9wGTI.fg)('enable_auto_apply_toggling') ? sessionData : undefined);
    const isInDocumentStreamingAllowed = (0, $9wGTI.fg)('enable_auto_apply_toggling') ? autoApplyState?.enabled ?? false : false;
    const refresh = autoApplyState?.refresh;
    // Listen for changes from other parts of the app
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('enable_auto_apply_toggling') || !refresh) return;
        const handleAutoApplyChange = ()=>{
            // Refresh the state from backend/localStorage when toggle changes
            refresh();
        };
        window.addEventListener('autoApplyChanged', handleAutoApplyChange);
        return ()=>window.removeEventListener('autoApplyChanged', handleAutoApplyChange);
    }, [
        refresh
    ]);
    // Use a ref to avoid recreating the options object on every state update
    const isInDocumentStreamingAllowedRef = (0, $42omo.useRef)(isInDocumentStreamingAllowed);
    isInDocumentStreamingAllowedRef.current = isInDocumentStreamingAllowed;
    const productConfig = (0, $42omo.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $jhcFr.useLinkPickerEditorProps)(undefined, productConfig);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId);
    const linkingProp = (0, $lmEhP.useLinkingFeatures)($820a39291628bd44$var$CARD_OPTIONS);
    const PromptEditor = (0, $42omo.useMemo)(()=>(0, $ihTS4.createPromptEditor)({
            linkPicker: linkPicker,
            enableLinks: true,
            linking: linkingProp.linking,
            mentionProvider: mentionProvider,
            featureFlags: {}
        }), [
        linkingProp.linking,
        linkPicker,
        mentionProvider
    ]);
    const editorRovoButtonActions = (0, $02cx8.useEditorRovoButtonActions)();
    const isAISmartButtonEnabled = (0, $42omo.useMemo)(()=>optionsToUse.appearance !== 'page-comment' && optionsToUse.aiGlobalOptIn.status === 'enabled', [
        optionsToUse.appearance,
        optionsToUse.aiGlobalOptIn.status
    ]);
    const { setNudges: setNudges } = (0, $4acD6.useAISmartButtonActions)();
    const aiSmartButtonOptions = (0, $42omo.useMemo)(()=>isAISmartButtonEnabled ? {
            actions: {
                ...editorRovoButtonActions,
                setNudges: setNudges
            }
        } : undefined, [
        isAISmartButtonEnabled,
        editorRovoButtonActions,
        setNudges
    ]);
    return (0, $42omo.useMemo)(()=>{
        return createEditorPluginAIOptions({
            aiGlobalOptIn: optionsToUseRef.current.aiGlobalOptIn,
            /**
			 * Hide AI button in primary toolbar when AI proactive is enabled or
			 * 	when appearance is full-page and AI smart button is enabled
			 */ hidePrimaryToolbarButton: optionsToUse.appearance === 'full-page' && optionsToUse.aiGlobalOptIn.status === 'enabled',
            generativeAIApiUrl: `${window.location.origin}/gateway/api/editor-ai/v1/generative/ai`,
            handleFeedbackSubmission: async (feedbackMetadata)=>{
                try {
                    // TODO: EDF-831: Fix and ensure types match with handleFeedbackSubmission
                    optionsToUseRef.current.onFeedbackClicked?.(feedbackMetadata);
                    return {
                        status: 'submitted'
                    };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                } catch (error) {
                    return {
                        status: 'failed'
                    };
                }
            },
            onAnnotationsRemoved: (0, $9wGTI.fg)('aifc_create_enabled') ? optionsToUseRef.current.onAnnotationsRemoved : undefined,
            onExperienceEvent: {
                // Thumbs up and down are being deprecated and are no longer used.
                THUMBS_UP: ()=>{},
                THUMBS_DOWN: ()=>{},
                REVIEW_STATE_ENTERED: ()=>{
                    optionsToUseRef.current.onReviewStateEntered?.();
                },
                EXPERIENCE_COMPLETE: ()=>{
                    optionsToUseRef.current.onExperienceComplete?.();
                }
            },
            onDocChangeByAgent: (_agent)=>{
            // TODO Integrate with confluence
            },
            onAIProviderChanged: (source, aiProvider)=>{
                if (optionsToUseRef.current.onAIProviderChanged) optionsToUseRef.current.onAIProviderChanged(source, aiProvider);
            },
            getUserPreferences: ()=>{
                if (!(0, $9wGTI.fg)('enable_auto_apply_toggling')) return {};
                return {
                    isInDocumentStreamingAllowed: isInDocumentStreamingAllowedRef.current
                };
            },
            getChannelVariables: optionsToUseRef.current.getChannelVariables,
            product: 'CONFLUENCE',
            objectId: optionsToUseRef.current.contentId,
            PromptEditor: PromptEditor,
            AIButtonWrapper: options?.AIButtonWrapper,
            providers: options?.providers,
            /**
			 * Need to audit logs only for confluence page as of now.
			 */ auditLogSettings: optionsToUse.appearance !== 'page-comment' && optionsToUse.contentId ? {
                enabled: true,
                eventData: {
                    type: 'page',
                    pageId: optionsToUse.contentId
                }
            } : {
                enabled: false
            },
            ...isAISmartButtonEnabled && {
                aiSmartButtonOptions: aiSmartButtonOptions
            },
            ...optionsToUse.usePlatformPrompt && {
                onSubmit: ()=>{}
            },
            isInDocumentStreamingEnabled: (0, $9wGTI.fg)('aifc_create_enabled'),
            isRovoEnabled: isRovoEnabled,
            // Provide creation context for experience-based agent routing.
            // Only set for full-page editor appearances (pages/blogs), not page comments.
            ...optionsToUse.appearance !== 'page-comment' && {
                creationContextParams: {
                    experience: 'inline_edit',
                    contentTypes: [
                        optionsToUse.contentType ?? 'page'
                    ]
                }
            }
        });
    }, [
        createEditorPluginAIOptions,
        optionsToUse.appearance,
        optionsToUse.contentId,
        optionsToUse.contentType,
        PromptEditor,
        options?.AIButtonWrapper,
        options?.providers,
        isAISmartButtonEnabled,
        aiSmartButtonOptions,
        optionsToUse.aiGlobalOptIn.status,
        optionsToUse.usePlatformPrompt,
        isRovoEnabled
    ]);
};
module.exports["useEditorPluginAIOptions"] = $820a39291628bd44$export$ac968d961305af39;

});

parcelRegister("9Tkc6", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $AMCQl = parcelRequire("AMCQl");

var $bpQiY = parcelRequire("bpQiY");

var $7ShCl = parcelRequire("7ShCl");


var $drPNW = parcelRequire("drPNW");

var $oeZjt = parcelRequire("oeZjt");

var $j398X = parcelRequire("j398X");

var $iulqN = parcelRequire("iulqN");

var $j8LwF = parcelRequire("j8LwF");

var $eugUs = parcelRequire("eugUs");

var $cH4SO = parcelRequire("cH4SO");

var $dLjaJ = parcelRequire("dLjaJ");


var $cbtR4 = parcelRequire("cbtR4");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $5SuLc = parcelRequire("5SuLc");


var $42omo = parcelRequire("42omo");








var $3HOqx = parcelRequire("3HOqx");

const $3aec6cdf0df0a4db$export$ced89349fedce38 = ({ size: size = 'medium' } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
        label: "",
        spacing: "spacious",
        size: size
    });



var $jc4DP = parcelRequire("jc4DP");


var $bwpRs = parcelRequire("bwpRs");

const $27f50db3f6ad9211$export$683185be8e4be56f = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).BRAINSTORM,
        title: (0, $AMCQl.aiConfigItemMessages).brainstormTitle,
        description: (0, $AMCQl.aiConfigItemMessages).brainstormDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aec6cdf0df0a4db$export$ced89349fedce38), null),
        promptLabel: (0, $AMCQl.aiConfigItemMessages).brainstormPromptLabel,
        promptHint: (0, $AMCQl.aiConfigItemMessages).brainstormPromptHint,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        agentId: 'editor_agent',
        intentSchemaId: 'brainstorm_intent_schema.json',
        featureId: 'brainstorm',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $27f50db3f6ad9211$export$dddd8d441293ae3 = (options)=>({
        config: $27f50db3f6ad9211$export$683185be8e4be56f(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });



var $l5nYy = parcelRequire("l5nYy");








var $cUQMr = parcelRequire("cUQMr");







const $42e6feb7d3869fde$var$intentSchemaId = 'convert_to_bullet_points.json';
const $42e6feb7d3869fde$export$c791aa34bcfdf607 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CONVERT_TO_BULLETED_LIST,
        title: (0, $AMCQl.aiConfigItemMessages).convertToBulletListTitle,
        description: (0, $AMCQl.aiConfigItemMessages).convertToBulletListDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $42e6feb7d3869fde$var$intentSchemaId,
        actions: {
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $42e6feb7d3869fde$export$37c986c539d0ca07 = (options)=>({
        config: $42e6feb7d3869fde$export$c791aa34bcfdf607(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });









var $4ymSL = parcelRequire("4ymSL");







const $db220b5201a1bbd7$var$intentSchemaId = 'convert_to_table.json';
const $db220b5201a1bbd7$export$a7ada90d2d2877a7 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).CONVERT_TO_TABLE,
        title: (0, $AMCQl.aiConfigItemMessages).convertToTableTitle,
        description: (0, $AMCQl.aiConfigItemMessages).convertToTableDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                label: "",
                spacing: "spacious"
            }),
        statusLozengeType: 'beta',
        intentSchemaId: $db220b5201a1bbd7$var$intentSchemaId,
        actions: {
            selection: [
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $jc4DP.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    });
const $db220b5201a1bbd7$export$d67616d0b45ccf63 = (options)=>({
        config: $db220b5201a1bbd7$export$a7ada90d2d2877a7(options),
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    });



var $iBSwI = parcelRequire("iBSwI");












var $c6GJD = parcelRequire("c6GJD");

const $63b70a897e24cdc6$export$cd87ff8f4335648e = ()=>{
    const getExperimentValue = (0, $c6GJD.default).getExperimentValue;
    const variation = getExperimentValue('platform_editor_ai-prompts-placeholder', 'cohort', 'not-enrolled');
    if (variation !== 'control' && variation !== 'not-enrolled') {
        const label = getExperimentValue('platform_editor_ai-prompts-placeholder', 'label', '');
        const description = getExperimentValue('platform_editor_ai-prompts-placeholder', 'description', '');
        const intent = getExperimentValue('platform_editor_ai-prompts-placeholder', 'intent', '');
        const listOrder = getExperimentValue('platform_editor_ai-prompts-placeholder', 'list_order', 0);
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        // The follow are optional backwards compatible properties which can be configured in the experiment
        const showOnEmpty = getExperimentValue('platform_editor_ai-prompts-placeholder', 'show_on_empty_page', true);
        const statusType = getExperimentValue('platform_editor_ai-prompts-placeholder', 'prompt_status_type', '');
        if (label && description && intent && analyticsExperienceName) return {
            label: {
                id: label,
                description: label,
                defaultMessage: label
            },
            description: {
                id: description,
                description: description,
                defaultMessage: description
            },
            intent: intent,
            listOrder: listOrder,
            analyticsExperienceName: analyticsExperienceName,
            showOnEmpty: showOnEmpty,
            statusType: statusType
        };
    }
};


const $84071a294f2874db$export$6cd03141a939166d = ()=>{
    const configurations = (0, $63b70a897e24cdc6$export$cd87ff8f4335648e)();
    if (configurations) {
        const statusLozengeType = configurations.statusType.toLowerCase() === 'new' || configurations.statusType.toLowerCase() === 'beta' ? configurations.statusType.toLowerCase() : undefined;
        return {
            ...configurations,
            configItem: {
                key: (0, $bwpRs.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER,
                title: configurations.label,
                description: configurations.description,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aec6cdf0df0a4db$export$ced89349fedce38), null),
                statusLozengeType: statusLozengeType,
                intentSchemaId: configurations.intent,
                actions: {
                    empty: [
                        (0, $jc4DP.createInsertAtCurrentPosition)({
                            appearance: 'secondary'
                        }),
                        (0, $jc4DP.createInsertAtTop)({
                            appearance: 'primary'
                        })
                    ],
                    selection: [
                        (0, $jc4DP.createInsertBelow)({
                            appearance: 'secondary'
                        }),
                        (0, $jc4DP.createReplace)({
                            appearance: 'primary'
                        })
                    ]
                },
                getBackendModel: ()=>{
                    return 'assistance-service';
                }
            }
        };
    }
};
const $84071a294f2874db$export$d991dc90761ce2a0 = ()=>{
    const res = $84071a294f2874db$export$6cd03141a939166d();
    if (res) {
        const { configItem: configItem, ...others } = res;
        return {
            configItemWithOptions: {
                config: configItem,
                triggers: {
                    empty: {
                        enabled: true,
                        docMinSize: 1
                    },
                    selection: {
                        enabled: true
                    }
                }
            },
            ...others
        };
    }
};












var $54tpX = parcelRequire("54tpX");

const $c28ec1426b832604$export$6eebfc33bd4f687b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($54tpX))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });








const $3e2ed2d891be3ae7$export$acf0f0fea45f23f0 = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FIND_ACTION_ITEMS,
        title: (0, $AMCQl.aiConfigItemMessages).findActionItemsTitle,
        description: (0, $AMCQl.aiConfigItemMessages).findActionItemsDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c28ec1426b832604$export$6eebfc33bd4f687b), null),
        intentSchemaId: 'action_items_intent_schema.json',
        featureId: 'find_action_items',
        actions: {
            empty: [
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $jc4DP.createInsertAtTop)({
                    appearance: 'secondary'
                }),
                (0, $jc4DP.createInsertBelow)({
                    appearance: 'primary',
                    factoryOptions: options
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $3e2ed2d891be3ae7$export$8edb35f92492e5cd = (options)=>({
        config: $3e2ed2d891be3ae7$export$acf0f0fea45f23f0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });






var $SFzFl = parcelRequire("SFzFl");




const $3502234323631fdc$export$28052871323f977f = (options)=>({
        key: (0, $bwpRs.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
        // This is to avoid StateMachine `guard` check
        title: {
            id: 'free-generate-aifc-title',
            defaultMessage: 'Free Generate AIFC'
        },
        description: (0, $SFzFl.default).aiUniversalLongCallToAction,
        promptHint: (0, $AMCQl.aiConfigItemMessages).freeGeneratePromptHint,
        adfPrompt: true,
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        actions: {},
        getBackendModel: ()=>'aifc-bridge'
    });



var $i5NyM = parcelRequire("i5NyM");


var $2KJU8 = parcelRequire("2KJU8");


var $96Uu5 = parcelRequire("96Uu5");


var $kOMDA = parcelRequire("kOMDA");


var $70Lwl = parcelRequire("70Lwl");


var $iipo1 = parcelRequire("iipo1");


var $6PN31 = parcelRequire("6PN31");


var $8vIZB = parcelRequire("8vIZB");


var $klIiV = parcelRequire("klIiV");

const $34183cfe058a8bad$export$fa98ce94fc01fa17 = {
    brainstormConfigItem: (0, $27f50db3f6ad9211$export$683185be8e4be56f)(),
    freeGenerateAifcConfigItem: (0, $3502234323631fdc$export$28052871323f977f)(),
    addPolishConfigItem: ()=>(0, $kOMDA.addPolish)()
};
function $34183cfe058a8bad$var$getDynamicSurfaceConfigItems(opts) {
    const dynamicSurfaceConfigItems = [
        // Only brainstorm, suggest title and find action items are enabled for empty
        {
            config: (0, $iBSwI.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $iBSwI.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEducational)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $96Uu5.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $2KJU8.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $kOMDA.addPolishWithOptions)(opts),
        // Convert to table and bullet list are already on enabled for selection
        (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
        (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
        (0, $3e2ed2d891be3ae7$export$8edb35f92492e5cd)(opts),
        (0, $70Lwl.suggestTitleForConfluenceTitleToolbarWithOptions)(opts),
        {
            config: (0, $iipo1.summarizeWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $6PN31.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    // Fix this const name after team 25 with platform_editor_ai_aifc_streaming being cleaned up
    const dynamicSurfaceConfigItemsTeam25 = [
        {
            config: (0, $iBSwI.improveWriting)(opts),
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        },
        (0, $kOMDA.addPolishWithOptions)(opts),
        {
            config: (0, $iBSwI.fixSpellingAndGrammar)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToCasual)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToEmpathetic)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $l5nYy.changeToneToProfessional)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $96Uu5.makeShorter)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        {
            config: (0, $2KJU8.makeLonger)(opts),
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        },
        ...(0, $6PN31.translationConfigItemWithOptionsEnabledForSelectionOnly)(opts)
    ];
    return opts.isInDocumentStreamingEnabled ? dynamicSurfaceConfigItemsTeam25 : dynamicSurfaceConfigItems;
}
const $34183cfe058a8bad$export$25814a113f71ded2 = (props)=>{
    const { editorView: editorView, configItem: configItem } = props;
    const openAIModalCommand = (0, $5SuLc.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: 'triggerConfigItem',
        aiGlobalOptIn: {
            status: 'enabled',
            triggerOptInFlow: ()=>{}
        }
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
function $34183cfe058a8bad$export$15d114523124a386(options) {
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
            (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $84071a294f2874db$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $i5NyM.freeGenerate)(),
        configItemWithOptions: getConfigItems({
            product: product,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
        }),
        disableAISelectionToolbar: true,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $klIiV._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        /**
     * Below options are added to use rovo agent behind the scenes for free generate.
     *
     * Need to load rovo agents, so getChannelVariables and isRovoEnabled is set.
     * showRovoAgentsInCommandPalette will disable showing Rovo agents section.
     * useFreeGenerateEditorAgent will swap standard free generate prompt with
     * 	rovo agent enabled free generate after agents are loaded.
     * If loading agents fails, then fallback to standard free generate.
     */ getChannelVariables: options.getChannelVariables,
        isRovoEnabled: options.isRovoEnabled ?? true,
        showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? false,
        useFreeGenerateEditorAgent: options.useFreeGenerateEditorAgent ?? true,
        onSubmit: options.onSubmit,
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        enableQuickPrompt: options.enableQuickPrompt ?? false
    };
}
const $34183cfe058a8bad$export$b2747cd26144b27d = (options)=>{
    /**
   * Not abstracting these defaults up, in order to be explicit about possible
   * different behaviours between page comment and page editors.
   */ // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    function getConfigItems(opts) {
        const list = [
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
            (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
            (0, $3e2ed2d891be3ae7$export$8edb35f92492e5cd)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            (0, $kOMDA.addPolishWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const newListOrder = [
            (0, $iBSwI.fixSpellingAndGrammarWithOptions)(opts),
            (0, $l5nYy.changeToneToProfessionalWithOptions)(opts),
            (0, $96Uu5.makeShorterWithOptions)(opts),
            (0, $iipo1.summarizeWritingWithOptions)(opts),
            (0, $iBSwI.improveWritingWithOptions)(opts),
            (0, $2KJU8.makeLongerWithOptions)(opts),
            (0, $42e6feb7d3869fde$export$37c986c539d0ca07)(opts),
            (0, $db220b5201a1bbd7$export$d67616d0b45ccf63)(opts),
            (0, $3e2ed2d891be3ae7$export$8edb35f92492e5cd)(opts),
            (0, $70Lwl.suggestTitleWithOptions)(opts),
            (0, $l5nYy.changeToneToEmpatheticWithOptions)(opts),
            (0, $l5nYy.changeToneToCasualWithOptions)(opts),
            (0, $l5nYy.changeToneToEducationalWithOptions)(opts),
            (0, $kOMDA.addPolishWithOptions)(opts),
            ...(0, $6PN31.translationConfigItemWithOptions)(opts)
        ];
        const experimentalPromptPlaceholderData = (0, $84071a294f2874db$export$d991dc90761ce2a0)();
        if (experimentalPromptPlaceholderData && !opts.isInDocumentStreamingEnabled) {
            const { listOrder: listOrder, configItemWithOptions: configItemWithOptions } = experimentalPromptPlaceholderData;
            list.splice(listOrder, 0, configItemWithOptions);
        }
        return opts.isInDocumentStreamingEnabled ? newListOrder : list;
    }
    const product = options.product ? options.product : 'CONFLUENCE';
    const isInDocumentStreamingEnabled = options.isInDocumentStreamingEnabled ?? (0, $dh538.fg)('platform_editor_ai_aifc_streaming');
    const configItemOptions = {
        product: product,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    };
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $i5NyM.freeGenerate)(configItemOptions),
        configItemWithOptions: getConfigItems(configItemOptions),
        getSelectionToolbarDropdowns () {
            const selectionToolbarOptions = [
                {
                    id: 'change-tone',
                    label: (0, $7ShCl.aiMessages).confluenceChangeToneSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneProfessionalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToProfessional)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneEmpatheticToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToEmpathetic)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneCasualToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToCasual)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneNeutralToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToNeutral)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).changeToneEducationalToneSelectionToolbarDropdownItemTitle,
                            configItem: (0, $l5nYy.changeToneToEducational)(configItemOptions)
                        }
                    ]
                },
                {
                    id: 'rewrite',
                    label: (0, $7ShCl.aiMessages).confluenceRewriteSelectionToolbarDropdownMenuTitle,
                    options: [
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).improveWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iBSwI.improveWriting)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).fixSpellingGrammarSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iBSwI.fixSpellingAndGrammar)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).summarizeWritingSelectionToolbarDropdownItemTitle,
                            configItem: (0, $iipo1.summarizeWriting)(configItemOptions)
                        },
                        {
                            label: (0, $AMCQl.aiConfigItemMessages).makeShorterSelectionToolbarDropdownItemTitle,
                            configItem: (0, $96Uu5.makeShorter)(configItemOptions)
                        }
                    ]
                }
            ];
            const translationConfigItemsMap = (0, $6PN31.createTranslationConfigItems)(configItemOptions);
            const translateOptions = (0, $8vIZB.getSortedSupportedTranslationLanguages)().map((language)=>{
                const label = (0, $bpQiY.aiLanguageMessages)[language];
                return {
                    label: label,
                    configItem: translationConfigItemsMap[language]
                };
            });
            selectionToolbarOptions.push({
                id: 'translate',
                label: (0, $7ShCl.aiMessages).confluenceTranslateSelectionToolbarDropdownMenuTitle,
                options: translateOptions
            });
            return selectionToolbarOptions;
        },
        disableAISelectionToolbar: false,
        hidePrimaryToolbarButton: isInDocumentStreamingEnabled ? false : options.hidePrimaryToolbarButton,
        product: product,
        objectId: options.objectId,
        getFetchCustomHeaders: options.getFetchCustomHeaders || (0, $klIiV._getFetchCustomHeaders),
        getChannelVariables: options.getChannelVariables,
        onDocChangeByAgent: options.onDocChangeByAgent,
        onAIProviderChanged: options.onAIProviderChanged,
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        aiUsageDisclaimer: options.aiUsageDisclaimer,
        isRovoEnabled: options.isRovoEnabled ?? true,
        /**
     * Below options are added because;
     * - Show rovo agents in command palette.
     */ showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? true,
        providers: options.providers,
        auditLogSettings: options.auditLogSettings,
        aiSmartButtonOptions: options.aiSmartButtonOptions,
        heroConfigItem: isInDocumentStreamingEnabled ? (0, $iBSwI.improveWritingWithOptions)(configItemOptions) : undefined,
        ...options.aiGlobalOptIn.status === 'enabled' && (0, $dh538.fg)('ai-smart-button-team-25') && {
            dynamicSurfaceConfigItems: $34183cfe058a8bad$var$getDynamicSurfaceConfigItems(configItemOptions)
        },
        onAnnotationsRemoved: options.onAnnotationsRemoved,
        getUserPreferences: options.getUserPreferences,
        onSubmit: options.onSubmit,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
        enableQuickPrompt: options.enableQuickPrompt ?? true,
        creationContextParams: options.creationContextParams
    };
};
const $34183cfe058a8bad$export$679d027153aa30cf = (editorApi)=>{
    const onActionClick = (configItem)=>{
        return ()=>{
            editorApi.aiExperience?.actions.openAIModal({
                invokedFrom: 'objectSidebar',
                configItem: configItem
            });
        };
    };
    const configItemOptions = {
        product: 'CONFLUENCE',
        isInDocumentStreamingEnabled: (0, $dh538.fg)('platform_editor_ai_aifc_streaming')
    };
    const changeToneActionItems = [
        {
            title: (0, $7ShCl.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))),
            onClick: onActionClick((0, $l5nYy.changeToneToProfessional)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).moreCasualToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j398X))),
            onClick: onActionClick((0, $l5nYy.changeToneToCasual)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($j8LwF))),
            onClick: onActionClick((0, $l5nYy.changeToneToEmpathetic)(configItemOptions))
        }
    ];
    const adjustLengthActionItems = [
        {
            title: (0, $7ShCl.aiMessages).makeShorterToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cH4SO))),
            onClick: onActionClick((0, $96Uu5.makeShorter)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).makeLongerToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eugUs))),
            onClick: onActionClick((0, $2KJU8.makeLonger)(configItemOptions))
        }
    ];
    const objectSideBarButtons = [
        {
            title: (0, $7ShCl.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dLjaJ))),
            onClick: onActionClick((0, $iBSwI.fixSpellingAndGrammar)(configItemOptions))
        },
        {
            title: (0, $7ShCl.aiMessages).changeToneToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iulqN))),
            subItems: changeToneActionItems
        },
        {
            title: (0, $7ShCl.aiMessages).adjustLengthToolbarDropdownIconTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($drPNW))),
            subItems: adjustLengthActionItems
        },
        {
            title: (0, $1oCLl.expValEquals)('platform_editor_ai_rename_add_polish', 'isEnabled', true) ? (0, $AMCQl.aiConfigItemMessages).improveFormattingTitle : (0, $AMCQl.aiConfigItemMessages).addPolishTitle,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cbtR4))),
            onClick: onActionClick((0, $kOMDA.addPolish)(configItemOptions))
        }
    ];
    return objectSideBarButtons;
};
module.exports["UNSTABLE_configItems"] = $34183cfe058a8bad$export$fa98ce94fc01fa17;
module.exports["UNSTABLE_DO_NOT_USE_ONLY_FOR_CONFLUENCE_triggerConfigItem"] = $34183cfe058a8bad$export$25814a113f71ded2;
module.exports["createPageCommentEditorPluginAIOptions"] = $34183cfe058a8bad$export$15d114523124a386;
module.exports["createPageEditorPluginAIOptions"] = $34183cfe058a8bad$export$b2747cd26144b27d;
module.exports["getEditorActionsForObjectSidebar"] = $34183cfe058a8bad$export$679d027153aa30cf;

});

parcelRegister("84Iqc", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");

/**
 * Shared prefix for every decoration key produced by the show-diff plugin.
 * All keys derive from this, so the full set of plugin decorations can be
 * identified by this single prefix.
 */ const $d389c671c2e69790$export$73f0f725d4ab2705 = 'diff';
const $d389c671c2e69790$export$821fbb25e40fbb48 = {
    inline: `${$d389c671c2e69790$export$73f0f725d4ab2705}-inline`,
    block: `${$d389c671c2e69790$export$73f0f725d4ab2705}-block`,
    widget: `${$d389c671c2e69790$export$73f0f725d4ab2705}-widget`
};
const $d389c671c2e69790$export$e95973fb6fa1595f = ({ type: type, isActive: isActive })=>isActive !== undefined ? `${type}-${isActive ? 'active' : 'inactive'}` : type;


/**
 * True if `fragment` contains at least one inline node (text, hardBreak, emoji, mention, etc.).
 * Block-only subtrees (e.g. empty paragraphs, block cards with no inline children) return false.
 */ function $f881639693888cff$var$fragmentContainsInlineContent(fragment) {
    for(let i = 0; i < fragment.childCount; i++){
        const node = fragment.child(i);
        if (node.isInline) return true;
        if (node.content.size > 0 && $f881639693888cff$var$fragmentContainsInlineContent(node.content)) return true;
    }
    return false;
}
function $f881639693888cff$export$1176e62203433107(doc, from, to) {
    try {
        const slice = doc.slice(from, to);
        return $f881639693888cff$var$fragmentContainsInlineContent(slice.content);
    } catch  {
        return false;
    }
}
/**
 * Checks if range1 is fully contained within range2
 */ function $f881639693888cff$var$isRangeFullyInside(range1Start, range1End, range2Start, range2End) {
    return range2Start <= range1Start && range1End <= range2End;
}
const $f881639693888cff$export$c459ab16dd3c3d79 = (set, doc)=>{
    if (!set) return [];
    const seenBlockKeys = new Set();
    const allDecorations = set.find(undefined, undefined, (spec)=>spec.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).inline) || spec.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).widget) || spec.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).block));
    // First pass: filter out listItem blocks and deduplicates blocks
    const filtered = allDecorations.filter((dec)=>{
        if (dec.spec?.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).block)) {
            // Skip listItem blocks as they are not scrollable
            if (dec.spec?.nodeName === 'listItem') return false;
        }
        const key = `${dec.from}-${dec.to}-${dec.spec?.nodeName ?? ''}`;
        // Skip blocks that have already been seen
        if (seenBlockKeys.has(key)) return false;
        seenBlockKeys.add(key);
        return true;
    });
    // Separate decorations by type for easier processing
    const blocks = filtered.filter((d)=>d.spec?.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).block));
    const rawInlines = filtered.filter((d)=>d.spec?.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).inline));
    const inlines = doc !== undefined ? rawInlines.filter((d)=>$f881639693888cff$export$1176e62203433107(doc, d.from, d.to)) : rawInlines;
    const widgets = filtered.filter((d)=>d.spec?.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).widget));
    // Second pass: exclude overlapping decorations
    // Rules:
    // - If an inline is fully inside a block, exclude the block (inline takes priority)
    // - If a block is fully inside an inline, exclude the block (inline takes priority)
    const nonOverlappingBlocks = blocks.filter((block)=>{
        // Exclude block if:
        // 1. It's fully contained within any inline, OR
        // 2. It fully contains any inline
        return !inlines.some((inline)=>$f881639693888cff$var$isRangeFullyInside(block.from, block.to, inline.from, inline.to) || // block inside inline
            $f881639693888cff$var$isRangeFullyInside(inline.from, inline.to, block.from, block.to));
    });
    // Combine all non-overlapping decorations
    const result = [
        ...nonOverlappingBlocks,
        ...inlines,
        ...widgets
    ];
    // Sort by from position, then by to position
    result.sort((a, b)=>a.from === b.from ? a.to - b.to : a.from - b.from);
    return result;
};



var $6tl2G = parcelRequire("6tl2G");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");


var $cO9ey = parcelRequire("cO9ey");


var $ftzrq = parcelRequire("ftzrq");




// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");


var $6rMOj = parcelRequire("6rMOj");


var $2pjJ5 = parcelRequire("2pjJ5");








var $aXG5V = parcelRequire("aXG5V");

/**
 * Returns a copy of the document with all marks removed from all text.
 * This normalises mark fragmentation — e.g. annotation marks reordering can split
 * a single text run into many text nodes, making structural comparison unreliable.
 * After stripping, ProseMirror will merge adjacent text nodes so childCounts are stable.
 */ function $1363eb0394885651$var$stripMarks(doc) {
    const tr = new (0, $aXG5V.Transform)(doc);
    tr.removeMark(0, doc.content.size);
    return tr.doc;
}
/**
 * Returns true if both (mark-stripped) nodes have the same block tree structure (node type and child count at every level)
 */ function $1363eb0394885651$var$isBlockStructureEqual(node1, node2) {
    if (node1.type !== node2.type || node1.childCount !== node2.childCount) return false;
    for(let i = 0; i < node1.childCount; i++){
        if (!$1363eb0394885651$var$isBlockStructureEqual(node1.child(i), node2.child(i))) return false;
    }
    return true;
}
function $1363eb0394885651$export$2b9c81e9e2c68dae(doc1, doc2) {
    if (doc1.textContent !== doc2.textContent) return false;
    // Strip marks before comparing so that mark-driven text fragmentation
    // (e.g. annotation mark reordering producing different childCounts) does not
    // cause false inequalities.
    const stripped1 = $1363eb0394885651$var$stripMarks(doc1);
    const stripped2 = $1363eb0394885651$var$stripMarks(doc2);
    return doc1.nodeSize === doc2.nodeSize && $1363eb0394885651$var$isBlockStructureEqual(stripped1, stripped2);
}



var $24P9d = parcelRequire("24P9d");










const $cfabb2a9f68e2f34$export$8382eabaf43593de = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $cfabb2a9f68e2f34$export$bab085854a7b47c = (0, $24P9d.convertToInlineCss)({
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $cfabb2a9f68e2f34$export$97e4289fb0e21ca7 = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-purple, #803FA5)"
});
const $cfabb2a9f68e2f34$export$6cbccbf53a6b2a8 = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $cfabb2a9f68e2f34$export$21401c524509064e = (0, $24P9d.convertToInlineCss)({
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $cfabb2a9f68e2f34$export$6edd58aab948260b = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    borderBottom: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    padding: `1px 0 2px`
});
const $cfabb2a9f68e2f34$export$f65e7b80cdbdaf11 = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.6
});
const $cfabb2a9f68e2f34$export$1c9944aa8f37265b = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text, #292A2E)",
    textDecoration: 'line-through',
    textDecorationColor: "var(--ds-text-accent-gray, #505258)",
    position: 'relative',
    opacity: 1
});
const $cfabb2a9f68e2f34$export$da356444d868ff8e = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 0.8
});
const $cfabb2a9f68e2f34$export$19cf8e2cf40a1110 = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    borderBottom: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    padding: `1px 0 2px`
});
const $cfabb2a9f68e2f34$export$f9aac5ed53f3d424 = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-text-accent-gray, #505258)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $cfabb2a9f68e2f34$export$4be2f4158e5479e9 = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-gray, #7D818A)"}`
});
const $cfabb2a9f68e2f34$export$a26de8170ba89016 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $cfabb2a9f68e2f34$export$b1c2428901df334f = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $cfabb2a9f68e2f34$export$2b892754935ecdf0 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $cfabb2a9f68e2f34$export$f2cea9f09f40fb64 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $cfabb2a9f68e2f34$export$95d973a7458c1194 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-gray, #7D818A)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $cfabb2a9f68e2f34$export$1e0b247f41c702d9 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $cfabb2a9f68e2f34$export$ba3acd64357126ab = (0, $24P9d.convertToInlineCss)({
    color: "var(--ds-text-accent-gray, #505258)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $cfabb2a9f68e2f34$export$61432713bede9dea = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`
});
const $cfabb2a9f68e2f34$export$69c3a1c4f451af4e = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-purple, #AF59E1)"
});
const $cfabb2a9f68e2f34$export$6ba987e1eae93022 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $cfabb2a9f68e2f34$export$7643378707ce1e7 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $cfabb2a9f68e2f34$export$5675345213f1a131 = (0, $24P9d.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-purple, #AF59E1)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $cfabb2a9f68e2f34$export$d311b2309a26b4fb = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-purple, #AF59E1)"}`,
    pointerEvents: 'none'
});
const $cfabb2a9f68e2f34$export$7000268b4d4c5e1 = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-gray, #7D818A)"}`,
    pointerEvents: 'none'
});





const $ea8348750032d332$export$5f26b1217ef25d6b = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-border-accent-green, #22A06B)"
});
const $ea8348750032d332$export$a9b71bdebdda9dc4 = (0, $24P9d.convertToInlineCss)({
    background: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    textDecoration: 'underline',
    textDecorationStyle: 'solid',
    textDecorationThickness: "var(--ds-space-025, 2px)",
    textDecorationColor: "var(--ds-text-accent-green, #216E4E)"
});
const $ea8348750032d332$var$deletedTraditionalInlineStyleBase = {
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    position: 'relative',
    opacity: 1
};
const $ea8348750032d332$var$deletedTraditionalInlineStyleActiveBase = {
    ...$ea8348750032d332$var$deletedTraditionalInlineStyleBase,
    textDecorationThickness: '2px',
    backgroundColor: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)"
};
function $ea8348750032d332$export$f37b168a762b249f(isActive) {
    return isActive ? (0, $24P9d.convertToInlineCss)($ea8348750032d332$var$deletedTraditionalInlineStyleActiveBase) : (0, $24P9d.convertToInlineCss)($ea8348750032d332$var$deletedTraditionalInlineStyleBase);
}
const $ea8348750032d332$export$d7c13cc5c70ee199 = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `1px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $ea8348750032d332$export$e384205f8cc82cfe = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: '50%',
    width: '100%',
    display: 'inline-block',
    borderTop: `2px solid ${"var(--ds-border-accent-red, #E2483D)"}`,
    pointerEvents: 'none',
    zIndex: 1
});
const $ea8348750032d332$export$781ad9e3e3929b91 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$cd5411bbe62ac5f5 = (0, $24P9d.convertToInlineCss)({
    marginTop: "var(--ds-space-150, 12px)",
    paddingTop: "var(--ds-space-025, 2px)",
    paddingBottom: "var(--ds-space-025, 2px)",
    paddingLeft: "var(--ds-space-025, 2px)",
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$2881f0731c48e52 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$bb158c719faea3c7 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$4d45bc5137e495cf = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-red, #E2483D)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $ea8348750032d332$export$9c9f71734a3c1e70 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtler-pressed, #FD9891)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $ea8348750032d332$export$94cf9011b730dea = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$bd7e21e639c80e8d = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    borderRadius: `calc(${"var(--ds-radius-xsmall, 2px)"} + 1px)`
});
const $ea8348750032d332$export$62207903895cae1 = (0, $24P9d.convertToInlineCss)({
    textDecorationColor: "var(--ds-border-accent-red, #E2483D)",
    textDecoration: 'line-through',
    opacity: 0.6,
    display: 'table-row'
});
const $ea8348750032d332$export$2baa37676a9f2541 = (0, $24P9d.convertToInlineCss)({
    borderLeft: `2px solid ${"var(--ds-border-accent-green, #22A06B)"}`
});
const $ea8348750032d332$export$94c7715dcf202eb7 = (0, $24P9d.convertToInlineCss)({
    borderLeft: `4px solid ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`
});
const $ea8348750032d332$export$f0d2b829bf102560 = (0, $24P9d.convertToInlineCss)({
    borderLeft: `4px solid ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`
});
const $ea8348750032d332$export$83df991322f77466 = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-border-accent-green, #22A06B)"
});
const $ea8348750032d332$export$987d21925631f1e0 = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    border: 'none',
    height: '4px',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$27f4e50fea498762 = (0, $24P9d.convertToInlineCss)({
    backgroundColor: "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    border: 'none',
    height: '4px',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$d4e3bc1287ea5f02 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$2e643fe7923d8094 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$a60bf2c814acef8e = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $ea8348750032d332$export$4352b2b7d464e82a = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-accent-green, #22A06B)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $ea8348750032d332$export$b5d15ab6b9f40699 = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $ea8348750032d332$export$cf5a738872f070ca = (0, $24P9d.convertToInlineCss)({
    boxShadow: `0 0 0 4px ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    borderRadius: "var(--ds-radius-medium, 6px)"
});
const $ea8348750032d332$export$90be779ecd934b0a = (0, $24P9d.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-border-accent-green, #22A06B)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $ea8348750032d332$export$25ad6f21613cdcf1 = (0, $24P9d.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $ea8348750032d332$export$4752b9cd0a02e8d3 = (0, $24P9d.convertToInlineCss)({
    '--diff-decoration-marker-color': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $ea8348750032d332$export$e3ce52bf0fe385a = (0, $24P9d.convertToInlineCss)({
    ...$ea8348750032d332$var$deletedTraditionalInlineStyleBase,
    '--diff-decoration-marker-color': "var(--ds-border-accent-red, #E2483D)",
    '--diff-decoration-marker-ring-width': '1px'
});
const $ea8348750032d332$export$1c68397531783614 = (0, $24P9d.convertToInlineCss)({
    ...$ea8348750032d332$var$deletedTraditionalInlineStyleBase,
    '--diff-decoration-marker-color': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $ea8348750032d332$export$2e6c07fb91e6b5f7 = (0, $24P9d.convertToInlineCss)({
    ...$ea8348750032d332$var$deletedTraditionalInlineStyleActiveBase,
    '--diff-decoration-marker-color': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    '--diff-decoration-marker-ring-width': '4px'
});
const $ea8348750032d332$export$d2957495f69575c = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-accent-green, #22A06B)"}`,
    pointerEvents: 'none'
});
const $ea8348750032d332$export$4447a7c482f80938 = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-background-accent-green-subtler-pressed, #7EE2B8)"}`,
    pointerEvents: 'none'
});
const $ea8348750032d332$export$ea323b9930a7947d = (0, $24P9d.convertToInlineCss)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: `rgba(from ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} r g b / 0.5)`,
    zIndex: 1,
    outline: `1px solid ${"var(--ds-border-disabled, #0515240F)"}`,
    pointerEvents: 'none'
});



const $3924418ec490911a$var$displayNoneStyle = (0, $24P9d.convertToInlineCss)({
    display: 'none'
});
const $3924418ec490911a$var$getNodeClass = (name)=>{
    switch(name){
        case 'extension':
            return 'show-diff-changed-decoration-node';
        default:
            return undefined;
    }
};
const $3924418ec490911a$var$getBlockNodeStyle = ({ nodeName: nodeName, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false })=>{
    const isTraditional = colorScheme === 'traditional';
    if ([
        'mediaSingle',
        'mediaGroup',
        'table',
        // Handle table separately to avoid border issues
        'tableRow',
        'paragraph',
        // Paragraph and heading nodes do not need special styling
        'heading',
        'hardBreak',
        'decisionList',
        'taskList',
        'bulletList',
        'orderedList',
        'layoutSection'
    ].includes(nodeName)) // Layout nodes do not need special styling
    return undefined;
    if ([
        'tableCell',
        'tableHeader'
    ].includes(nodeName)) {
        if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) // This is used for positioning the cell overlay widget decorations
        return (0, $24P9d.convertToInlineCss)({
            position: 'relative'
        });
        // When gate is off, it should return undefined as above
        return undefined;
    }
    if ([
        'extension',
        'embedCard',
        'listItem'
    ].includes(nodeName)) {
        if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
            if (isInserted) return isTraditional && isActive ? (0, $ea8348750032d332$export$4752b9cd0a02e8d3) : isTraditional ? (0, $ea8348750032d332$export$25ad6f21613cdcf1) : (0, $cfabb2a9f68e2f34$export$5675345213f1a131);
            else return isTraditional && isActive ? (0, $ea8348750032d332$export$2e6c07fb91e6b5f7) : isTraditional ? (0, $ea8348750032d332$export$1c68397531783614) : (0, $cfabb2a9f68e2f34$export$da356444d868ff8e);
        }
        return isTraditional && isActive ? (0, $ea8348750032d332$export$4752b9cd0a02e8d3) : isTraditional ? (0, $ea8348750032d332$export$25ad6f21613cdcf1) : (0, $cfabb2a9f68e2f34$export$5675345213f1a131);
    }
    if (nodeName === 'blockquote') {
        if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
            if (isInserted) return isTraditional ? isActive ? (0, $ea8348750032d332$export$f0d2b829bf102560) : (0, $ea8348750032d332$export$94c7715dcf202eb7) : (0, $cfabb2a9f68e2f34$export$61432713bede9dea);
            else return isTraditional ? (0, $ea8348750032d332$export$781ad9e3e3929b91) : (0, $cfabb2a9f68e2f34$export$4be2f4158e5479e9);
        }
        return isTraditional ? isActive ? (0, $ea8348750032d332$export$f0d2b829bf102560) : (0, $ea8348750032d332$export$94c7715dcf202eb7) : (0, $cfabb2a9f68e2f34$export$61432713bede9dea);
    }
    if (nodeName === 'rule') {
        if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
            if (isInserted) return isTraditional ? isActive ? (0, $ea8348750032d332$export$27f4e50fea498762) : (0, $ea8348750032d332$export$987d21925631f1e0) : (0, $cfabb2a9f68e2f34$export$69c3a1c4f451af4e);
            else return isTraditional ? (0, $ea8348750032d332$export$f37b168a762b249f)(false) : (0, $cfabb2a9f68e2f34$export$da356444d868ff8e);
        }
        return isTraditional ? isActive ? (0, $ea8348750032d332$export$27f4e50fea498762) : (0, $ea8348750032d332$export$987d21925631f1e0) : (0, $cfabb2a9f68e2f34$export$69c3a1c4f451af4e);
    }
    if (nodeName === 'blockCard') {
        if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
            if (isInserted) return isTraditional ? isActive ? (0, $ea8348750032d332$export$cf5a738872f070ca) : (0, $ea8348750032d332$export$b5d15ab6b9f40699) : (0, $cfabb2a9f68e2f34$export$7643378707ce1e7);
            else return isTraditional ? (0, $ea8348750032d332$export$f37b168a762b249f)(false) : (0, $cfabb2a9f68e2f34$export$da356444d868ff8e);
        }
        return isTraditional ? isActive ? (0, $ea8348750032d332$export$cf5a738872f070ca) : (0, $ea8348750032d332$export$b5d15ab6b9f40699) : (0, $cfabb2a9f68e2f34$export$7643378707ce1e7);
    }
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (isInserted) return isTraditional ? isActive ? (0, $ea8348750032d332$export$a60bf2c814acef8e) : (0, $ea8348750032d332$export$2e643fe7923d8094) : (0, $cfabb2a9f68e2f34$export$6ba987e1eae93022);
        else return isTraditional ? (0, $ea8348750032d332$export$f37b168a762b249f)(false) : (0, $cfabb2a9f68e2f34$export$da356444d868ff8e);
    }
    return isTraditional ? isActive ? (0, $ea8348750032d332$export$a60bf2c814acef8e) : (0, $ea8348750032d332$export$2e643fe7923d8094) : (0, $cfabb2a9f68e2f34$export$6ba987e1eae93022);
};
const $3924418ec490911a$export$8df64513a6dc1f2a = ({ change: change, colorScheme: colorScheme, isInserted: isInserted = true, isActive: isActive = false, shouldHideDeleted: shouldHideDeleted = false })=>{
    const decorations = [];
    if (shouldHideDeleted) return [
        (0, $ftzrq.Decoration).node(change.from, change.to, {
            style: $3924418ec490911a$var$displayNoneStyle
        }, {
            key: (0, $d389c671c2e69790$export$e95973fb6fa1595f)({
                type: (0, $d389c671c2e69790$export$821fbb25e40fbb48).block
            }),
            nodeName: change.name
        })
    ];
    let style;
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && [
        'tableCell',
        'tableHeader'
    ].includes(change.name)) {
        const cellOverlay = document.createElement('div');
        const cellOverlayStyle = isInserted ? colorScheme === 'traditional' ? (0, $ea8348750032d332$export$d2957495f69575c) : (0, $cfabb2a9f68e2f34$export$d311b2309a26b4fb) : colorScheme === 'traditional' ? (0, $ea8348750032d332$export$ea323b9930a7947d) : (0, $cfabb2a9f68e2f34$export$7000268b4d4c5e1);
        cellOverlay.setAttribute('style', cellOverlayStyle);
        decorations.push(// change.to - 1 to position the overlay inside the end of the cell
        (0, $ftzrq.Decoration).widget(change.to - 1, cellOverlay, {
            key: (0, $d389c671c2e69790$export$e95973fb6fa1595f)({
                type: (0, $d389c671c2e69790$export$821fbb25e40fbb48).widget,
                isActive: isActive
            })
        }));
    }
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) style = $3924418ec490911a$var$getBlockNodeStyle({
        nodeName: change.name,
        colorScheme: colorScheme,
        isInserted: isInserted,
        isActive: isActive
    });
    else style = $3924418ec490911a$var$getBlockNodeStyle({
        nodeName: change.name,
        colorScheme: colorScheme,
        isActive: isActive
    });
    const className = $3924418ec490911a$var$getNodeClass(change.name);
    if (style || className) decorations.push((0, $ftzrq.Decoration).node(change.from, change.to, {
        style: style,
        'data-testid': 'show-diff-changed-decoration-node',
        class: className
    }, {
        key: (0, $d389c671c2e69790$export$e95973fb6fa1595f)({
            type: (0, $d389c671c2e69790$export$821fbb25e40fbb48).block
        }),
        nodeName: change.name
    }));
    return decorations;
};














const $e42005dbde5fc4ab$var$displayNoneStyle = (0, $24P9d.convertToInlineCss)({
    display: 'none'
});
const $e42005dbde5fc4ab$export$69543ba6b110e31c = ({ change: change, colorScheme: colorScheme, isActive: isActive = false, isInserted: isInserted = true, shouldHideDeleted: shouldHideDeleted = false })=>{
    if (shouldHideDeleted) return (0, $ftzrq.Decoration).inline(change.fromB, change.toB, {
        style: $e42005dbde5fc4ab$var$displayNoneStyle
    }, {
        key: (0, $d389c671c2e69790$export$e95973fb6fa1595f)({
            type: (0, $d389c671c2e69790$export$821fbb25e40fbb48).inline
        })
    });
    let style;
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (isInserted) {
            if (colorScheme === 'traditional') style = isActive ? (0, $ea8348750032d332$export$a9b71bdebdda9dc4) : (0, $ea8348750032d332$export$5f26b1217ef25d6b);
            else style = isActive ? (0, $cfabb2a9f68e2f34$export$6edd58aab948260b) : (0, $cfabb2a9f68e2f34$export$6cbccbf53a6b2a8);
        } else if (colorScheme === 'traditional') style = (0, $ea8348750032d332$export$f37b168a762b249f)(false);
        else {
            style = isActive ? (0, $cfabb2a9f68e2f34$export$1c9944aa8f37265b) : (0, $cfabb2a9f68e2f34$export$f65e7b80cdbdaf11);
            /**
				 * Merge into existing styles when cleaning up
				 */ if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) style += (0, $cfabb2a9f68e2f34$export$19cf8e2cf40a1110);
        }
    } else if (colorScheme === 'traditional') style = isActive ? (0, $ea8348750032d332$export$a9b71bdebdda9dc4) : (0, $ea8348750032d332$export$5f26b1217ef25d6b);
    else style = isActive ? (0, $cfabb2a9f68e2f34$export$97e4289fb0e21ca7) : (0, $cfabb2a9f68e2f34$export$8382eabaf43593de);
    return (0, $ftzrq.Decoration).inline(change.fromB, change.toB, {
        style: style,
        'data-testid': 'show-diff-changed-decoration'
    }, {
        key: (0, $d389c671c2e69790$export$e95973fb6fa1595f)({
            type: (0, $d389c671c2e69790$export$821fbb25e40fbb48).inline
        })
    });
};

















var $8m4tT = parcelRequire("8m4tT");





var $LmqWp = parcelRequire("LmqWp");









function $d8e013344d09c8ac$export$c531c54bff461ffa(doc, pos, slice) {
    if (pos > doc.content.size) return doc.content.size;
    let $pos = doc.resolve(pos);
    while(!(0, $8m4tT.canInsert)($pos, slice.content) && slice.content.firstChild?.type.name !== 'paragraph'){
        if ($pos.pos + 1 > doc.content.size) break;
        $pos = doc.resolve($pos.pos + 1);
    }
    return $pos.pos;
}


/**
 * Extracts information about deleted table rows from a change
 */ const $6f81e63a7d5996d4$var$extractChangedRows = ({ change: change, originalDoc: originalDoc, newDoc: newDoc })=>{
    const changedRows = [];
    // Find the table in the original document
    const $fromPos = originalDoc.resolve(change.fromA);
    const tableOld = (0, $8m4tT.findParentNodeClosestToPos)($fromPos, (node)=>node.type.name === 'table');
    if (!tableOld) return changedRows;
    const oldTableMap = (0, $LmqWp.TableMap).get(tableOld.node);
    // Find the table in the new document at the insertion point
    const $newPos = newDoc.resolve(change.fromB);
    const tableNew = (0, $8m4tT.findParentNodeClosestToPos)($newPos, (node)=>node.type.name === 'table');
    if (!tableNew) return changedRows;
    const newTableMap = (0, $LmqWp.TableMap).get(tableNew.node);
    // If no rows were changed, return empty
    if (oldTableMap.height <= newTableMap.height || // For now ignore if there are column deletions as well
    oldTableMap.width !== newTableMap.width) return changedRows;
    // Find which rows were changed by analyzing the change range
    const changeStartInTable = change.fromA - tableOld.pos - 1;
    const changeEndInTable = change.toA - tableOld.pos - 1;
    let currentOffset = 0;
    let rowIndex = 0;
    tableOld.node.content.forEach((rowNode)=>{
        const rowStart = currentOffset;
        const rowEnd = currentOffset + rowNode.nodeSize;
        // Check if this row overlaps with the deletion range
        const rowOverlapsChange = rowStart >= changeStartInTable && rowStart < changeEndInTable || rowEnd > changeStartInTable && rowEnd <= changeEndInTable || rowStart < changeStartInTable && rowEnd > changeEndInTable;
        if (rowOverlapsChange && rowNode.type.name === 'tableRow' && ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) || !$6f81e63a7d5996d4$var$isEmptyRow(rowNode))) {
            const startOfRow = newTableMap.mapByRow.slice().reverse().find((row)=>row[0] + tableNew.pos < change.fromB && change.fromB < row[row.length - 1] + tableNew.pos);
            changedRows.push({
                rowIndex: rowIndex,
                rowNode: rowNode,
                fromA: tableOld.pos + 1 + rowStart,
                toA: tableOld.pos + 1 + rowEnd,
                fromB: startOfRow ? startOfRow[0] + tableNew.start : change.fromB
            });
        }
        currentOffset += rowNode.nodeSize;
        if (rowNode.type.name === 'tableRow') rowIndex++;
    });
    // Filter changes that never truly got deleted
    return changedRows.filter((changedRow)=>{
        return !tableNew.node.children.some((newRow)=>(0, $2pjJ5.areNodesEqualIgnoreAttrs)(newRow, changedRow.rowNode));
    });
};
/**
 * Checks if a table row is empty (contains no meaningful content)
 */ const $6f81e63a7d5996d4$var$isEmptyRow = (rowNode)=>{
    let isEmpty = true;
    rowNode.descendants((node)=>{
        if (!isEmpty) return false;
        // If we find any inline content with size > 0, the row is not empty
        if (node.isInline && node.nodeSize > 0) {
            isEmpty = false;
            return false;
        }
        // If we find text content, the row is not empty
        if (node.isText && node.text && node.text.trim() !== '') {
            isEmpty = false;
            return false;
        }
        return true;
    });
    return isEmpty;
};
/**
 * Creates a DOM representation of a deleted table row
 */ const $6f81e63a7d5996d4$var$createChangedRowDOM = (rowNode, nodeViewSerializer, colorScheme, isInserted)=>{
    const tr = document.createElement('tr');
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (!isInserted) tr.setAttribute('style', colorScheme === 'traditional' ? (0, $ea8348750032d332$export$62207903895cae1) : (0, $cfabb2a9f68e2f34$export$ba3acd64357126ab));
    } else tr.setAttribute('style', colorScheme === 'traditional' ? (0, $ea8348750032d332$export$62207903895cae1) : (0, $cfabb2a9f68e2f34$export$ba3acd64357126ab));
    tr.setAttribute('data-testid', 'show-diff-deleted-row');
    // Serialize each cell in the row
    rowNode.content.forEach((cellNode)=>{
        if (cellNode.type.name === 'tableCell' || cellNode.type.name === 'tableHeader') {
            const nodeView = nodeViewSerializer.tryCreateNodeView(cellNode);
            if (nodeView) {
                if (nodeView instanceof HTMLElement && (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
                    const overlay = document.createElement('span');
                    const overlayStyle = colorScheme === 'traditional' ? isInserted ? (0, $ea8348750032d332$export$d2957495f69575c) : (0, $ea8348750032d332$export$ea323b9930a7947d) : isInserted ? (0, $cfabb2a9f68e2f34$export$d311b2309a26b4fb) : (0, $cfabb2a9f68e2f34$export$7000268b4d4c5e1);
                    overlay.setAttribute('style', overlayStyle);
                    nodeView.appendChild(overlay);
                }
                tr.appendChild(nodeView);
            } else {
                // Fallback to fragment serialization
                const serializedContent = nodeViewSerializer.serializeFragment(cellNode.content);
                if (serializedContent) tr.appendChild(serializedContent);
            }
        }
    });
    return tr;
};
/**
 * Expands a diff to include whole changed rows when table rows are affected
 */ const $6f81e63a7d5996d4$var$expandDiffForChangedRows = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc })=>{
    const rowInfo = [];
    for (const change of changes){
        // Check if this change affects table content
        const changedRows = $6f81e63a7d5996d4$var$extractChangedRows({
            change: change,
            originalDoc: originalDoc,
            newDoc: newDoc
        });
        if (changedRows.length > 0) rowInfo.push(...changedRows);
    }
    return rowInfo;
};
const $6f81e63a7d5996d4$export$f3a7e2ee274f388a = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, isInserted: isInserted = false })=>{
    // First, expand the changes to include complete deleted rows
    const changedRows = $6f81e63a7d5996d4$var$expandDiffForChangedRows({
        changes: changes.filter((change)=>change.deleted.length > 0),
        originalDoc: originalDoc,
        newDoc: newDoc
    });
    return changedRows.map((changedRow)=>{
        const rowDOM = $6f81e63a7d5996d4$var$createChangedRowDOM(changedRow.rowNode, nodeViewSerializer, colorScheme, isInserted);
        // Find safe insertion position for the deleted row
        const safeInsertPos = (0, $d8e013344d09c8ac$export$c531c54bff461ffa)(newDoc, changedRow.fromB - 1, originalDoc.slice(changedRow.fromA, changedRow.toA));
        return (0, $ftzrq.Decoration).widget(safeInsertPos, rowDOM, {});
    });
};








var $808tb = parcelRequire("808tb");


var $cX9xt = parcelRequire("cX9xt");






const $c6d7b21351b8a6a2$var$lozengeStyle = (0, $24P9d.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    font: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $c6d7b21351b8a6a2$var$lozengeStyleActiveStandard = (0, $24P9d.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    font: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $c6d7b21351b8a6a2$var$lozengeStyleActiveTraditional = (0, $24P9d.convertToInlineCss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    position: 'static',
    blockSize: 'min-content',
    borderRadius: "var(--ds-radius-small, 4px)",
    overflow: 'hidden',
    paddingInlineStart: "var(--ds-space-050, 4px)",
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    font: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-bold, 653)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: "var(--ds-text-warning-inverse, #292A2E)"
});
const $c6d7b21351b8a6a2$var$getChangedContentStyle = (colorScheme, isActive = false, isInserted = false)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && isInserted) {
        if (colorScheme === 'traditional') return isActive ? (0, $ea8348750032d332$export$a9b71bdebdda9dc4) : (0, $ea8348750032d332$export$5f26b1217ef25d6b);
        return isActive ? (0, $cfabb2a9f68e2f34$export$6edd58aab948260b) : (0, $cfabb2a9f68e2f34$export$6cbccbf53a6b2a8);
    }
    if (colorScheme === 'traditional') return (0, $ea8348750032d332$export$f37b168a762b249f)(isActive);
    if (isActive) return 0, $cfabb2a9f68e2f34$export$1c9944aa8f37265b;
    return (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? (0, $cfabb2a9f68e2f34$export$da356444d868ff8e) : (0, $cfabb2a9f68e2f34$export$f65e7b80cdbdaf11);
};
const $c6d7b21351b8a6a2$var$getChangedNodeStyle = (nodeName, colorScheme, isInserted = false, isActive = false)=>{
    const isTraditional = colorScheme === 'traditional';
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && isInserted) {
        if ($c6d7b21351b8a6a2$var$isMultiContainerBlockNode(nodeName)) return 0, $cfabb2a9f68e2f34$export$21401c524509064e;
        if ($c6d7b21351b8a6a2$var$isTextLikeBlockNode(nodeName)) return undefined;
        if (isTraditional) return isActive ? (0, $ea8348750032d332$export$a60bf2c814acef8e) : (0, $ea8348750032d332$export$2e643fe7923d8094);
        return 0, $cfabb2a9f68e2f34$export$6ba987e1eae93022;
    }
    switch(nodeName){
        case 'blockquote':
            if (isTraditional) return isActive ? (0, $ea8348750032d332$export$cd5411bbe62ac5f5) : (0, $ea8348750032d332$export$781ad9e3e3929b91);
            return isActive ? (0, $cfabb2a9f68e2f34$export$b1c2428901df334f) : (0, $cfabb2a9f68e2f34$export$a26de8170ba89016);
        case 'expand':
        case 'decisionList':
            if (isTraditional) return isActive ? (0, $ea8348750032d332$export$bb158c719faea3c7) : (0, $ea8348750032d332$export$94cf9011b730dea);
            return isActive ? (0, $cfabb2a9f68e2f34$export$f2cea9f09f40fb64) : (0, $cfabb2a9f68e2f34$export$2b892754935ecdf0);
        case 'panel':
        case 'codeBlock':
            if (isTraditional) return isActive ? (0, $ea8348750032d332$export$9c9f71734a3c1e70) : (0, $ea8348750032d332$export$bd7e21e639c80e8d);
            return isActive ? (0, $cfabb2a9f68e2f34$export$1e0b247f41c702d9) : (0, $cfabb2a9f68e2f34$export$95d973a7458c1194);
        default:
            return undefined;
    }
};
const $c6d7b21351b8a6a2$var$shouldShowRemovedLozenge = (nodeName)=>{
    switch(nodeName){
        case 'expand':
        case 'codeBlock':
        case 'mediaSingle':
        case 'panel':
        case 'decisionList':
        case 'embedCard':
        case 'blockquote':
            return true;
        default:
            return false;
    }
};
const $c6d7b21351b8a6a2$var$shouldAddShowDiffDeletedNodeClass = (nodeName)=>{
    switch(nodeName){
        case 'mediaSingle':
        case 'embedCard':
        case 'blockquote':
            return true;
        default:
            return false;
    }
}; /** Scroll-nav “new” ring (4px red subtlest) for media/embed; styled in editor-core smartCardStyles. */ 
const $c6d7b21351b8a6a2$var$maybeAddDeletedOutlineNewClass = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive = false })=>{
    const name = targetNode.type.name;
    if (name !== 'mediaSingle' && name !== 'embedCard') return;
    if (colorScheme === 'traditional' && !isActive) nodeView.classList.add('show-diff-deleted-outline-new');
}; /**
    * Checks if a node should apply deleted styles directly without wrapper
    * to preserve natural block-level margins
    */ 
const $c6d7b21351b8a6a2$var$shouldApplyStylesDirectly = (nodeName)=>{
    return nodeName === 'heading';
};
const $c6d7b21351b8a6a2$var$isMultiContainerBlockNode = (nodeName)=>{
    return [
        'decisionList',
        'layoutSection'
    ].includes(nodeName);
};
const $c6d7b21351b8a6a2$var$isTextLikeBlockNode = (nodeName)=>{
    return [
        'heading',
        'bulletList',
        'orderedList',
        'listItem',
        'taskList',
        'blockquote'
    ].includes(nodeName);
};
const $c6d7b21351b8a6a2$var$applyCellOverlayStyles = ({ element: element, colorScheme: colorScheme, isInserted: isInserted })=>{
    element.querySelectorAll('td, th').forEach((cell)=>{
        const overlay = document.createElement('span');
        const overlayStyle = colorScheme === 'traditional' ? isInserted ? (0, $ea8348750032d332$export$4447a7c482f80938) : (0, $ea8348750032d332$export$ea323b9930a7947d) : isInserted ? (0, $cfabb2a9f68e2f34$export$d311b2309a26b4fb) : (0, $cfabb2a9f68e2f34$export$7000268b4d4c5e1);
        overlay.setAttribute('style', overlayStyle);
        cell.appendChild(overlay);
    });
}; /**
    * Creates a "Removed" lozenge to be displayed at the top right corner of deleted block nodes
    */ 
const $c6d7b21351b8a6a2$var$createRemovedLozenge = (intl, isActive = false, colorScheme)=>{
    const container = document.createElement('span');
    const containerStyle = (0, $24P9d.convertToInlineCss)({
        position: 'absolute',
        top: "var(--ds-space-075, 6px)",
        right: "var(--ds-space-075, 6px)",
        zIndex: 2,
        pointerEvents: 'none',
        display: 'flex'
    });
    container.setAttribute('style', containerStyle);
    container.setAttribute('data-testid', 'show-diff-removed-lozenge'); // Create vanilla HTML lozenge element with Atlaskit Lozenge styling (visual refresh)
    const lozengeElement = document.createElement('span');
    const lozengeInnerStyle = isActive && colorScheme === 'traditional' ? $c6d7b21351b8a6a2$var$lozengeStyleActiveTraditional : isActive ? $c6d7b21351b8a6a2$var$lozengeStyleActiveStandard : $c6d7b21351b8a6a2$var$lozengeStyle;
    lozengeElement.setAttribute('style', lozengeInnerStyle);
    lozengeElement.textContent = intl.formatMessage((0, $808tb.trackChangesMessages).removed).toUpperCase();
    container.appendChild(lozengeElement);
    return container;
}; /**
    * Wraps a block node in a container with relative positioning to support absolute positioned lozenge
    */ 
const $c6d7b21351b8a6a2$var$createBlockNodeWrapper = ()=>{
    const wrapper = document.createElement('div');
    const baseStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative',
        display: 'block',
        opacity: 1
    });
    wrapper.setAttribute('style', baseStyle);
    return wrapper;
}; /**
    * Applies styles directly to an HTML element by merging with existing styles
    */ 
const $c6d7b21351b8a6a2$var$applyStylesToElement = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted })=>{
    const currentStyle = element.getAttribute('style') || '';
    const contentStyle = $c6d7b21351b8a6a2$var$getChangedContentStyle(colorScheme, isActive, isInserted);
    const targetNodeName = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeSpecificStyle = $c6d7b21351b8a6a2$var$getChangedNodeStyle(targetNodeName, colorScheme, isInserted, isActive) || '';
    element.setAttribute('style', `${currentStyle}${contentStyle}${nodeSpecificStyle}`);
};
const $c6d7b21351b8a6a2$var$applyMultiContainerLikeStyles = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted })=>{
    const currentStyle = element.getAttribute('style') || '';
    const targetNodeName = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeSpecificStyle = $c6d7b21351b8a6a2$var$getChangedNodeStyle(targetNodeName, colorScheme, isInserted, isActive) || '';
    if (targetNode.type.name === 'decisionList') element.querySelectorAll('li').forEach((listItem)=>{
        const currentListItemStyle = listItem.getAttribute('style') || '';
        listItem.setAttribute('style', `${currentListItemStyle}${(0, $cfabb2a9f68e2f34$export$6ba987e1eae93022)}`);
    });
    else if (targetNode.type.name === 'layoutSection') element.querySelectorAll('[data-layout-column="true"]').forEach((section)=>{
        const currentSectionStyle = section.getAttribute('style') || '';
        section.setAttribute('style', `${currentSectionStyle}${(0, $cfabb2a9f68e2f34$export$6ba987e1eae93022)}`);
    });
    else if (targetNode.type.name === 'taskList') element.querySelectorAll('li').forEach((listItem)=>{
        const currentListItemStyle = listItem.getAttribute('style') || '';
        listItem.setAttribute('style', `${currentListItemStyle}${(0, $cfabb2a9f68e2f34$export$6ba987e1eae93022)}`);
    });
    element.setAttribute('style', `${currentStyle};${nodeSpecificStyle}`);
};
const $c6d7b21351b8a6a2$var$applyTextLikeBlockNodeStyles = ({ element: element, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted })=>{
    $c6d7b21351b8a6a2$var$getChangedNodeStyle(targetNode.type.name, colorScheme, isInserted, isActive);
    const contentStyle = $c6d7b21351b8a6a2$var$getChangedContentStyle(colorScheme, isActive, isInserted);
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodesToWrap = [];
    let currentNode = walker.nextNode();
    while(currentNode){
        if (currentNode instanceof Text && currentNode.textContent !== '' && currentNode.parentElement) textNodesToWrap.push(currentNode);
        currentNode = walker.nextNode();
    }
    textNodesToWrap.forEach((textNode)=>{
        const contentWrapper = document.createElement('span');
        contentWrapper.setAttribute('style', contentStyle);
        textNode.replaceWith(contentWrapper);
        contentWrapper.append(textNode);
    });
}; /**
    * Creates a content wrapper with deleted styles for a block node
    */ 
const $c6d7b21351b8a6a2$var$createBlockNodeContentWrapper = ({ nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted })=>{
    const contentWrapper = document.createElement('div');
    const targetNodeName = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    const nodeStyle = $c6d7b21351b8a6a2$var$getChangedNodeStyle(targetNodeName, colorScheme, isInserted, isActive); // When the extended experiment is enabled and the content is inserted,
    // block widget nodes that already have dedicated node-level styling (e.g. boxShadow outline)
    // should not also get the inline content style (borderBottom underline) on their container.
    const shouldSkipContentStyle = (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && isInserted && nodeStyle !== undefined;
    const contentStyle = shouldSkipContentStyle ? '' : $c6d7b21351b8a6a2$var$getChangedContentStyle(colorScheme, isActive, isInserted);
    contentWrapper.setAttribute('style', `${contentStyle}${nodeStyle || ''}`);
    contentWrapper.append(nodeView);
    return contentWrapper;
}; /**
    * Handles embedCard node rendering with lozenge attached to the rich-media-item container.
    * Since embedCard content loads asynchronously, we use a MutationObserver
    * to wait for the rich-media-item to appear before attaching the lozenge.
    * @returns true if embedCard was handled
    */ 
const $c6d7b21351b8a6a2$var$handleEmbedCardWithLozenge = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, lozenge: lozenge, colorScheme: colorScheme, isActive: isActive = false })=>{
    if (targetNode.type.name !== 'embedCard' || !(nodeView instanceof HTMLElement)) return false;
    const richMediaItem = nodeView.querySelector('.rich-media-item');
    if (richMediaItem instanceof HTMLElement) richMediaItem.appendChild(lozenge);
    else {
        const observer = new MutationObserver((_, obs)=>{
            const loadedRichMedia = nodeView.querySelector('.rich-media-item');
            if (loadedRichMedia instanceof HTMLElement) {
                loadedRichMedia.appendChild(lozenge);
                obs.disconnect();
            }
        });
        observer.observe(nodeView, {
            childList: true,
            subtree: true
        });
    }
    if ($c6d7b21351b8a6a2$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
        if (isActive) nodeView.classList.add('show-diff-deleted-active');
        $c6d7b21351b8a6a2$var$maybeAddDeletedOutlineNewClass({
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive
        });
    }
    dom.append(nodeView);
    return true;
}; /**
    * Handles special mediaSingle node rendering with lozenge on child media element
    * @returns true if mediaSingle was handled, false otherwise
    */ 
const $c6d7b21351b8a6a2$var$handleMediaSingleWithLozenge = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, lozenge: lozenge, colorScheme: colorScheme, isActive: isActive = false })=>{
    if (targetNode.type.name !== 'mediaSingle' || !(nodeView instanceof HTMLElement)) return false;
    const mediaNode = nodeView.querySelector('[data-prosemirror-node-name="media"]');
    if (!mediaNode || !(mediaNode instanceof HTMLElement)) return false;
     // Add relative positioning to media node to anchor lozenge
    const currentStyle = mediaNode.getAttribute('style') || '';
    const relativePositionStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative'
    });
    mediaNode.setAttribute('style', `${currentStyle}${relativePositionStyle}`);
    mediaNode.append(lozenge); // Add deleted node class if needed
    if ($c6d7b21351b8a6a2$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
        if (isActive) nodeView.classList.add('show-diff-deleted-active');
        $c6d7b21351b8a6a2$var$maybeAddDeletedOutlineNewClass({
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive
        });
    }
    dom.append(nodeView);
    return true;
}; /**
    * Appends a block node with wrapper, lozenge, and appropriate styling
    */ 
const $c6d7b21351b8a6a2$var$wrapBlockNode = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, intl: intl, isActive: isActive = false, isInserted: isInserted = false })=>{
    const blockWrapper = $c6d7b21351b8a6a2$var$createBlockNodeWrapper();
    const targetNodeName = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.getBaseNodeTypeName)(targetNode.type) : targetNode.type.name;
    if ($c6d7b21351b8a6a2$var$shouldShowRemovedLozenge(targetNodeName) && (!(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) || !isInserted)) {
        const lozenge = $c6d7b21351b8a6a2$var$createRemovedLozenge(intl, isActive, colorScheme);
        if ($c6d7b21351b8a6a2$var$handleEmbedCardWithLozenge({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            lozenge: lozenge,
            colorScheme: colorScheme,
            isActive: isActive
        })) return;
        if ($c6d7b21351b8a6a2$var$handleMediaSingleWithLozenge({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            lozenge: lozenge,
            colorScheme: colorScheme,
            isActive: isActive
        })) return;
        blockWrapper.append(lozenge);
    }
    const contentWrapper = $c6d7b21351b8a6a2$var$createBlockNodeContentWrapper({
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        isActive: isActive,
        isInserted: isInserted
    });
    blockWrapper.append(contentWrapper);
    if (nodeView instanceof HTMLElement && $c6d7b21351b8a6a2$var$shouldAddShowDiffDeletedNodeClass(targetNode.type.name)) {
        const showDiffDeletedNodeClass = colorScheme === 'traditional' ? 'show-diff-deleted-node-traditional' : 'show-diff-deleted-node';
        nodeView.classList.add(showDiffDeletedNodeClass);
        if (isActive) nodeView.classList.add('show-diff-deleted-active');
        $c6d7b21351b8a6a2$var$maybeAddDeletedOutlineNewClass({
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive
        });
    }
    dom.append(blockWrapper);
}; /**
    * Handles all block node rendering with appropriate deleted styling.
    * For heading nodes, applies styles directly to preserve natural margins.
    * For other block nodes, uses wrapper approach with optional lozenge.
    */ 
const $c6d7b21351b8a6a2$export$decea4d8614a74b3 = ({ dom: dom, nodeView: nodeView, targetNode: targetNode, colorScheme: colorScheme, intl: intl, isActive: isActive = false, isInserted: isInserted = false })=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (nodeView instanceof HTMLElement) {
            if (isInserted && $c6d7b21351b8a6a2$var$isMultiContainerBlockNode(targetNode.type.name)) {
                $c6d7b21351b8a6a2$var$applyMultiContainerLikeStyles({
                    element: nodeView,
                    targetNode: targetNode,
                    colorScheme: colorScheme,
                    isActive: isActive,
                    isInserted: isInserted
                });
                dom.append(nodeView);
                return;
            }
            if ($c6d7b21351b8a6a2$var$isTextLikeBlockNode(targetNode.type.name)) {
                $c6d7b21351b8a6a2$var$applyTextLikeBlockNodeStyles({
                    element: nodeView,
                    targetNode: targetNode,
                    colorScheme: colorScheme,
                    isActive: isActive,
                    isInserted: isInserted
                });
                dom.append(nodeView);
                return;
            }
            if (targetNode.type.name === 'table') {
                $c6d7b21351b8a6a2$var$applyCellOverlayStyles({
                    element: nodeView,
                    colorScheme: colorScheme,
                    isInserted: isInserted
                });
                dom.append(nodeView);
                return;
            }
        }
        $c6d7b21351b8a6a2$var$wrapBlockNode({
            dom: dom,
            nodeView: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            intl: intl,
            isActive: isActive,
            isInserted: isInserted
        });
        return;
    } else if ($c6d7b21351b8a6a2$var$shouldApplyStylesDirectly(targetNode.type.name) && nodeView instanceof HTMLElement) {
        // Apply deleted styles directly to preserve natural block-level margins
        $c6d7b21351b8a6a2$var$applyStylesToElement({
            element: nodeView,
            targetNode: targetNode,
            colorScheme: colorScheme,
            isActive: isActive,
            isInserted: isInserted
        });
        dom.append(nodeView);
    } else $c6d7b21351b8a6a2$var$wrapBlockNode({
        dom: dom,
        nodeView: nodeView,
        targetNode: targetNode,
        colorScheme: colorScheme,
        intl: intl,
        isActive: isActive,
        isInserted: isInserted
    });
};


const $3db5c6ad889f5540$var$getDeletedContentStyleUnbounded = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional' && isActive) return 0, $ea8348750032d332$export$e384205f8cc82cfe;
    return colorScheme === 'traditional' ? (0, $ea8348750032d332$export$d7c13cc5c70ee199) : (0, $cfabb2a9f68e2f34$export$f9aac5ed53f3d424);
};
const $3db5c6ad889f5540$var$getInsertedContentStyle = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional') {
        if (isActive) return 0, $ea8348750032d332$export$a9b71bdebdda9dc4;
        return 0, $ea8348750032d332$export$5f26b1217ef25d6b;
    }
    if (isActive) return (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? (0, $cfabb2a9f68e2f34$export$6edd58aab948260b) : (0, $cfabb2a9f68e2f34$export$97e4289fb0e21ca7);
    return (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? (0, $cfabb2a9f68e2f34$export$6cbccbf53a6b2a8) : (0, $cfabb2a9f68e2f34$export$8382eabaf43593de);
};
const $3db5c6ad889f5540$var$getDeletedContentStyle = (colorScheme, isActive = false)=>{
    if (colorScheme === 'traditional') return (0, $ea8348750032d332$export$f37b168a762b249f)(isActive);
    // Merge into existing styles when cleaning up
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (isActive) return (0, $cfabb2a9f68e2f34$export$1c9944aa8f37265b) + (0, $cfabb2a9f68e2f34$export$19cf8e2cf40a1110);
        return (0, $cfabb2a9f68e2f34$export$da356444d868ff8e) + (0, $cfabb2a9f68e2f34$export$19cf8e2cf40a1110);
    }
    if (isActive) return 0, $cfabb2a9f68e2f34$export$1c9944aa8f37265b;
    return (0, $1oCLl.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? (0, $cfabb2a9f68e2f34$export$da356444d868ff8e) : (0, $cfabb2a9f68e2f34$export$f65e7b80cdbdaf11);
};
/**
 * CSS backgrounds don't work when applied to a wrapper around a paragraph, so
 * the wrapper needs to be injected inside the node around the child content
 */ const $3db5c6ad889f5540$var$injectInnerWrapper = ({ node: node, colorScheme: colorScheme, isActive: isActive, isInserted: isInserted })=>{
    const wrapper = document.createElement('span');
    wrapper.setAttribute('style', isInserted ? $3db5c6ad889f5540$var$getInsertedContentStyle(colorScheme, isActive) : $3db5c6ad889f5540$var$getDeletedContentStyle(colorScheme, isActive));
    [
        ...node.childNodes
    ].forEach((child)=>{
        const removedChild = node.removeChild(child);
        wrapper.append(removedChild);
    });
    node.appendChild(wrapper);
    return node;
};
const $3db5c6ad889f5540$var$createContentWrapper = (colorScheme, isActive = false, isInserted = false)=>{
    const wrapper = document.createElement('span');
    const baseStyle = (0, $24P9d.convertToInlineCss)({
        position: 'relative',
        width: 'fit-content'
    });
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (isInserted) wrapper.setAttribute('style', `${baseStyle}${$3db5c6ad889f5540$var$getInsertedContentStyle(colorScheme, isActive)}`);
        else {
            wrapper.setAttribute('style', `${baseStyle}${$3db5c6ad889f5540$var$getDeletedContentStyle(colorScheme, isActive)}`);
            const strikethrough = document.createElement('span');
            strikethrough.setAttribute('style', $3db5c6ad889f5540$var$getDeletedContentStyleUnbounded(colorScheme, isActive));
            wrapper.append(strikethrough);
        }
    } else {
        wrapper.setAttribute('style', `${baseStyle}${$3db5c6ad889f5540$var$getDeletedContentStyle(colorScheme, isActive)}`);
        const strikethrough = document.createElement('span');
        strikethrough.setAttribute('style', $3db5c6ad889f5540$var$getDeletedContentStyleUnbounded(colorScheme, isActive));
        wrapper.append(strikethrough);
    }
    return wrapper;
};
const $3db5c6ad889f5540$export$33298e826c81587e = ({ change: change, doc: doc, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, newDoc: newDoc, intl: intl, activeIndexPos: activeIndexPos, isInserted: // This is false by default as this is generally used to show deleted content
isInserted = false })=>{
    const slice = doc.slice(change.fromA, change.toA);
    const shouldSkipDeletedEmptyParagraphDecoration = !isInserted && slice?.content?.childCount === 1 && slice?.content?.firstChild?.type.name === 'paragraph' && slice?.content?.firstChild?.content.size === 0;
    // Widget decoration used for deletions as the content is not in the document
    // and we want to display the deleted content with a style.
    const safeInsertPos = (0, $d8e013344d09c8ac$export$c531c54bff461ffa)(newDoc, change.fromB, slice);
    const isActive = activeIndexPos && safeInsertPos === activeIndexPos.from && safeInsertPos === activeIndexPos.to;
    if (slice.content.content.length === 0 || shouldSkipDeletedEmptyParagraphDecoration) return;
    const isTableCellContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableHeader',
                'tableCell'
            ].includes(siblingNode.type.name)));
    const isTableRowContent = slice.content.content.some(()=>slice.content.content.some((siblingNode)=>[
                'tableRow'
            ].includes(siblingNode.type.name)));
    if (isTableCellContent) return;
    if (isTableRowContent) return (0, $6f81e63a7d5996d4$export$f3a7e2ee274f388a)({
        changes: [
            change
        ],
        originalDoc: doc,
        newDoc: newDoc,
        nodeViewSerializer: nodeViewSerializer,
        colorScheme: colorScheme,
        isInserted: isInserted
    });
    const serializer = nodeViewSerializer;
    // For non-table content, use the existing span wrapper approach
    const dom = document.createElement('span');
    /*
   * The thinking is we separate out the fragment we got from doc.slice
   * and if it's the first or last content, we go in however many the sliced Open
   * or sliced End depth is and match only the entire node.
   */ slice.content.forEach((node)=>{
        // Helper function to handle multiple child nodes
        const handleMultipleChildNodes = (node)=>{
            if (node.content.childCount > 1 && node.type.inlineContent) {
                node.content.forEach((childNode)=>{
                    const childNodeView = serializer.tryCreateNodeView(childNode);
                    if (childNodeView) {
                        const lineBreak = document.createElement('br');
                        dom.append(lineBreak);
                        const wrapper = $3db5c6ad889f5540$var$createContentWrapper(colorScheme, isActive, isInserted);
                        wrapper.append(childNodeView);
                        dom.append(wrapper);
                    } else {
                        // Fallback to serializing the individual child node
                        const serializedChild = serializer.serializeNode(childNode);
                        if (serializedChild) {
                            const wrapper = $3db5c6ad889f5540$var$createContentWrapper(colorScheme, isActive, isInserted);
                            wrapper.append(serializedChild);
                            dom.append(wrapper);
                        }
                    }
                });
                return true; // Indicates we handled multiple children
            }
            return false; // Indicates single child, continue with normal logic
        };
        // Determine which node to use and how to serialize
        const isFirst = slice.content.firstChild === node;
        const isLast = slice.content.lastChild === node;
        const hasInlineContent = node.content.childCount > 0 && node.type.inlineContent === true;
        let fallbackSerialization;
        if (handleMultipleChildNodes(node)) return;
        if ((isFirst || isLast && slice.content.childCount > 2) && hasInlineContent) fallbackSerialization = ()=>serializer.serializeFragment(node.content);
        else if (isLast && slice.content.childCount === 2) fallbackSerialization = ()=>{
            if (node.type.name === 'text') return document.createTextNode(node.text || '');
            if (node.type.name === 'paragraph') {
                const lineBreak = document.createElement('br');
                dom.append(lineBreak);
                return serializer.serializeFragment(node.content);
            }
            return serializer.serializeFragment(node.content);
        };
        else fallbackSerialization = ()=>serializer.serializeNode(node);
        // Try to create node view, fallback to serialization
        const nodeView = serializer.tryCreateNodeView(node);
        if (nodeView) {
            if (node.isInline) {
                const wrapper = $3db5c6ad889f5540$var$createContentWrapper(colorScheme, isActive, isInserted);
                wrapper.append(nodeView);
                dom.append(wrapper);
            } else // Handle all block nodes with unified function
            (0, $c6d7b21351b8a6a2$export$decea4d8614a74b3)({
                dom: dom,
                nodeView: nodeView,
                targetNode: node,
                colorScheme: colorScheme,
                intl: intl,
                isActive: isActive,
                isInserted: isInserted
            });
        } else if (nodeViewSerializer.getFilteredNodeViewBlocklist([
            'paragraph',
            'tableRow'
        ]).has(node.type.name)) // Skip the case where the node is a paragraph or table row that way it can still be rendered and delete the entire table
        return;
        else {
            const fallbackNode = fallbackSerialization();
            if (fallbackNode) {
                if (fallbackNode instanceof HTMLElement) {
                    const injectedNode = $3db5c6ad889f5540$var$injectInnerWrapper({
                        node: fallbackNode,
                        colorScheme: colorScheme,
                        isActive: isActive,
                        isInserted: isInserted
                    });
                    dom.append(injectedNode);
                } else {
                    const wrapper = $3db5c6ad889f5540$var$createContentWrapper(colorScheme, isActive, isInserted);
                    wrapper.append(fallbackNode);
                    dom.append(wrapper);
                }
            }
        }
    });
    dom.setAttribute('data-testid', 'show-diff-deleted-decoration');
    const decorations = [];
    decorations.push((0, $ftzrq.Decoration).widget(safeInsertPos, dom, {
        key: (0, $d389c671c2e69790$export$e95973fb6fa1595f)({
            type: (0, $d389c671c2e69790$export$821fbb25e40fbb48).widget,
            isActive: isActive
        }),
        ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && {
            side: -1
        }
    }));
    return decorations;
};



var $9YoeD = parcelRequire("9YoeD");




const $0f6682ae00a27f19$var$filterUndefined = (x)=>!!x;
// Attributes that indicate a change in media image
const $0f6682ae00a27f19$var$mediaAttrs = [
    'id',
    'collection',
    'url'
];
// Attribute that indicates a date change
const $0f6682ae00a27f19$var$dateAttrs = [
    'timestamp'
];
// Attribute that indicates a task item state change
const $0f6682ae00a27f19$var$taskItemAttrs = [
    'state'
];
// Attributes excluded from extension change detection (not meaningful content changes)
const $0f6682ae00a27f19$var$extensionExcludedAttrs = [
    'localId'
];
// Extension node type names
const $0f6682ae00a27f19$var$extensionNodeNames = [
    'extension',
    'inlineExtension',
    'bodiedExtension'
];
const $0f6682ae00a27f19$var$getStepAttrs = (step)=>{
    if (step instanceof (0, $aXG5V.AttrStep)) return [
        step.attr
    ];
    if (step instanceof (0, $9YoeD.SetAttrsStep) && step.attrs) return Object.keys(step.attrs);
    return [];
};
const $0f6682ae00a27f19$export$34445edbbb29aecb = (doc, steps)=>{
    return steps.map((step)=>{
        if (!(step instanceof (0, $aXG5V.AttrStep)) && !(step instanceof (0, $9YoeD.SetAttrsStep))) return undefined;
        const stepAttrs = $0f6682ae00a27f19$var$getStepAttrs(step);
        const $pos = doc.resolve(step.pos);
        const nodeAtPos = doc.nodeAt(step.pos);
        // date node: timestamp attribute change — highlight the date node itself (inline)
        if (stepAttrs.some((v)=>$0f6682ae00a27f19$var$dateAttrs.includes(v)) && nodeAtPos?.type.name === 'date') return {
            fromB: step.pos,
            toB: step.pos + nodeAtPos.nodeSize,
            isInline: true
        };
        // taskItem node: state attribute change — highlight the taskItem node
        if (stepAttrs.some((v)=>$0f6682ae00a27f19$var$taskItemAttrs.includes(v)) && nodeAtPos?.type.name === 'taskItem') return {
            fromB: step.pos,
            toB: step.pos + nodeAtPos.nodeSize
        };
        // extension nodes: any attribute change except localId — highlight the node
        if (nodeAtPos && $0f6682ae00a27f19$var$extensionNodeNames.includes(nodeAtPos.type.name) && stepAttrs.some((v)=>!$0f6682ae00a27f19$var$extensionExcludedAttrs.includes(v))) {
            const isInline = nodeAtPos.type.name === 'inlineExtension';
            return {
                fromB: step.pos,
                toB: step.pos + nodeAtPos.nodeSize,
                isInline: isInline
            };
        }
        // media node: id/collection/url attribute change — highlight the mediaSingle parent
        if (stepAttrs.some((v)=>$0f6682ae00a27f19$var$mediaAttrs.includes(v)) && $pos.parent.type === doc.type.schema.nodes.mediaSingle) {
            const startPos = $pos.pos + $pos.parentOffset;
            return {
                fromB: startPos,
                toB: startPos + $pos.parent.nodeSize - 1
            };
        }
        return undefined;
    }).filter($0f6682ae00a27f19$var$filterUndefined);
};
const $0f6682ae00a27f19$export$78b37f7430a7646c = (step, beforeDoc, afterDoc)=>{
    try {
        if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $9YoeD.SetAttrsStep)) {
            const attrStepAfter = afterDoc.nodeAt(step.pos);
            const attrStepBefore = beforeDoc.nodeAt(step.pos);
            // The change affected the document
            if (attrStepAfter && attrStepBefore && !attrStepAfter.eq(attrStepBefore)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};





const $8887a45e8ceab209$var$extractMarkStep = (step)=>{
    if (step instanceof (0, $aXG5V.AddMarkStep)) return {
        type: 'add',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    if (step instanceof (0, $aXG5V.RemoveMarkStep)) return {
        type: 'remove',
        from: step.from,
        to: step.to,
        markName: step.mark.type.name
    };
    return undefined;
};
const $8887a45e8ceab209$export$cb37e032b0f65b99 = (steps)=>{
    const resultRanges = [];
    let lastOp;
    for (const step of steps){
        const op = $8887a45e8ceab209$var$extractMarkStep(step);
        if (!op) continue;
        // Check if previous operation cancels this one
        if (lastOp && lastOp.from === op.from && lastOp.to === op.to && lastOp.markName === op.markName && lastOp.type !== op.type) resultRanges.pop();
        else resultRanges.push({
            fromB: op.from,
            toB: op.to
        });
        lastOp = op;
    }
    return resultRanges;
};






var $5SAOw = parcelRequire("5SAOw");




function $0b53856bf7843575$export$e2f3b3d89f27d105(changes) {
    if (changes.length <= 1) return changes;
    const optimized = [];
    let current = {
        ...changes[0]
    };
    for(let i = 1; i < changes.length; i++){
        const next = changes[i];
        // Check if changes are adjacent or very close (within 2 positions)
        const isAdjacent = next.fromB <= current.toB + 2;
        if (isAdjacent) current = {
            fromA: current.fromA,
            toA: Math.max(current.toA, next.toA),
            fromB: current.fromB,
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            optimized.push(current);
            current = {
                ...next
            };
        }
    }
    optimized.push(current);
    return optimized;
}


const $c7ca31c0aa9ecf40$var$mapPosition = (mapping, pos)=>mapping.map(pos);
/**
 * Build a per-content-offset view of the textblock's characters.
 *
 * Returns an array `chars` whose length is `parent.content.size`. For every
 * offset that lies inside a text node, `chars[offset]` is the character at
 * that offset; for every offset that lies inside (or on the edge of) a
 * non-text inline node — hardBreak, mention, emoji, date, etc. — the entry
 * is `null`.
 *
 * Using doc positions to index `parent.textContent` is wrong because
 * `textContent` strips non-text inline nodes, so every such node shifts the
 * lookup off by its size. This per-offset view restores a 1:1 mapping between
 * doc positions inside the textblock and the character (or "no character",
 * i.e. a hard word boundary) at that position.
 */ const $c7ca31c0aa9ecf40$var$buildCharsByOffset = (parent)=>{
    const chars = new Array(parent.content.size).fill(null);
    parent.content.forEach((child, offset)=>{
        if (!child.isText) return;
        const text = child.text ?? '';
        for(let i = 0; i < text.length; i++)chars[offset + i] = text[i];
    });
    return chars;
};
/**
 * Given a ProseMirror doc and a position range [from, to], expand
 * both endpoints outward to the nearest word boundaries.
 *
 * A "word character" is any Unicode letter/number or underscore. Punctuation is
 * treated as part of the same token only when it is sandwiched between two
 * non-whitespace characters, so contractions like "You'll", accented words like
 * "l'été", and punctuation-joined tokens like "deep-sea" or "foo/bar" stay
 * intact without treating standalone punctuation as a general word character.
 * Expansion stops at whitespace, standalone punctuation, the boundary of any
 * non-text inline node (hardBreak, mention, emoji, date, etc.), or the
 * textblock edges.
 *
 * If `from` and `to` resolve into different parent nodes, or if the
 * parent is not a textblock, the range is returned unchanged.
 */ const $c7ca31c0aa9ecf40$var$expandToWordBoundaries = (doc, from, to)=>{
    const $from = doc.resolve(from);
    // Only expand inside a textblock.
    if (!$from.parent.isTextblock) return {
        from: from,
        to: to
    };
    // When `from !== to`, verify both ends are in the same textblock.
    if (from !== to) {
        const $to = doc.resolve(to);
        if ($from.parent !== $to.parent) return {
            from: from,
            to: to
        };
    }
    const parent = $from.parent;
    const parentStart = $from.start(); // absolute position of the first character in the textblock
    // Per-offset view of the textblock so we don't conflate the inline
    // positions of non-text nodes (hardBreak, mention, emoji, date, etc.)
    // with the characters returned by `parent.textContent`.
    const chars = $c7ca31c0aa9ecf40$var$buildCharsByOffset(parent);
    // Convert absolute doc positions to zero-based content offsets.
    let fromIdx = from - parentStart;
    let toIdx = to - parentStart;
    // Base word chars are Unicode letters/numbers/underscore. Punctuation only
    // counts when it is surrounded by non-whitespace characters, e.g. in
    // "You'll", "deep-sea", or "foo/bar". `null` still behaves like a hard
    // boundary because only string neighbors qualify.
    const isWordCharAt = (idx)=>{
        if (idx < 0 || idx >= chars.length) return false;
        const ch = chars[idx];
        if (typeof ch !== 'string') return false;
        const prev = chars[idx - 1];
        const next = chars[idx + 1];
        return(// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        RegExp("[\\p{L}\\p{N}_]", "u").test(ch) || // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        RegExp("\\p{P}", "u").test(ch) && typeof prev === 'string' && typeof next === 'string' && // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        !/\s/u.test(prev) && // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        !/\s/u.test(next));
    };
    // Detect whether the position sits mid-word: there is a word character
    // on both sides of the position (or, for a non-empty range, on the
    // outer side of each endpoint).
    const isMidWord = (idx)=>idx > 0 && idx < chars.length && isWordCharAt(idx - 1) && isWordCharAt(idx);
    // For a zero-width range (pure insertion / deletion point), only expand
    // if the point is mid-word — i.e. both the char before and after are
    // word characters. Otherwise the point is already at a word boundary.
    if (from === to) {
        if (!isMidWord(fromIdx)) return {
            from: from,
            to: to
        };
        // Expand both directions from the mid-word point.
        while(fromIdx > 0 && isWordCharAt(fromIdx - 1))fromIdx--;
        while(toIdx < chars.length && isWordCharAt(toIdx))toIdx++;
        return {
            from: parentStart + fromIdx,
            to: parentStart + toIdx
        };
    }
    // Non-empty range: expand each endpoint outward if it is mid-word.
    // Expand left only if `from` is truly mid-word: the character at `from`
    // (inside the range) and the character before `from` are both word chars.
    if (fromIdx > 0 && fromIdx < chars.length && isWordCharAt(fromIdx) && isWordCharAt(fromIdx - 1)) while(fromIdx > 0 && isWordCharAt(fromIdx - 1))fromIdx--;
    // Expand right only if `to` is truly mid-word: the character just before
    // `to` (last char of the range) and the character at `to` are both word chars.
    if (toIdx > 0 && toIdx < chars.length && isWordCharAt(toIdx - 1) && isWordCharAt(toIdx)) while(toIdx < chars.length && isWordCharAt(toIdx))toIdx++;
    return {
        from: parentStart + fromIdx,
        to: parentStart + toIdx
    };
};
/**
 * Compare marks between two nodes
 * We have to check each child because adding a mark splits text into multiple nodes
 */ const $c7ca31c0aa9ecf40$var$hasSameChildMarks = (left, right)=>{
    if (left.childCount !== right.childCount) return false;
    for(let index = 0; index < left.childCount; index++){
        if (!(0, $5SAOw.Mark).sameSet(left.child(index).marks, right.child(index).marks)) return false;
    }
    return true;
};
const $c7ca31c0aa9ecf40$var$createMapping = (maps)=>{
    const mapping = new (0, $aXG5V.Mapping)();
    for (const map of maps)mapping.appendMap(map);
    return mapping;
};
const $c7ca31c0aa9ecf40$var$createSpans = (length)=>length > 0 ? [
        {
            length: length,
            data: null
        }
    ] : [];
const $c7ca31c0aa9ecf40$var$mergeOverlappingByNewDocRange = (changes)=>{
    if (changes.length <= 1) return changes;
    const sortedChanges = [
        ...changes
    ].sort((left, right)=>left.fromB - right.fromB);
    const merged = [];
    let current = {
        ...sortedChanges[0]
    };
    for(let i = 1; i < sortedChanges.length; i++){
        const next = sortedChanges[i];
        const isOverlapping = next.fromB <= current.toB;
        if (isOverlapping) current = {
            fromA: Math.min(current.fromA, next.fromA),
            toA: Math.max(current.toA, next.toA),
            fromB: Math.min(current.fromB, next.fromB),
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            merged.push(current);
            current = {
                ...next
            };
        }
    }
    merged.push(current);
    return merged;
};
/**
 * This function checks whether to do granular diffing.
 * We should do granular diffing if:
 * - The step is a replace step
 * - The step is not open
 * - The replaced slice is not open
 * - The replaced slice has only one child
 * - The replacing slice has only one child
 * - The replaced slice and replacing slice have the same text content
 * - The replaced slice and replacing slice have the same child marks (if text content is equal)
 */ const $c7ca31c0aa9ecf40$var$shouldCheckGranularDiff = (step, before, from, to)=>{
    if (!(step instanceof (0, $aXG5V.ReplaceStep))) return false;
    if (step.slice.openStart !== 0 || step.slice.openEnd !== 0) return false;
    const replacedSlice = before.slice(from, to);
    const replacingSlice = step.slice;
    if (replacedSlice.openStart !== 0 || replacedSlice.openEnd !== 0 || replacedSlice.content.childCount !== 1 || replacingSlice.content.childCount !== 1) return false;
    const replacedNode = replacedSlice.content.firstChild;
    const replacingNode = replacingSlice.content.firstChild;
    if (replacedNode?.type.name !== replacingNode?.type.name || !replacedNode?.type.isTextblock) return false;
    if (!(0, $5SAOw.Mark).sameSet(replacedNode?.marks ?? [], replacingNode?.marks ?? [])) return false;
    const isTextContentEqual = replacedNode?.textContent === replacingNode?.textContent;
    return !isTextContentEqual || isTextContentEqual && $c7ca31c0aa9ecf40$var$hasSameChildMarks(replacedNode, replacingNode);
};
const $c7ca31c0aa9ecf40$export$3dfa1fc8b4a78d32 = (originalDoc, steps)=>{
    const changes = [];
    let currentDoc = originalDoc;
    const successfulStepMaps = [];
    const rangedSteps = [];
    for (const step of steps){
        const before = currentDoc;
        const result = step.apply(currentDoc);
        if (result.failed !== null || !result.doc) continue;
        const stepMap = step.getMap();
        const rangeStep = step;
        if (typeof rangeStep.from === 'number' && typeof rangeStep.to === 'number') rangedSteps.push({
            before: before,
            doc: result.doc,
            from: rangeStep.from,
            to: rangeStep.to,
            mapIndex: successfulStepMaps.length,
            step: step,
            stepMap: stepMap
        });
        successfulStepMaps.push(stepMap);
        currentDoc = result.doc;
    }
    for (const rangedStep of rangedSteps){
        // Mapping from original -> doc before this step.
        const originalToBeforeStep = $c7ca31c0aa9ecf40$var$createMapping(successfulStepMaps.slice(0, rangedStep.mapIndex));
        const beforeStepToOriginal = originalToBeforeStep.invert();
        const fromA = $c7ca31c0aa9ecf40$var$mapPosition(beforeStepToOriginal, rangedStep.from);
        const toA = $c7ca31c0aa9ecf40$var$mapPosition(beforeStepToOriginal, rangedStep.to);
        // Map the step range into final steppedDoc coordinates.
        const fromAfterStep = rangedStep.stepMap.map(rangedStep.from, -1);
        const toAfterStep = rangedStep.stepMap.map(rangedStep.to, 1);
        const afterStepToFinal = $c7ca31c0aa9ecf40$var$createMapping(successfulStepMaps.slice(rangedStep.mapIndex + 1));
        const fromB = $c7ca31c0aa9ecf40$var$mapPosition(afterStepToFinal, fromAfterStep);
        const toB = $c7ca31c0aa9ecf40$var$mapPosition(afterStepToFinal, toAfterStep);
        if ($c7ca31c0aa9ecf40$var$shouldCheckGranularDiff(rangedStep.step, rangedStep.before, rangedStep.from, rangedStep.to)) {
            const granularStepChanges = (0, $6rMOj.ChangeSet).create(rangedStep.before).addSteps(rangedStep.doc, [
                rangedStep.stepMap
            ], null);
            // `simplifyChanges` reads text using `Change.fromB`/`toB`, which are
            // positions in the post-step doc (the "B" doc). Passing the pre-step
            // doc (`startDoc`) misreads characters and produces mid-word cuts
            // (e.g. "deep-s|ea") because word-boundary detection runs against the
            // wrong text/positions. Use the post-step doc here.
            const optimizedGranularStepChanges = (0, $0b53856bf7843575$export$e2f3b3d89f27d105)((0, $6rMOj.simplifyChanges)(granularStepChanges.changes, rangedStep.doc));
            for (const granularChange of optimizedGranularStepChanges){
                // Expand each granular change to the nearest word boundaries in
                // both the pre-step doc (A-side) and the post-step doc (B-side).
                // This ensures that a mid-word edit like "sanitised" → "sanitized"
                // shows as deleting the whole original word and inserting the whole
                // new word, rather than a single-character swap.
                const expandedA = $c7ca31c0aa9ecf40$var$expandToWordBoundaries(rangedStep.before, granularChange.fromA, granularChange.toA);
                const expandedB = $c7ca31c0aa9ecf40$var$expandToWordBoundaries(rangedStep.doc, granularChange.fromB, granularChange.toB);
                // When one side expanded further than the other (e.g. a space
                // was inserted mid-word: "altogether" → "all together"), the
                // less-expanded side must grow to match — otherwise the renderer
                // shows a partial word as plain text next to a deletion/insertion.
                // We compare left and right deltas independently so partial
                // expansion on one side doesn't prevent the other side from
                // being pulled out further.
                const aLeftDelta = granularChange.fromA - expandedA.from;
                const aRightDelta = expandedA.to - granularChange.toA;
                const bLeftDelta = granularChange.fromB - expandedB.from;
                const bRightDelta = expandedB.to - granularChange.toB;
                let finalA = expandedA;
                let finalB = expandedB;
                // If A expanded further on either side, nudge B outward
                // by the excess and re-expand to snap to word boundaries.
                if (aLeftDelta > bLeftDelta || aRightDelta > bRightDelta) {
                    const extraLeft = Math.max(0, aLeftDelta - bLeftDelta);
                    const extraRight = Math.max(0, aRightDelta - bRightDelta);
                    finalB = $c7ca31c0aa9ecf40$var$expandToWordBoundaries(rangedStep.doc, Math.max(expandedB.from - extraLeft, 0), expandedB.to + extraRight);
                }
                // If B expanded further on either side, nudge A outward.
                if (bLeftDelta > aLeftDelta || bRightDelta > aRightDelta) {
                    const extraLeft = Math.max(0, bLeftDelta - aLeftDelta);
                    const extraRight = Math.max(0, bRightDelta - aRightDelta);
                    finalA = $c7ca31c0aa9ecf40$var$expandToWordBoundaries(rangedStep.before, Math.max(expandedA.from - extraLeft, 0), expandedA.to + extraRight);
                }
                const granularFromA = $c7ca31c0aa9ecf40$var$mapPosition(beforeStepToOriginal, finalA.from);
                const granularToA = $c7ca31c0aa9ecf40$var$mapPosition(beforeStepToOriginal, finalA.to);
                const granularFromB = $c7ca31c0aa9ecf40$var$mapPosition(afterStepToFinal, finalB.from);
                const granularToB = $c7ca31c0aa9ecf40$var$mapPosition(afterStepToFinal, finalB.to);
                changes.push({
                    fromA: granularFromA,
                    toA: granularToA,
                    fromB: granularFromB,
                    toB: granularToB,
                    deleted: $c7ca31c0aa9ecf40$var$createSpans(Math.max(0, granularToA - granularFromA)),
                    inserted: $c7ca31c0aa9ecf40$var$createSpans(Math.max(0, granularToB - granularFromB))
                });
            }
            continue;
        }
        changes.push({
            fromA: fromA,
            toA: toA,
            fromB: fromB,
            toB: toB,
            deleted: $c7ca31c0aa9ecf40$var$createSpans(Math.max(0, toA - fromA)),
            inserted: $c7ca31c0aa9ecf40$var$createSpans(Math.max(0, toB - fromB))
        });
    }
    return $c7ca31c0aa9ecf40$var$mergeOverlappingByNewDocRange(changes);
};


/**
 * Finds the position range of the top-level block (direct child of doc) that contains `pos`.
 * Returns null if `pos` is at the doc boundary or outside the doc content.
 */ function $2fdbfce96379896f$var$getTopLevelBlockAt(doc, from, to) {
    return {
        from: doc.resolve(from).before(1),
        to: doc.resolve(to).after(1)
    };
}
function $2fdbfce96379896f$export$a0c7c7ce83d8783e(changes, docA, docB) {
    const groups = new Map();
    for (const change of changes){
        const blockA = $2fdbfce96379896f$var$getTopLevelBlockAt(docA, change.fromA, change.toA);
        const blockB = $2fdbfce96379896f$var$getTopLevelBlockAt(docB, change.fromB, change.toB);
        if (!groups.has(blockB.from)) groups.set(blockB.from, {
            fromB: blockB.from,
            toB: blockB.to,
            fromA: blockA ? blockA.from : change.fromA,
            toA: blockA ? blockA.to : change.toA,
            changed: []
        });
        const group = groups.get(blockB.from);
        if (group) group.changed = [
            ...group.changed,
            ...change.inserted,
            ...change.deleted
        ];
    }
    return Array.from(groups.values()).sort((a, b)=>a.fromB - b.fromB).map(({ fromA: fromA, toA: toA, fromB: fromB, toB: toB, changed: changed })=>({
            fromA: fromA,
            toA: toA,
            fromB: fromB,
            toB: toB,
            /**
			 * We add all changes (both deleted and inserted) as that will
			 * inform the calculateDiffDecorations function that changes should be rendered
			 * (even if the change is only one of the two).
			 */ deleted: changed,
            inserted: changed
        }));
}




var $jy7VG = parcelRequire("jy7VG");







/**
 * Attempts to merge two consecutive ReplaceStep operations.
 * This merges steps where:
 * - Both steps replace content at the same starting position
 * - The second step's range encompasses the first step's range
 * - The second step has content to insert
 * Returns null if steps cannot be merged.
 */ function $f6f6b039c84303ea$var$mergeReplaceSteps(step1, step2) {
    if (!(step1 instanceof (0, $aXG5V.ReplaceStep)) || !(step2 instanceof (0, $aXG5V.ReplaceStep))) return null;
    // Confirm the step overlaps exactly with the previous
    const step2Length = step2.to - step2.from;
    if (step1.from === step2.from && step2.to >= step1.to && step2.slice.size >= step2Length && step2Length === step1.slice.size && step2.slice.size >= step1.slice.size && step1.slice.openEnd === step2.slice.openEnd && step1.slice.openStart === step2.slice.openStart) return new (0, $aXG5V.ReplaceStep)(step1.from, step1.to, step2.slice);
    return null;
}
function $f6f6b039c84303ea$export$320ba57788df881b(steps, originalDoc) {
    const stepsToFilter = $f6f6b039c84303ea$var$removeUnusedSteps(steps, originalDoc);
    return stepsToFilter// Remove steps that don't affect document structure or content
    .filter((step)=>!(step instanceof (0, $jy7VG.AnalyticsStep)))// Merge consecutive steps where possible
    .reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        const merged = lastStep?.merge?.(step) ?? $f6f6b039c84303ea$var$mergeReplaceSteps(lastStep, step);
        if (merged) acc[acc.length - 1] = merged;
        else acc.push(step);
        return acc;
    }, []);
}
/**
 * Does a first pass to remove steps that don't impact the document
 */ function $f6f6b039c84303ea$var$removeUnusedSteps(steps, originalDoc) {
    const finalSteps = [];
    let firstPassDoc = originalDoc;
    for (const step of steps){
        const result = step.apply(firstPassDoc);
        if (result.failed === null && result.doc && !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(firstPassDoc, result.doc, [
            'localId'
        ])) {
            finalSteps.push(step);
            firstPassDoc = result.doc;
        }
    }
    return finalSteps;
}


const $b8b2f651ace0ef18$var$getChanges = ({ changeset: changeset, originalDoc: originalDoc, steppedDoc: steppedDoc, diffType: diffType, tr: tr, steps: steps })=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
        if (diffType === 'step') return (0, $c7ca31c0aa9ecf40$export$3dfa1fc8b4a78d32)(originalDoc, steps);
        if (diffType === 'block') return (0, $2fdbfce96379896f$export$a0c7c7ce83d8783e)(changeset.changes, originalDoc, steppedDoc);
        const changes = (0, $6rMOj.simplifyChanges)(changeset.changes, tr.doc);
        return (0, $0b53856bf7843575$export$e2f3b3d89f27d105)(changes);
    }
    const changes = (0, $6rMOj.simplifyChanges)(changeset.changes, tr.doc);
    return (0, $0b53856bf7843575$export$e2f3b3d89f27d105)(changes);
};
const $b8b2f651ace0ef18$var$calculateNodesForBlockDecoration = ({ doc: doc, from: from, to: to, colorScheme: colorScheme, isInserted: isInserted = true, activeIndexPos: activeIndexPos, shouldHideDeleted: shouldHideDeleted = false })=>{
    const decorations = [];
    // Iterate over the document nodes within the range
    doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isBlock && (!(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) || pos + node.nodeSize <= to)) {
            const nodeEnd = pos + node.nodeSize;
            const isActive = activeIndexPos && pos === activeIndexPos.from && nodeEnd === activeIndexPos.to;
            const blockChangedDecorations = (0, $3924418ec490911a$export$8df64513a6dc1f2a)({
                change: {
                    from: pos,
                    to: nodeEnd,
                    name: node.type.name
                },
                colorScheme: colorScheme,
                isInserted: isInserted,
                isActive: isActive,
                shouldHideDeleted: shouldHideDeleted
            });
            if (blockChangedDecorations.length) decorations.push(...blockChangedDecorations);
        }
    });
    return decorations;
};
const $b8b2f651ace0ef18$var$calculateDiffDecorationsInner = ({ state: state, pluginState: pluginState, nodeViewSerializer: nodeViewSerializer, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, api: api, isInverted: isInverted = false, diffType: diffType = 'inline', hideDeletedDiffs: hideDeletedDiffs = false })=>{
    const { originalDoc: originalDoc, steps: steps } = pluginState;
    if (!originalDoc || !pluginState.isDisplayingChanges) return (0, $ftzrq.DecorationSet).empty;
    const { tr: tr } = state;
    let steppedDoc = originalDoc;
    const attrSteps = [];
    const simplifiedSteps = (0, $f6f6b039c84303ea$export$320ba57788df881b)(steps, originalDoc);
    const stepMaps = [];
    for (const step of simplifiedSteps){
        const result = step.apply(steppedDoc);
        if (result.failed === null && result.doc) {
            if ((0, $0f6682ae00a27f19$export$78b37f7430a7646c)(step, steppedDoc, result.doc)) attrSteps.push(step);
            stepMaps.push(step.getMap());
            steppedDoc = result.doc;
        }
    }
    // Rather than using .eq() we use a custom function that only checks for structural
    // changes and ignores differences in attributes which don't affect decoration positions
    if (!(0, $2pjJ5.areNodesEqualIgnoreAttrs)(steppedDoc, tr.doc)) {
        const recoveredViaContentEquality = (0, $1363eb0394885651$export$2b9c81e9e2c68dae)(steppedDoc, tr.doc);
        api?.analytics?.actions.fireAnalyticsEvent({
            eventType: 'track',
            action: 'nodesNotEqual',
            actionSubject: 'showDiff',
            attributes: {
                docSizeEqual: steppedDoc.nodeSize === tr.doc.nodeSize,
                colorScheme: colorScheme,
                recoveredViaContentEquality: recoveredViaContentEquality
            }
        });
        if (!recoveredViaContentEquality) return (0, $ftzrq.DecorationSet).empty;
    }
    const changeset = (0, $6rMOj.ChangeSet).create(originalDoc).addSteps(steppedDoc, stepMaps, tr.doc);
    const changes = $b8b2f651ace0ef18$var$getChanges({
        changeset: changeset,
        originalDoc: originalDoc,
        steppedDoc: steppedDoc,
        diffType: diffType,
        tr: tr,
        steps: steps
    });
    const decorations = [];
    changes.forEach((change)=>{
        const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
        // Our default operations are insertions, so it should match the opposite of isInverted.
        const isInserted = !isInverted;
        if (change.inserted.length > 0) {
            const shouldHideDeleted = (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? isInverted && hideDeletedDiffs : false;
            decorations.push((0, $e42005dbde5fc4ab$export$69543ba6b110e31c)({
                change: change,
                colorScheme: colorScheme,
                isActive: isActive,
                ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted
                }
            }));
            decorations.push(...$b8b2f651ace0ef18$var$calculateNodesForBlockDecoration({
                doc: tr.doc,
                from: change.fromB,
                to: change.toB,
                colorScheme: colorScheme,
                ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && {
                    isInserted: isInserted,
                    shouldHideDeleted: shouldHideDeleted
                },
                activeIndexPos: activeIndexPos,
                intl: intl
            }));
        }
        if (change.deleted.length > 0) {
            const shouldHideDeleted = (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? !isInverted && hideDeletedDiffs : false;
            if (!shouldHideDeleted) {
                const decoration = (0, $3db5c6ad889f5540$export$33298e826c81587e)({
                    change: change,
                    doc: originalDoc,
                    nodeViewSerializer: nodeViewSerializer,
                    colorScheme: colorScheme,
                    newDoc: tr.doc,
                    intl: intl,
                    activeIndexPos: activeIndexPos,
                    ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) && {
                        isInserted: !isInserted,
                        diffType: diffType
                    }
                });
                if (decoration) decorations.push(...decoration);
            }
        }
    });
    (0, $8887a45e8ceab209$export$cb37e032b0f65b99)(steps).forEach((change)=>{
        const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
        decorations.push((0, $e42005dbde5fc4ab$export$69543ba6b110e31c)({
            change: change,
            colorScheme: colorScheme,
            isActive: isActive,
            isInserted: true
        }));
    });
    (0, $0f6682ae00a27f19$export$34445edbbb29aecb)(tr.doc, attrSteps).forEach((change)=>{
        if (change.isInline) {
            // Inline nodes (e.g. date) need an inline decoration rather than a block decoration
            const isActive = activeIndexPos && change.fromB === activeIndexPos.from && change.toB === activeIndexPos.to;
            decorations.push((0, $e42005dbde5fc4ab$export$69543ba6b110e31c)({
                change: change,
                colorScheme: colorScheme,
                isActive: isActive,
                isInserted: true
            }));
        } else decorations.push(...$b8b2f651ace0ef18$var$calculateNodesForBlockDecoration({
            doc: tr.doc,
            from: change.fromB,
            to: change.toB,
            colorScheme: colorScheme,
            isInserted: true,
            activeIndexPos: activeIndexPos,
            intl: intl
        }));
    });
    return (0, $ftzrq.DecorationSet).empty.add(tr.doc, decorations);
};
const $b8b2f651ace0ef18$export$aa7cf3ccfb5d875f = (0, $2XqLN.default)($b8b2f651ace0ef18$var$calculateDiffDecorationsInner, // Cache results unless relevant inputs change
([{ pluginState: pluginState, state: state, colorScheme: colorScheme, intl: intl, activeIndexPos: activeIndexPos, isInverted: isInverted, diffType: diffType, hideDeletedDiffs: hideDeletedDiffs }], [{ pluginState: lastPluginState, state: lastState, colorScheme: lastColorScheme, intl: lastIntl, activeIndexPos: lastActiveIndexPos, isInverted: lastIsInverted, diffType: lastDiffType, hideDeletedDiffs: lastHideDeletedDiffs }])=>{
    const originalDocIsSame = lastPluginState.originalDoc && pluginState.originalDoc && pluginState.originalDoc.eq(lastPluginState.originalDoc);
    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) return (colorScheme === lastColorScheme && intl.locale === lastIntl.locale && isInverted === lastIsInverted && diffType === lastDiffType && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(activeIndexPos, lastActiveIndexPos) && originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(pluginState.steps, lastPluginState.steps) && state.doc.eq(lastState.doc) && hideDeletedDiffs === lastHideDeletedDiffs) ?? false;
    return (originalDocIsSame && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(pluginState.steps, lastPluginState.steps) && state.doc.eq(lastState.doc) && colorScheme === lastColorScheme && intl.locale === lastIntl.locale && (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(activeIndexPos, lastActiveIndexPos) && hideDeletedDiffs === lastHideDeletedDiffs) ?? false;
});


// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $cU18e = parcelRequire("cU18e");


var $fKGo7 = parcelRequire("fKGo7");




const $276fef3fc049cf68$export$b180cb547184e48c = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // @ts-expect-error ProseMirror step classes expose jsonID on prototype.
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // Re-register if needed; ignore if already registered.
                // @ts-expect-error Step.jsonID expects a step constructor.
                (0, $cO9ey.Step).jsonID(id, customStep);
            } catch  {
            // Step already registered.
            }
        }
    };
    // @ts-expect-error Step modules export non-step symbols too.
    tryToRegisterStep($fKGo7);
    // @ts-expect-error Step modules export non-step symbols too.
    tryToRegisterStep($cU18e);
};






function $e9d15807b524bec2$export$42cf4389dbe8b0ff(view) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return view.nodeViews !== undefined;
}
class $e9d15807b524bec2$export$314a8d5cfa8a18e6 {
    /**
   * Initializes or reinitializes the NodeViewSerializer with a new EditorView.
   * This allows the same serializer instance to be reused across different editor states.
   */ init(params) {
        this.serializer = (0, $5SAOw.DOMSerializer).fromSchema(params.editorView.state.schema);
        if ($e9d15807b524bec2$export$42cf4389dbe8b0ff(params.editorView)) this.editorView = params.editorView;
        const nodeViews = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params.editorView?.nodeViews || {};
        this.nodeViews = nodeViews ?? this.editorView?.nodeViews ?? {};
    }
    /**
   * Appends serialized child nodes to the given contentDOM element.
   */ appendChildNodes(children, contentDOM) {
        children.forEach((child)=>{
            const childNode = this.tryCreateNodeView(child) || this.serializeNode(child);
            if (childNode) contentDOM?.append(childNode);
        });
    }
    /**
   * Attempts to create a node view for the given node.
   *
   * Returns `null` when there is no `EditorView`, no constructor for the node type,
   * or the node type is blocklisted. Otherwise returns the constructed node view instance.
   */ tryCreateNodeView(targetNode) {
        if (!this.editorView) return null;
        const constructor = this.nodeViews?.[targetNode.type.name];
        if (this.nodeViewBlocklist.has(targetNode.type.name)) return null;
        try {
            if (!constructor) {
                if (targetNode.isInline) return null;
                const toDOMResult = targetNode.type.spec.toDOM?.(targetNode);
                if (!toDOMResult) return null;
                const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, toDOMResult);
                if (dom instanceof HTMLElement) {
                    if (targetNode.type.name === 'paragraph' && targetNode.children.length === 1) return this.serializeFragment(targetNode.content);
                    // Iteratively populate children
                    this.appendChildNodes(targetNode.children, contentDOM);
                }
                return dom;
            }
            const { dom: dom, contentDOM: contentDOM } = constructor(targetNode, this.editorView, ()=>0, [], {});
            // Iteratively populate children
            this.appendChildNodes(targetNode.children, contentDOM);
            return dom;
        } catch  {
            return null;
        }
    }
    /**
   * Serializes a node to a DOM `Node` using the schema's `DOMSerializer`.
   */ serializeNode(node) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeNode(node);
        } catch  {
            return null;
        }
    }
    /**
   * Serializes a fragment to a `DocumentFragment` using the schema's `DOMSerializer`.
   */ serializeFragment(fragment) {
        if (!this.serializer) throw new Error('NodeViewSerializer must be initialized with init() before use');
        try {
            return this.serializer.serializeFragment(fragment);
        } catch  {
            return null;
        }
    }
    /**
   * Returns a copy of the current node view blocklist.
   */ getNodeViewBlocklist() {
        return new Set(this.nodeViewBlocklist);
    }
    /**
   * Returns a filtered copy of the node view blocklist, excluding specified node types.
   * @param excludeTypes - Array of node type names to exclude from the blocklist
   */ getFilteredNodeViewBlocklist(excludeTypes) {
        const filtered = new Set(this.nodeViewBlocklist);
        excludeTypes.forEach((type)=>filtered.delete(type));
        return filtered;
    }
    constructor(params){
        this.editorView = void 0;
        this.serializer = void 0;
        this.nodeViews = void 0;
        this.nodeViewBlocklist = void 0;
        if (params?.editorView) this.init({
            editorView: params.editorView
        });
        this.nodeViewBlocklist = new Set(params.blocklist ?? [
            'paragraph'
        ]);
    }
}



/**
 * Extra space above the scrolled-to element so it does not sit flush under the
 * viewport edge (helps with sticky table headers, toolbars, etc.).
 *
 * Implemented with `scroll-margin-top` so we still use the browser’s native
 * `scrollIntoView`, which scrolls every relevant scrollport (nested containers
 * and the window). A single manual `scrollTop` on one ancestor often misses
 * outer scroll or mis-identifies the active scroll container.
 */ const $2a0c13179dcbe761$var$SCROLL_TOP_MARGIN_PX = 100;
/**
 * Returns the resolved HTMLElement for a given DOM node, walking up to the
 * parent element if the node itself is not an Element (e.g. a text node).
 */ function $2a0c13179dcbe761$var$scrollToSelection(node) {
    const element = node instanceof Element ? node : node?.parentElement instanceof Element ? node.parentElement : null;
    if (!(element instanceof HTMLElement)) return;
    // scroll-margin is included in scroll-into-view math; it does not change layout.
    const previousScrollMarginTop = element.style.scrollMarginTop;
    element.style.scrollMarginTop = `${$2a0c13179dcbe761$var$SCROLL_TOP_MARGIN_PX}px`;
    try {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } finally{
        element.style.scrollMarginTop = previousScrollMarginTop;
    }
}
const $2a0c13179dcbe761$export$8c2c2fbc53afef61 = (view, decorations)=>{
    const decoration = decorations[0];
    if (!decoration) return ()=>{};
    let rafId = requestAnimationFrame(()=>{
        rafId = null;
        // @ts-expect-error - decoration.type is not typed public API
        if (decoration.spec?.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).widget) && decoration?.type?.toDOM) {
            // @ts-expect-error - decoration.type is not typed public API
            const widgetDom = decoration.type.toDOM;
            // Always scroll to the top of this decoration even if it's in view already
            $2a0c13179dcbe761$var$scrollToSelection(widgetDom);
        } else {
            const targetNode = view.nodeDOM(decoration?.from);
            const node = targetNode instanceof Element ? targetNode : view.domAtPos(decoration?.from)?.node;
            if (node instanceof HTMLElement) // Always scroll to the top of this decoration even if it's in view already
            $2a0c13179dcbe761$var$scrollToSelection(node);
        }
    });
    return ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
};
const $2a0c13179dcbe761$export$58319fce2ad9953a = (view, decorations, activeIndex)=>{
    const decoration = decorations[activeIndex];
    if (!decoration) return ()=>{};
    let rafId = requestAnimationFrame(()=>{
        rafId = null;
        if (decoration.spec?.key?.startsWith((0, $d389c671c2e69790$export$821fbb25e40fbb48).widget)) {
            // @ts-expect-error - decoration.type is not typed public API
            const widgetDom = decoration?.type?.toDOM;
            $2a0c13179dcbe761$var$scrollToSelection(widgetDom);
        } else {
            const targetNode = view.nodeDOM(decoration?.from);
            const node = targetNode instanceof Element ? targetNode : view.domAtPos(decoration?.from)?.node;
            $2a0c13179dcbe761$var$scrollToSelection(node);
        }
    });
    return ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
};


const $5e437f43e556a591$export$cc8ba64700247b36 = new (0, $ks2lK.PluginKey)('showDiffPlugin');
const $5e437f43e556a591$export$ae829ec7b2625219 = (config, getIntl, api)=>{
    (0, $276fef3fc049cf68$export$b180cb547184e48c)();
    const nodeViewSerializer = new (0, $e9d15807b524bec2$export$314a8d5cfa8a18e6)({});
    const setNodeViewSerializer = (editorView)=>{
        nodeViewSerializer.init({
            editorView: editorView
        });
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $5e437f43e556a591$export$cc8ba64700247b36,
        state: {
            init (_, _state) {
                // We do initial setup after we setup the editor view
                return {
                    steps: [],
                    originalDoc: undefined,
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    isDisplayingChanges: false,
                    ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                        isInverted: false,
                        diffType: 'inline',
                        hideDeletedDiffs: false
                    } : {}
                };
            },
            apply: (tr, currentPluginState, oldState, newState)=>{
                const meta = tr.getMeta($5e437f43e556a591$export$cc8ba64700247b36);
                let newPluginState = currentPluginState;
                if (meta) {
                    if (meta?.action === 'SHOW_DIFF') {
                        // Update the plugin state with the new metadata
                        newPluginState = {
                            ...currentPluginState,
                            ...meta,
                            isDisplayingChanges: true,
                            activeIndex: undefined
                        };
                        // Calculate and store decorations in state
                        const decorations = (0, $b8b2f651ace0ef18$export$aa7cf3ccfb5d875f)({
                            state: newState,
                            pluginState: newPluginState,
                            nodeViewSerializer: nodeViewSerializer,
                            colorScheme: config?.colorScheme,
                            intl: getIntl(),
                            activeIndexPos: newPluginState.activeIndexPos,
                            api: api,
                            ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                                isInverted: newPluginState?.isInverted,
                                diffType: newPluginState?.diffType,
                                hideDeletedDiffs: newPluginState?.hideDeletedDiffs
                            } : {}
                        });
                        // Update the decorations
                        newPluginState.decorations = decorations;
                    } else if (meta?.action === 'HIDE_DIFF') newPluginState = {
                        ...currentPluginState,
                        ...meta,
                        decorations: (0, $ftzrq.DecorationSet).empty,
                        isDisplayingChanges: false,
                        activeIndex: undefined,
                        /**
               * Reset isInverted & diffType state when hiding diffs
               * Otherwise this should persist for the diff-showing session
               */ ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                            isInverted: false,
                            diffType: 'inline',
                            hideDeletedDiffs: false
                        } : {}
                    };
                    else if (meta?.action === 'SCROLL_TO_NEXT' || meta?.action === 'SCROLL_TO_PREVIOUS') {
                        // Update the active index in plugin state and recalculate decorations
                        const decorations = (0, $f881639693888cff$export$c459ab16dd3c3d79)(currentPluginState.decorations, newState.doc);
                        if (decorations.length > 0) {
                            // Initialize to -1 if undefined so that the first "next" scroll takes us to index 0 (first change).
                            // This allows the UI to start with no selection and only highlight on first user interaction.
                            let nextIndex = currentPluginState.activeIndex ?? -1;
                            if (meta.action === 'SCROLL_TO_NEXT') nextIndex = (nextIndex + 1) % decorations.length;
                            else // Handle scrolling backwards from the uninitialized state.
                            // If at -1 (no selection), wrap to the last decoration.
                            if (nextIndex === -1) nextIndex = decorations.length - 1;
                            else nextIndex = (nextIndex - 1 + decorations.length) % decorations.length;
                            const activeDecoration = decorations[nextIndex];
                            newPluginState = {
                                ...currentPluginState,
                                activeIndex: nextIndex,
                                activeIndexPos: activeDecoration ? {
                                    from: activeDecoration.from,
                                    to: activeDecoration.to
                                } : undefined
                            };
                            // Recalculate decorations with the new active index
                            const updatedDecorations = (0, $b8b2f651ace0ef18$export$aa7cf3ccfb5d875f)({
                                state: newState,
                                pluginState: newPluginState,
                                nodeViewSerializer: nodeViewSerializer,
                                colorScheme: config?.colorScheme,
                                intl: getIntl(),
                                activeIndexPos: newPluginState.activeIndexPos,
                                api: api,
                                ...(0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true) ? {
                                    isInverted: newPluginState.isInverted,
                                    diffType: newPluginState.diffType,
                                    hideDeletedDiffs: newPluginState.hideDeletedDiffs
                                } : {}
                            });
                            newPluginState.decorations = updatedDecorations;
                        }
                    } else newPluginState = {
                        ...currentPluginState,
                        ...meta
                    };
                }
                return {
                    ...newPluginState,
                    decorations: newPluginState.decorations.map(tr.mapping, tr.doc)
                };
            }
        },
        view (editorView) {
            setNodeViewSerializer(editorView);
            let isFirst = true;
            let previousActiveIndex;
            let cancelPendingScrollToDecoration = null;
            return {
                update (view) {
                    // If we're using configuration to show diffs we initialise here once we setup the editor view
                    if (config?.originalDoc && config?.steps && config.steps.length > 0 && isFirst) {
                        isFirst = false;
                        view.dispatch(view.state.tr.setMeta($5e437f43e556a591$export$cc8ba64700247b36, {
                            action: 'SHOW_DIFF',
                            steps: config.steps.map((step)=>(0, $cO9ey.Step).fromJSON(view.state.schema, step)),
                            originalDoc: (0, $6tl2G.processRawValue)(view.state.schema, config.originalDoc)
                        }));
                    }
                    const pluginState = $5e437f43e556a591$export$cc8ba64700247b36.getState(view.state);
                    // Scroll to the first decoration when scrollIntoView was requested
                    if (pluginState?.scrollIntoView && (0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) {
                        cancelPendingScrollToDecoration?.();
                        const allDecorations = pluginState.decorations?.find() || [];
                        cancelPendingScrollToDecoration = (0, $2a0c13179dcbe761$export$8c2c2fbc53afef61)(view, allDecorations);
                        // Reset the flag so we don't scroll again on subsequent updates
                        view.dispatch(view.state.tr.setMeta($5e437f43e556a591$export$cc8ba64700247b36, {
                            scrollIntoView: false
                        }));
                    }
                    // Check for any potential scroll side-effects
                    const activeIndexChanged = pluginState?.activeIndex !== undefined && pluginState.activeIndex !== previousActiveIndex;
                    previousActiveIndex = pluginState?.activeIndex;
                    if (pluginState?.activeIndex !== undefined && activeIndexChanged) {
                        cancelPendingScrollToDecoration?.();
                        const scrollableDecorations = (0, $f881639693888cff$export$c459ab16dd3c3d79)(pluginState.decorations, view.state.doc);
                        const activeDecoration = scrollableDecorations[pluginState.activeIndex];
                        if (activeDecoration && api?.expand?.commands?.toggleExpandRange) api?.core.actions.execute(api.expand.commands.toggleExpandRange(activeDecoration.from, activeDecoration.to, true));
                        cancelPendingScrollToDecoration = (0, $2a0c13179dcbe761$export$58319fce2ad9953a)(view, scrollableDecorations, pluginState.activeIndex);
                    }
                },
                destroy () {
                    cancelPendingScrollToDecoration?.();
                    cancelPendingScrollToDecoration = null;
                }
            };
        },
        props: {
            decorations: (state)=>{
                const pluginState = $5e437f43e556a591$export$cc8ba64700247b36.getState(state);
                return pluginState?.decorations;
            }
        }
    });
};


const $0a7e0bfbc3e153f6$export$b025b000fc343096 = ({ api: api, config: config })=>({
        name: 'showDiff',
        commands: {
            showDiff: (params)=>({ tr: tr })=>{
                    if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) api?.userIntent?.commands.setCurrentUserIntent('viewingDiff')({
                        tr: tr
                    });
                    return tr.setMeta((0, $5e437f43e556a591$export$cc8ba64700247b36), {
                        ...params,
                        action: 'SHOW_DIFF'
                    });
                },
            hideDiff: ({ tr: tr })=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_diff_plugin_extended', 'isEnabled', true)) api?.userIntent?.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta((0, $5e437f43e556a591$export$cc8ba64700247b36), {
                    steps: [],
                    action: 'HIDE_DIFF'
                });
            },
            scrollToNext: ({ tr: tr })=>{
                return tr.setMeta((0, $5e437f43e556a591$export$cc8ba64700247b36), {
                    action: 'SCROLL_TO_NEXT'
                });
            },
            scrollToPrevious: ({ tr: tr })=>{
                return tr.setMeta((0, $5e437f43e556a591$export$cc8ba64700247b36), {
                    action: 'SCROLL_TO_PREVIOUS'
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'showDiffPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $5e437f43e556a591$export$ae829ec7b2625219)(config, getIntl, api)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                activeIndex: undefined
            };
            const pluginState = (0, $5e437f43e556a591$export$cc8ba64700247b36).getState(editorState);
            const decorationCount = (0, $f881639693888cff$export$c459ab16dd3c3d79)(pluginState?.decorations, editorState.doc);
            return {
                isDisplayingChanges: decorationCount.length > 0,
                activeIndex: pluginState?.activeIndex,
                numberOfChanges: decorationCount.length
            };
        }
    });
module.exports["showDiffPlugin"] = $0a7e0bfbc3e153f6$export$b025b000fc343096;

});

parcelRegister("dF1N1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fO7hX = parcelRequire("fO7hX");


var $6qdjm = parcelRequire("6qdjm");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $4QzBR = parcelRequire("4QzBR");


var $d925B = parcelRequire("d925B");


var $2pjJ5 = parcelRequire("2pjJ5");







function $d8e69355082f4231$export$a76b6d56e2272140(symptom, detectionLayer) {
    // ─── Parser-detected symptoms ────────────────────────────────────────
    // The streaming-JSON parser (in ai-model-io / ADFStreamer) is the
    // detector here, but the *cause* in every case is upstream — the model
    // produced output that the parser had to reject or repair. Detection
    // point ≠ ownership: we attribute to the backend.
    // Parser detecting malformed final ADF → backend generated bad output.
    // High confidence because the parser does not modify content — if the
    // final ADF is invalid, it's invalid as emitted by the model.
    if (detectionLayer === 'parser' && symptom === 'final_adf_invalid') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Parser had to repair JSON → backend streamed invalid JSON. Medium
    // confidence because some JSON-repair recoveries are triggered by
    // transport-level glitches (truncation, re-ordering) rather than true
    // model-output errors.
    if (detectionLayer === 'parser' && symptom === 'final_json_repaired') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // ─── Orchestrator-detected symptoms ──────────────────────────────────
    // The orchestrator is responsible for translating streamed ADF into
    // ProseMirror transactions and managing session lifecycle. Symptoms it
    // detects can split between frontend bugs (apply logic, lifecycle) and
    // backend bugs (the model emitted ADF that doesn't conform to the
    // schema or references a node that doesn't exist).
    // Orchestrator session lifecycle error → frontend issue. The session
    // machine itself is FE-owned; lifecycle errors are almost always our
    // bugs.
    if (detectionLayer === 'orchestrator' && symptom === 'session_lifecycle_error') return {
        attribution: 'frontend_apply_logic',
        confidence: 'high'
    };
    // Apply step failed with ProseMirror transaction error → FE apply
    // logic. The transaction was constructed by our code; if PM rejects
    // it, our construction is wrong.
    if (detectionLayer === 'orchestrator' && symptom === 'apply_failed_pm_error') return {
        attribution: 'frontend_apply_logic',
        confidence: 'high'
    };
    // Apply step failed because incoming ADF node had schema errors →
    // backend. The orchestrator only attempts to apply what the model
    // emitted; if the schema check fails, the model is at fault.
    if (detectionLayer === 'orchestrator' && symptom === 'apply_failed_adf_schema_error') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Target node not found → LLM hallucinated a localId. The orchestrator
    // looks up the target by the model-supplied localId; if no such node
    // exists in the doc, the model invented an identifier.
    if (detectionLayer === 'orchestrator' && symptom === 'local_id_not_found') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Node disappeared that wasn't the explicit target → frontend apply
    // side effect. Medium confidence because a poorly-formed transaction
    // can collateral-damage a sibling, but it could also be backend asking
    // for a structural change that we translated correctly into a
    // destructive transaction.
    if (detectionLayer === 'orchestrator' && symptom === 'unexpected_node_removal') return {
        attribution: 'frontend_apply_logic',
        confidence: 'medium'
    };
    // Tool call applied successfully but produced no document change.
    // Highest-likelihood cause is the model emitting content identical to
    // what already exists in the document (redundant generation). Medium
    // confidence rather than high because frontend apply-layer normalisation
    // can also silently collapse a transaction to a no-op (e.g. ProseMirror
    // merging adjacent identical text runs). A future refinement comparing
    // pre/post node-content hashes could upgrade this to high confidence
    // when the replacement content is byte-identical to the existing content.
    if (detectionLayer === 'orchestrator' && symptom === 'no_document_change') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // User / UI explicitly aborted the session. Origin is opaque to
    // telemetry (could be intentional cancel, navigation away, etc.) so we
    // can't confidently attribute the cause — only the fact of the abort
    // itself.
    if (detectionLayer === 'orchestrator' && symptom === 'session_aborted') return {
        attribution: 'unknown',
        confidence: 'high'
    };
    // Stream stalled: no further commands arrived within the orchestrator's
    // queue timeout. The most common cause is the backend halting its
    // stream (network slowness, model latency, or upstream error) so we
    // attribute to backend generation quality with medium confidence —
    // frontend bugs can also stall the stream, so this is not high
    // confidence.
    if (detectionLayer === 'orchestrator' && symptom === 'session_timeout') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // Post-apply analyzer detected a top-level node removed that no tool
    // call had explicitly targeted. When the analyzer used the precise
    // backend-supplied selection set we can confidently attribute to the
    // model. The proxy-fallback path (no backend selection) is handled at
    // the call site, where it returns unknown/low instead.
    if (detectionLayer === 'post_apply' && symptom === 'unexpected_content_removal') return {
        attribution: 'backend_generation_quality',
        confidence: 'high'
    };
    // Post-apply analyzer detected text content of a top-level node changed
    // that no tool call had explicitly targeted. Heuristic-driven (uses
    // character-count inequality with a `±1` ProseMirror normalisation
    // tolerance) so low-confidence — the caller is expected to also flag
    // the event with `experimental: true`. Same-length rewrites are silent
    // false negatives by design (out of scope for v1).
    if (detectionLayer === 'post_apply' && symptom === 'unintended_text_modification') return {
        attribution: 'unknown',
        confidence: 'low'
    };
    // Mutating tool calls ran but the document is effectively unchanged.
    // Highest-likelihood cause is a model that emitted commands targeting
    // the wrong node or producing no-op transactions; medium confidence
    // because frontend bugs (e.g. apply-layer no-op merges) can also
    // produce this signal.
    if (detectionLayer === 'post_apply' && symptom === 'no_meaningful_effect') return {
        attribution: 'backend_generation_quality',
        confidence: 'medium'
    };
    // Inferred intent doesn't match structural delta (e.g. APPEND intent
    // but net node removal). Heuristic-driven and so low-confidence — the
    // caller is expected to also flag the event with `experimental: true`.
    if (detectionLayer === 'post_apply' && symptom === 'semantic_mismatch') return {
        attribution: 'unknown',
        confidence: 'low'
    };
    // Default: unknown.
    return {
        attribution: 'unknown',
        confidence: 'low'
    };
}



var $2QlXt = parcelRequire("2QlXt");

const $af0b798917256420$export$d4371db4dc3f8b5f = [
    'replaceDoc',
    'replaceNode',
    'removeNode',
    'removeNodes',
    'moveNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'appendNodeToEnd',
    'setAttrs',
    'wrap',
    'wrapNode',
    'appendNode'
];
 // #endregion


function $839bfdacc8d0b035$export$6bf900bab6a4720d(api) {
    let doc;
    // Quick and dirty way to get the doc
    api?.core.actions.execute(({ tr: tr })=>{
        doc = tr.doc;
        return null;
    });
    return doc;
}


function $c127a9255266496a$export$f85aff2979b590a7(command) {
    return [
        'replaceDoc',
        'replaceNode',
        'insertNodeBefore',
        'insertNodeAfter',
        'appendNode',
        'appendNodeToEnd'
    ].includes(command.type);
}














function $009cb14caceb5527$export$1bd732ee2c8aaeb(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (nodeResult) return false;
        if (node.attrs.localId === localId) nodeResult = {
            node: node,
            pos: pos,
            parent: parent
        };
        return !nodeResult;
    });
    return nodeResult;
}
function $009cb14caceb5527$export$a3fa3f6695d8b421(doc) {
    const ids = new Set();
    if (!doc) return ids;
    doc.descendants((node)=>{
        const localId = node.attrs?.localId;
        if (typeof localId === 'string' && localId.length > 0) ids.add(localId);
        return true;
    });
    return ids;
}
function $009cb14caceb5527$export$c1cb5b5eb3aab3e3(doc, localId) {
    let nodeResult;
    doc.descendants((node, pos, parent)=>{
        if (node.attrs.localId === localId) {
            nodeResult = {
                node: node,
                pos: pos,
                parent: parent
            };
            return false;
        }
        return true;
    });
    return nodeResult;
}
function $009cb14caceb5527$export$b7b4fc0a0195a016(api, localId) {
    if (!localId) return undefined;
    let foundNode;
    api?.core.actions.execute(({ tr: tr })=>{
        foundNode = $009cb14caceb5527$export$1bd732ee2c8aaeb(tr.doc, localId)?.node;
        return null;
    });
    return foundNode;
}
function $009cb14caceb5527$export$aadcc3ba2430b(api, tr, localId, callback, reversed) {
    const result = (reversed ? $009cb14caceb5527$export$c1cb5b5eb3aab3e3 : $009cb14caceb5527$export$1bd732ee2c8aaeb)(tr.doc, localId);
    if (result) {
        api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
        callback(result);
    }
    if (!result) {
        const localIdState = api?.localId?.sharedState.currentState();
        let localIdStatus;
        if (!localIdState) localIdStatus = 'localIdPluginMissing';
        else if (!localIdState.localIdWatchmenEnabled) localIdStatus = 'localIdWatchmenDisabled';
        else localIdStatus = localIdState.localIdStatus?.get(localId) ?? 'notFound';
        let docSize;
        // Quick and dirty way to get the node size - do not copy this pattern, use `requestDocument`
        api?.core.actions.execute(({ tr: tr })=>{
            docSize = tr.doc.nodeSize;
            return null;
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).LOCAL_ID_NOT_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                localIdLength: localId?.length,
                docSize: docSize,
                scrubbedLocalId: (0, $4QzBR.scrubStr)(localId),
                localIdStatus: (0, $dh538.fg)('platform_editor_ai_aifc_localid_error_reporting') ? localIdStatus : 'unavailable',
                localIdStatusSize: localIdState?.localIdStatus?.size ?? 0
            }
        });
        return null;
    }
    return tr;
}



var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

function $adc2c60cd4921249$export$7b6c9d9d26e2f428(api, response) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!schema || !response) return {
        adfDoc: response
    };
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        const node = (0, $5SAOw.Node).fromJSON(schema, response);
        const newDoc = transform.replaceWith(0, 2, node).doc;
        return {
            doc: newDoc,
            // The "doc" response can cause nesting issues (ie. by wrapping a taskItem in doc -> taskList -> taskItem)
            // We should use the response, but for now only use it for `replaceNode` since it causes some edge cases with other commands
            // that need to be resolved separately
            adfDoc: response
        };
    } catch  {
        return {
            adfDoc: response
        };
    }
}


function $9dc598573bd03537$export$450b2ad108e2e506(api, initialNode, finalNode) {
    const schema = api?.core.sharedState.currentState()?.schema;
    if (!initialNode || !finalNode || !schema || !initialNode.attrs.localId) return false;
    const finalPMDoc = (0, $adc2c60cd4921249$export$7b6c9d9d26e2f428)(api, finalNode)?.doc;
    if (!finalPMDoc) return false;
    const finalPMNode = (0, $009cb14caceb5527$export$1bd732ee2c8aaeb)(finalPMDoc, initialNode.attrs.localId)?.node;
    return (finalPMNode && !initialNode.eq(finalPMNode) && (0, $2pjJ5.areNodesEqualIgnoreAttrs)(initialNode, finalPMNode)) ?? false;
}


function $7b61ecd8bc5f3510$export$6dcba6b9d3966cf9({ api: api, isCreateAction: isCreateAction, traceId: traceId, promptVersion: promptVersion }) {
    return (event)=>{
        const commonAttributes = {
            traceId: traceId,
            ...promptVersion && (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                promptVersion: promptVersion
            } : {},
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction
            }
        };
        if (event.type === 'error') api?.analytics?.actions.fireAnalyticsEvent({
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                ...commonAttributes,
                errorMessage: event.message,
                errorData: event.data
            }
        });
        else api?.analytics?.actions.fireAnalyticsEvent({
            action: 'info',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'adfStreaming',
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                ...commonAttributes,
                message: event.message,
                data: event.data
            }
        });
    };
}
function $7b61ecd8bc5f3510$export$7535a054b27a27c4({ api: api, initialNode: initialNode, lastDoc: lastDoc }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'replaceNodeAction',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'orchestratorReplaceNode',
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            attributeOnlyChange: (0, $9dc598573bd03537$export$450b2ad108e2e506)(api, initialNode, lastDoc),
            nodeName: initialNode?.type.name
        }
    });
}
// Validates the command is valid ()
const $7b61ecd8bc5f3510$var$validateCommandType = (cmd)=>cmd?.type && (0, $af0b798917256420$export$d4371db4dc3f8b5f).includes(cmd.type) ? cmd.type : 'invalid';
function $7b61ecd8bc5f3510$export$276ecd5322451ab4({ api: api, docBeforeStreaming: docBeforeStreaming, command: command, traceId: traceId }) {
    const docAfterStreaming = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(api);
    if (docBeforeStreaming && docAfterStreaming) {
        const isSameDoc = docBeforeStreaming.eq(docAfterStreaming);
        const isSameDocIgnoreAttrs = (0, $2pjJ5.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming);
        if (isSameDoc || isSameDocIgnoreAttrs) api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).NO_DOC_CHANGE_FOUND,
            actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                command: $7b61ecd8bc5f3510$var$validateCommandType(command),
                isSameDoc: isSameDoc,
                isSameDocIgnoreAttrs: isSameDocIgnoreAttrs,
                traceId: traceId
            }
        });
        // Attribution-first `toolCallAnomaly { symptom: 'no_document_change' }` for
        // streamable commands. The call site (streamCommandQueue) defers this call until
        // after handleFinalize's commit transaction lands (via an isStreaming subscription),
        // so by the time this runs, getPmDoc() reflects the committed doc.
        // isSameDoc is therefore accurate: true only when the stream genuinely produced
        // no structural change.
        //
        // The legacy NO_DOC_CHANGE_FOUND event above keeps the broader isSameDoc ||
        // isSameDocIgnoreAttrs check for dashboard continuity.
        if (command !== undefined && (0, $c127a9255266496a$export$f85aff2979b590a7)(command) && (0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            if ((0, $dh538.fg)('platform_editor_ai_normalized_telemetry_patch1')) {
                // CCI-16980: For the toolCallAnomaly path we use a narrower comparator that
                // ignores only `localId` attributes. `replaceNode` always produces replacement
                // nodes with fresh localIds (CCI-16968 pattern), so `isSameDoc` alone would
                // miss genuine no-ops. However, the old `isSameDocIgnoreAttrs` was too broad
                // — it ignored ALL attributes including meaningful ones like heading `level`,
                // `panelType`, `background` etc., causing false positives when a replaceNode
                // intentionally changed only those attributes.
                //
                // `areNodesEqualIgnoreAttrs(…, ['localId'])` strips only localId before
                // comparing, so attribute-only changes to level/panelType/background etc. are
                // still detected as real edits and will NOT fire no_document_change.
                //
                // Short-circuit on isSameDoc: if docs are byte-for-byte identical the
                // localId-only traversal is redundant (isSameDoc ⊆ isSameDocIgnoreLocalIdsOnly).
                const isSameDocIgnoreLocalIdsOnly = isSameDoc || (0, $2pjJ5.areNodesEqualIgnoreAttrs)(docBeforeStreaming, docAfterStreaming, [
                    'localId'
                ]);
                if (isSameDocIgnoreLocalIdsOnly) $7b61ecd8bc5f3510$export$4d196ad3126dbf0c({
                    api: api,
                    traceId: traceId,
                    commandType: command.type,
                    result: 'anomaly',
                    symptom: 'no_document_change'
                });
                else $7b61ecd8bc5f3510$export$4d196ad3126dbf0c({
                    api: api,
                    traceId: traceId,
                    commandType: command.type,
                    result: 'success'
                });
            } else // Gate OFF: reuse already-computed isSameDocIgnoreAttrs (line 139) to avoid
            // a redundant doc traversal.
            if (isSameDoc || isSameDocIgnoreAttrs) $7b61ecd8bc5f3510$export$4d196ad3126dbf0c({
                api: api,
                traceId: traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'no_document_change'
            });
            else $7b61ecd8bc5f3510$export$4d196ad3126dbf0c({
                api: api,
                traceId: traceId,
                commandType: command.type,
                result: 'success'
            });
        }
    }
}
function $7b61ecd8bc5f3510$export$8b7d4483ec260574({ api: api, sessionStarted: sessionStarted, endSessionCallCount: endSessionCallCount, lastEndedSessionId: lastEndedSessionId, isDoubleCall: isDoubleCall }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreamingEndSession',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            sessionStarted: sessionStarted,
            endSessionCallCount: endSessionCallCount,
            lastEndedSessionId: lastEndedSessionId,
            isDoubleCall: isDoubleCall
        }
    });
}
function $7b61ecd8bc5f3510$export$121949ee4a6ce5f6({ api: api, backendEndToPacerCompleteMs: backendEndToPacerCompleteMs, backlogCharsAtBackendEnd: backlogCharsAtBackendEnd, charsPerTickAtComplete: charsPerTickAtComplete, terminalType: terminalType, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'completed',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'streamFlowPacerCompletion',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            backendEndToPacerCompleteMs: backendEndToPacerCompleteMs,
            backlogCharsAtBackendEnd: backlogCharsAtBackendEnd,
            charsPerTickAtComplete: charsPerTickAtComplete,
            terminalType: terminalType,
            traceId: traceId
        }
    });
}
function $7b61ecd8bc5f3510$export$4b84cbb6abceadd2({ api: api, sessionId: sessionId, traceId: traceId, promptVersion: promptVersion }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionStart',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'userFlow',
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            aiGroupId: sessionId,
            actionTaken: undefined,
            editCount: 0,
            aiSessionId: '',
            traceIds: traceId ? [
                traceId
            ] : undefined,
            ...promptVersion && (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                promptVersion: promptVersion
            } : {}
        }
    });
}
function $7b61ecd8bc5f3510$export$2197bcc2a00f4a51({ api: api, command: command, actionId: actionId, traceId: traceId }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'captured',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'toolCall',
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            actionId: actionId,
            commandType: $7b61ecd8bc5f3510$var$validateCommandType(command),
            contentType: 'contentType' in command ? command.contentType : undefined,
            traceId: traceId
        }
    });
}
function $7b61ecd8bc5f3510$export$f31b302ceb439402({ api: api, traceId: traceId, outcomeClass: outcomeClass, detectionLayer: detectionLayer, symptom: symptom, finalJsonInvalid: finalJsonInvalid, finalJsonRepaired: finalJsonRepaired, finalAdfInvalid: finalAdfInvalid, finalAdfRepaired: finalAdfRepaired, unintendedRegionRemoved: unintendedRegionRemoved, unintendedRegionModified: unintendedRegionModified, noMeaningfulEffect: noMeaningfulEffect, intentEffectMismatch: intentEffectMismatch, removedNodeCount: removedNodeCount, totalNodeDelta: totalNodeDelta, textCharacterDelta: textCharacterDelta, commandTypeCounts: commandTypeCounts, selectionLocalIdsAvailable: selectionLocalIdsAvailable, heuristicInferred: heuristicInferred }) {
    // When no symptom is reported (e.g. clean_success) the routing table
    // returns `unknown`/`low`, which is the correct contract value for "no
    // detectable failure to attribute".
    const { attribution: attribution, confidence: confidence } = (0, $d8e69355082f4231$export$a76b6d56e2272140)(symptom ?? '', detectionLayer);
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'sessionOutcome',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            traceId: traceId,
            outcomeClass: outcomeClass,
            attribution: attribution,
            confidence: confidence,
            detectionLayer: detectionLayer,
            symptom: symptom,
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired,
            ...unintendedRegionRemoved !== undefined ? {
                unintendedRegionRemoved: unintendedRegionRemoved
            } : {},
            ...unintendedRegionModified !== undefined ? {
                unintendedRegionModified: unintendedRegionModified
            } : {},
            ...noMeaningfulEffect !== undefined ? {
                noMeaningfulEffect: noMeaningfulEffect
            } : {},
            ...intentEffectMismatch !== undefined ? {
                intentEffectMismatch: intentEffectMismatch
            } : {},
            ...removedNodeCount !== undefined ? {
                removedNodeCount: removedNodeCount
            } : {},
            ...totalNodeDelta !== undefined ? {
                totalNodeDelta: totalNodeDelta
            } : {},
            ...textCharacterDelta !== undefined ? {
                textCharacterDelta: textCharacterDelta
            } : {},
            ...commandTypeCounts !== undefined ? {
                commandTypeCounts: commandTypeCounts
            } : {},
            ...selectionLocalIdsAvailable !== undefined ? {
                selectionLocalIdsAvailable: selectionLocalIdsAvailable
            } : {},
            ...heuristicInferred !== undefined ? {
                heuristicInferred: heuristicInferred
            } : {}
        }
    });
}
function $7b61ecd8bc5f3510$export$c20b86820b0850bf({ api: api, command: command, traceId: traceId, isCreateAction: isCreateAction, error: error }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'toolCallError',
            errorData: {
                commandType: command?.type,
                commandReason: command?.type === 'endStream' ? command?.reason : undefined,
                errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error)
            },
            traceId: traceId,
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: isCreateAction ?? false
            }
        }
    });
}
function $7b61ecd8bc5f3510$export$4d196ad3126dbf0c(args) {
    const { api: api, traceId: traceId, commandType: commandType, result: result } = args;
    const symptom = args.result === 'anomaly' ? args.symptom : undefined;
    const errorMessage = args.result === 'anomaly' ? args.errorMessage : undefined;
    const targetLocalId = args.result === 'anomaly' ? args.targetLocalId : undefined;
    const removedLocalIds = args.result === 'anomaly' ? args.removedLocalIds : undefined;
    const routed = result === 'anomaly' && symptom !== undefined && symptom !== 'no_document_change' ? (0, $d8e69355082f4231$export$a76b6d56e2272140)(symptom, 'orchestrator') : undefined;
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'toolCallResult',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            result: result,
            commandType: commandType,
            detectionLayer: 'orchestrator',
            traceId: traceId,
            ...symptom !== undefined && {
                symptom: symptom
            },
            ...routed !== undefined && {
                attribution: routed.attribution,
                confidence: routed.confidence
            },
            ...errorMessage !== undefined && {
                errorMessage: errorMessage
            },
            ...targetLocalId !== undefined && {
                scrubbedTargetLocalId: (0, $4QzBR.scrubStr)(targetLocalId)
            },
            ...removedLocalIds !== undefined && {
                scrubbedRemovedLocalIds: removedLocalIds.map((id)=>(0, $4QzBR.scrubStr)(id))
            }
        }
    });
}



var $c6GJD = parcelRequire("c6GJD");


var $e83av = parcelRequire("e83av");

function $19e1d609df7dfc8f$var$isNumber(value) {
    return typeof value === 'number';
}
function $19e1d609df7dfc8f$var$isRamp(value) {
    if (typeof value !== 'object' || value === null) return false;
    const v = value;
    return $19e1d609df7dfc8f$var$isNumber(v.initialDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.stepDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.flushDelaySec) && $19e1d609df7dfc8f$var$isNumber(v.growthFactor);
}
function $19e1d609df7dfc8f$var$getExperimentValue(key, defaultValue) {
    return (0, $c6GJD.default).getExperimentValue('platform-editor-ai-streaming-speed', key, defaultValue, {
        typeGuard: $19e1d609df7dfc8f$var$isNumber
    });
}
function $19e1d609df7dfc8f$export$9ea8217d5ec56f82(enabled) {
    if (enabled === false) return null;
    const backlogRampThreshold = $19e1d609df7dfc8f$var$getExperimentValue('backlogRampThreshold', 100);
    const initialCharsPerTick = $19e1d609df7dfc8f$var$getExperimentValue('initialCharsPerTick', 8);
    const maxCharsPerTick = $19e1d609df7dfc8f$var$getExperimentValue('maxCharsPerTick', 1000);
    const tickMs = $19e1d609df7dfc8f$var$getExperimentValue('tickMs', 41);
    const ramp = (0, $c6GJD.default).getExperimentValue('platform-editor-ai-streaming-speed', 'ramp', {
        initialDelaySec: 6,
        stepDelaySec: 3,
        flushDelaySec: 0.5,
        growthFactor: 1.5
    }, {
        typeGuard: $19e1d609df7dfc8f$var$isRamp
    });
    // These settings are copied from the ai plugins pacer -> platform/packages/editor/editor-plugin-ai/src/ui/utils/request/stream-flow-pacer.ts
    return new (0, $e83av.StreamFlowPacer)({
        backlogRampThreshold: backlogRampThreshold,
        initialCharsPerTick: initialCharsPerTick,
        maxCharsPerTick: maxCharsPerTick,
        ramp: ramp,
        tickMs: tickMs
    });
}





var $bI3mS = parcelRequire("bI3mS");








var $4pSml = parcelRequire("4pSml");





var $1xicG = parcelRequire("1xicG");


var $9Tkc6 = parcelRequire("9Tkc6");




const $127e6d5334706012$var$reset = '\x1b[0m';
const $127e6d5334706012$var$red = '\x1b[31m';
const $127e6d5334706012$var$magenta = '\x1b[35m';
const $127e6d5334706012$var$green = '\x1b[32m';
const $127e6d5334706012$var$blue = '\x1b[34m';
class $127e6d5334706012$export$21e6cc849c1dc1ab {
    add(log) {
        if ((0, $dh538.fg)('platform_editor_editor_debugging_panel')) {
            try {
                if (window.top?.__aifcDebuggerEnabled__) {
                    const { type: type, message: message } = log;
                    // eslint-disable-next-line no-console
                    console.log(`${$127e6d5334706012$var$magenta}[AIFC]:EditorStreamQueue${$127e6d5334706012$var$reset} ${type === 'Public' ? $127e6d5334706012$var$green : type === 'Queue' ? $127e6d5334706012$var$blue : $127e6d5334706012$var$red}${type}${$127e6d5334706012$var$reset} ${message}`, log);
                }
            } catch  {
            // Ignore cross-origin errors
            }
            this.logs.push({
                type: log.type,
                message: log.message,
                timestamp: log.timestamp
            });
            if (this.logs.length > this.MAX_LENGTH) this.logs.shift(); // Remove the oldest log to maintain a max log
        }
    }
    logPublic(message, data) {
        this.add({
            type: 'Public',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logError(message, data) {
        this.add({
            type: 'Error',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    logQueueState(message, data) {
        this.add({
            type: 'Queue',
            message: message,
            ...data,
            timestamp: new Date()
        });
    }
    // Current ADF at the time of logging so we can recreate the scenario
    getAdf() {
        if (!this.api) return undefined;
        let doc;
        this.api.core.actions.execute(({ tr: tr })=>{
            doc = tr.doc.toJSON();
            return null;
        });
        return doc;
    }
    getDebugInformation() {
        return {
            logs: this.logs,
            adf: this.getAdf(),
            selection: this.api?.selection?.actions.getSelectionFragment() ?? undefined,
            localIds: this.api?.selection?.actions.getSelectionLocalIds() ?? undefined
        };
    }
    constructor(api){
        this.api = api;
        this.logs = [];
        this.MAX_LENGTH = 100;
        if ((0, $dh538.fg)('platform_editor_editor_debugging_panel')) {
            if (window.top) try {
                window.top.__aifcEditorDebugData__ = ()=>this.getDebugInformation();
            } catch  {
            // Ignore cross-origin errors
            }
        }
    }
}






/**
 * Walk the document once and collect everything the analyzer needs:
 * `byLocalId` (top-level node text-length lookup), `totalNodesTopLevel`,
 * `totalNodesRecursive` (used by `noMeaningfulEffect`), `totalTextLength`,
 * and `attrFingerprints` (multiset for `attrSignaturesEqual`).
 */ function $66ee3dc21d67414d$var$snapshotDoc(doc) {
    const byLocalId = new Map();
    // Multiset (fingerprint → count) — catches compositional swaps with
    // matching unique fingerprints but different multiplicities.
    const attrFingerprints = new Map();
    // nested localId → top-level localId, built during the existing walk.
    const nestedToTopLevel = new Map();
    let totalNodesTopLevel = 0;
    let totalNodesRecursive = 0;
    let totalTextLength = 0;
    const content = doc.content;
    if (!Array.isArray(content)) return {
        byLocalId: byLocalId,
        totalNodesTopLevel: totalNodesTopLevel,
        totalNodesRecursive: totalNodesRecursive,
        totalTextLength: totalTextLength,
        attrFingerprints: attrFingerprints,
        nestedToTopLevel: nestedToTopLevel
    };
    for (const child of content){
        if (child === null || typeof child !== 'object') continue;
        totalNodesTopLevel += 1;
        const node = child;
        const localId = typeof node.attrs?.localId === 'string' ? node.attrs.localId : undefined;
        const { textLength: textLength, descendantCount: descendantCount } = $66ee3dc21d67414d$var$collectSubtreeMetrics(node, attrFingerprints, localId, nestedToTopLevel);
        // `descendantCount` includes the root node itself.
        totalNodesRecursive += descendantCount;
        totalTextLength += textLength;
        if (localId !== undefined) byLocalId.set(localId, {
            localId: localId,
            textLength: textLength
        });
    }
    return {
        byLocalId: byLocalId,
        totalNodesTopLevel: totalNodesTopLevel,
        totalNodesRecursive: totalNodesRecursive,
        totalTextLength: totalTextLength,
        attrFingerprints: attrFingerprints,
        nestedToTopLevel: nestedToTopLevel
    };
}
/**
 * Attrs excluded from the per-node fingerprint: `localId` (regenerated on
 * every streaming insert) and any `__`-prefixed key (editor-internal / UI-only
 * state, e.g. `__expanded`, `__autoSize`).
 */ function $66ee3dc21d67414d$var$isIgnoredAttr(key) {
    return key === 'localId' || key.startsWith('__');
}
/**
 * Stable string fingerprint of a node's identity: `type` + sorted filtered
 * `attrs` + sorted marks. Used by `attrSignaturesEqual`.
 */ function $66ee3dc21d67414d$var$buildNodeAttrFingerprint(node) {
    const type = typeof node.type === 'string' ? node.type : '?';
    const attrs = node.attrs;
    let attrsPart = '';
    if (attrs !== null && typeof attrs === 'object') {
        const keys = Object.keys(attrs).filter((k)=>!$66ee3dc21d67414d$var$isIgnoredAttr(k)).sort();
        if (keys.length > 0) {
            const pairs = [];
            for (const key of keys){
                const value = attrs[key];
                pairs.push(`${key}=${JSON.stringify(value)}`);
            }
            attrsPart = `|${pairs.join(',')}`;
        }
    }
    // Fold marks into the fingerprint (each mark contributes type + attrs).
    const marks = node.marks;
    let marksPart = '';
    if (Array.isArray(marks) && marks.length > 0) {
        const markStrings = [];
        for (const mark of marks)if (mark !== null && typeof mark === 'object') markStrings.push($66ee3dc21d67414d$var$buildNodeAttrFingerprint(mark));
        markStrings.sort();
        marksPart = `|marks=${markStrings.join(';')}`;
    }
    return `${type}${attrsPart}${marksPart}`;
}
/**
 * Estimated displayed-text contribution of atomic inline nodes that store
 * their user-visible text in attributes rather than child `text` nodes.
 *
 * Without this accounting the analyzer's `textCharacterDelta` would view
 * a legitimate user-requested conversion (e.g. "Notion" → status lozenge
 * labelled "Notion") as a large negative delta and incorrectly flag the
 * session with `unintendedTextModification`. See CCI-16817.
 *
 * The values returned are intentionally a coarse estimate — the analyzer
 * only consumes them as a `±1` tolerance proxy for "this region's text
 * length changed meaningfully". Sub-character precision is not required.
 *
 * Per-type rationale:
 * - `status`      — `attrs.text` is the lozenge label (e.g. "Notion").
 * - `date`        — rendered as a localised date badge; we have no access
 *                   to the formatter, so use a fixed `10` character estimate
 *                   (matches common short-date renderings like
 *                   "Jan 1, 2024").
 * - `mention`     — `attrs.text` (e.g. "@John Doe"); falls back to `0` if
 *                   absent (mention text is optional in the schema).
 * - `emoji`       — `attrs.text` (the rendered glyph) when present;
 *                   otherwise `attrs.shortName` (e.g. ":smile:").
 * - `inlineCard`  — renders as a link. URL-based cards expose
 *                   `attrs.url`; datasource-based cards (e.g. Jira
 *                   issue inline smart links) expose `attrs.data`
 *                   instead. We prefer `attrs.url` length when
 *                   present, otherwise fall back to
 *                   `JSON.stringify(attrs.data).length` so datasource
 *                   cards also contribute a non-zero text estimate
 *                   and don't re-trigger the
 *                   `unintendedTextModification` false-positive this
 *                   analyzer change is fixing. If neither attr is
 *                   present (malformed / unknown shape) we fall back
 *                   to a fixed `10` char estimate, mirroring `date`.
 * - `placeholder` — `attrs.text` is the placeholder string.
 */ function $66ee3dc21d67414d$var$getAtomicInlineNodeTextLength(type, attrs) {
    // `date`'s estimate is independent of attrs content — it must return
    // the fixed value even when attrs is absent or non-object. Handled
    // before the `attrs === undefined` guard so a malformed-ADF `date`
    // node (missing attrs) does not silently fall through to `0` and
    // re-trigger the very false positive this analyzer change is
    // fixing. Short-date renderings are typically ~10 chars
    // ("Jan 1, 2024"); the exact value isn't important — the goal is
    // to absorb the text-delta of the conversion, not to match what
    // the renderer ultimately displays.
    if (type === 'date') return 10;
    if (attrs === undefined) return 0;
    switch(type){
        case 'status':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        case 'mention':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        case 'emoji':
            {
                const text = attrs.text;
                if (typeof text === 'string' && text.length > 0) return text.length;
                const shortName = attrs.shortName;
                return typeof shortName === 'string' ? shortName.length : 0;
            }
        case 'inlineCard':
            {
                const url = attrs.url;
                if (typeof url === 'string' && url.length > 0) return url.length;
                // Datasource-based inline cards (e.g. Jira-issue inline
                // smart links) carry no `url` attr — their content lives
                // in `attrs.data`. Serialise it to JSON to get a coarse
                // non-zero estimate so a text-to-datasource-inlineCard
                // conversion doesn't reintroduce the very false positive
                // CCI-16817 is fixing. The exact length is unimportant —
                // the analyzer only needs a ±1-tolerance proxy.
                const data = attrs.data;
                if (data !== undefined && data !== null) try {
                    return JSON.stringify(data).length;
                } catch  {
                // Circular refs or unserialisable values fall
                // through to the fixed estimate below.
                }
                // Last-resort fixed estimate — matches the rationale used
                // for `date` (locale-rendered content with no plain text
                // in the ADF). Avoids returning 0 for malformed/unknown
                // inlineCard shapes that would otherwise re-trigger the
                // false positive.
                return 10;
            }
        case 'placeholder':
            {
                const text = attrs.text;
                return typeof text === 'string' ? text.length : 0;
            }
        default:
            return 0;
    }
}
/**
 * Single recursive walk: returns `textLength` + `descendantCount`,
 * accumulates fingerprints into the passed-in multiset, and — as a free
 * byproduct of the traversal — records every descendant node's `localId`
 * into `nestedToTopLevel` mapped to `topLevelLocalId`. O(N) per snapshot.
 *
 * `textLength` counts characters from both regular `text` nodes AND from
 * atomic inline nodes that store their displayed text in attributes
 * (e.g. `status.text`, `mention.text`). See `getAtomicInlineNodeTextLength`
 * for the per-type contribution and CCI-16817 for the rationale.
 *
 * `topLevelLocalId` is `undefined` for the top-level node itself (which is
 * the ancestor, not a descendant) and for top-level nodes that lack a
 * `localId` (unlabelled nodes can't be looked up anyway). Only descendants
 * of a labelled top-level node are added to the map.
 */ function $66ee3dc21d67414d$var$collectSubtreeMetrics(node, attrFingerprints, topLevelLocalId, nestedToTopLevel) {
    if (node === null || typeof node !== 'object') return {
        textLength: 0,
        descendantCount: 0
    };
    const n = node;
    let textLength = 0;
    let descendantCount = 1; // this node + its descendants below
    if (n.type === 'text' && typeof n.text === 'string') textLength += n.text.length;
    else if (typeof n.type === 'string') {
        const attrs = n.attrs !== null && typeof n.attrs === 'object' ? n.attrs : undefined;
        textLength += $66ee3dc21d67414d$var$getAtomicInlineNodeTextLength(n.type, attrs);
    }
    const fingerprint = $66ee3dc21d67414d$var$buildNodeAttrFingerprint(n);
    attrFingerprints.set(fingerprint, (attrFingerprints.get(fingerprint) ?? 0) + 1);
    if (Array.isArray(n.content)) for (const child of n.content){
        // Record the child's localId → top-level ancestor before recursing.
        // We do this here (at the child level, not the node level) so that
        // the top-level node itself is never added as its own descendant.
        if (topLevelLocalId !== undefined && child !== null && typeof child === 'object') {
            const childNode = child;
            const childLocalId = typeof childNode.attrs?.localId === 'string' ? childNode.attrs.localId : undefined;
            if (childLocalId !== undefined) nestedToTopLevel.set(childLocalId, topLevelLocalId);
        }
        const childMetrics = $66ee3dc21d67414d$var$collectSubtreeMetrics(child, attrFingerprints, topLevelLocalId, nestedToTopLevel);
        textLength += childMetrics.textLength;
        descendantCount += childMetrics.descendantCount;
    }
    return {
        textLength: textLength,
        descendantCount: descendantCount
    };
}
function $66ee3dc21d67414d$export$6cc6bb4851b62689(toolCalls) {
    const ids = new Set();
    for (const record of toolCalls){
        if (record.targetLocalId !== undefined) ids.add(record.targetLocalId);
        if (Array.isArray(record.targetLocalIds)) for (const id of record.targetLocalIds)ids.add(id);
    }
    return ids;
}
function $66ee3dc21d67414d$export$61c69a2d86d8e0fe(doc) {
    return $66ee3dc21d67414d$var$snapshotDoc(doc).nestedToTopLevel;
}
const $66ee3dc21d67414d$var$APPEND_INTENT_COMMANDS = new Set([
    'append',
    'appendNode',
    'appendNodeToEnd',
    'insertNodeAfter',
    'insertNodeBefore'
]);
const $66ee3dc21d67414d$var$REWRITE_INTENT_COMMANDS = new Set([
    'replaceNode',
    'setAttrs',
    'wrap',
    'wrapNode'
]);
const $66ee3dc21d67414d$var$REMOVE_INTENT_COMMANDS = new Set([
    'removeNode',
    'removeNodes',
    'moveNode'
]);
const $66ee3dc21d67414d$export$55aaf9e829063b88 = 0.7;
function $66ee3dc21d67414d$var$inferSessionIntent(toolCalls) {
    let hasAppend = false;
    let hasRewrite = false;
    let hasRemove = false;
    for (const call of toolCalls){
        if ($66ee3dc21d67414d$var$APPEND_INTENT_COMMANDS.has(call.commandType)) hasAppend = true;
        else if ($66ee3dc21d67414d$var$REWRITE_INTENT_COMMANDS.has(call.commandType)) hasRewrite = true;
        else if ($66ee3dc21d67414d$var$REMOVE_INTENT_COMMANDS.has(call.commandType)) hasRemove = true;
    }
    const categoryCount = (hasAppend ? 1 : 0) + (hasRewrite ? 1 : 0) + (hasRemove ? 1 : 0);
    if (categoryCount !== 1) // Either zero recognised categories (no signal) or two-or-more
    // (genuinely mixed — heuristic too noisy to apply).
    return 'mixed';
    if (hasAppend) return 'append';
    if (hasRewrite) return 'rewrite';
    return 'remove';
}
/**
 * Decide whether the top-level structural delta contradicts the inferred
 * intent. Uses the **top-level** node delta (not recursive) because the
 * heuristic targets root-shape contradictions and its `±1` tolerance was
 * tuned to the top-level scale.
 *
 * Threshold rationale:
 * - `'append'`  — any net removal (`topLevelNodeDelta < 0`) is a mismatch.
 *                  Net delta of `0` is allowed: a `replaceNode`-shaped
 *                  command can produce zero delta even with append intent
 *                  (this case is rare but not a contradiction).
 * - `'rewrite'` — `|topLevelNodeDelta| ≥ 2` is a mismatch. The `±1` window
 *                  absorbs single trailing whitespace / newline / paragraph
 *                  normalisation that can shift the top-level count by 1
 *                  without indicating a real structural change.
 * - `'remove'`  — `topLevelNodeDelta ≥ 0` is a mismatch (the apply layer
 *                  didn't actually remove anything despite remove intent).
 */ /**
 * Returns true when the session's inferred intent contradicts the observed
 * structural delta — a heuristic signal that something unexpected happened.
 *
 * @param intent - Inferred from the mix of tool-call types in the session.
 * @param topLevelNodeDelta - post minus pre top-level node count.
 * @param totalNodeDelta - post minus pre recursive node count (CCI-16969 P1).
 * @param anyAffectedLocalIdDisappearedPostApply - true when a targeted top-level
 *   node is absent from the post-doc (CCI-16969 P2): a replaceNode that expands
 *   one container into many top-level nodes produces a large topLevelNodeDelta
 *   that is intentional, not anomalous.
 */ function $66ee3dc21d67414d$var$detectIntentEffectMismatch(intent, topLevelNodeDelta, totalNodeDelta, anyAffectedLocalIdDisappearedPostApply) {
    switch(intent){
        case 'append':
            return topLevelNodeDelta < 0;
        case 'rewrite':
            // CCI-16969 P2: when the targeted node itself disappeared from the
            // post-doc, the expansion is intentional (e.g. bulletList → headed
            // sections, expand → inline content). Skip the topLevelDelta check.
            if (anyAffectedLocalIdDisappearedPostApply) return false;
            return Math.abs(topLevelNodeDelta) >= 2;
        case 'remove':
            // CCI-16969 P1: removeNodes targeting nested nodes (e.g. tableRows
            // inside a table) leaves topLevelNodeDelta at 0 even though content
            // was legitimately removed. Use recursive totalNodeDelta instead,
            // which correctly captures nested removals.
            return totalNodeDelta >= 0;
        case 'mixed':
        default:
            return false;
    }
}
function $66ee3dc21d67414d$export$9aa9db1056f785bc({ preSessionAdf: preSessionAdf, postSessionAdf: postSessionAdf, toolCalls: toolCalls, selectionLocalIds: selectionLocalIds }) {
    const pre = $66ee3dc21d67414d$var$snapshotDoc(preSessionAdf);
    const post = $66ee3dc21d67414d$var$snapshotDoc(postSessionAdf);
    const affectedLocalIds = $66ee3dc21d67414d$export$6cc6bb4851b62689(toolCalls);
    if (Array.isArray(selectionLocalIds)) for (const id of selectionLocalIds)affectedLocalIds.add(id);
    // For any targeted localId that belongs to a nested node
    // (e.g. a paragraph inside a table cell), also add the top-level
    // ancestor's localId to `affectedLocalIds`. Without this, the
    // modification-detection loop below flags the top-level container
    // (table, panel, expand, etc.) as "unintentionally modified" even
    // though the change was entirely within the tool call's intended target.
    //
    // `pre.nestedToTopLevel` is built as a free byproduct of the
    // `snapshotDoc` walk above — no additional document traversal.
    // Snapshot the set before iterating so that newly added ancestor IDs are
    // not re-examined. Mutating a Set during for-of is valid JS (new entries
    // ARE visited), but snapshotting makes the intent explicit and removes the
    // dependency on that spec detail.
    for (const targetId of [
        ...affectedLocalIds
    ]){
        const topLevelAncestorId = pre.nestedToTopLevel.get(targetId);
        if (topLevelAncestorId !== undefined) affectedLocalIds.add(topLevelAncestorId);
    }
    /**
   * True when at least one targeted localId is absent from the post-doc.
   *
   * This happens when `replaceNode` (or similar) creates replacement nodes
   * with fresh localIds — the targeted node has been genuinely replaced, not
   * silently dropped. Using this guard prevents two classes of false positives:
   *
   * - CCI-16968: `noMeaningfulEffect` fires because `totalNodeDelta === 0`
   *   and `|textCharacterDelta| <= 1`, even though real content was rewritten
   *   (the targeted node's content is now under a different localId).
   *
   * - CCI-16969 (P2): `intentEffectMismatch` fires for 'rewrite' intent when
   *   `|topLevelNodeDelta| >= 2` because one container was replaced by many
   *   top-level nodes (e.g. a bulletList expanded into headed sections). The
   *   large top-level delta is intentional — the targeted node is gone and new
   *   nodes took its place.
   *
   * Known limitation: `pre.byLocalId` contains only top-level nodes, so this
   * check does not fire when a `replaceNode` targets a nested node (e.g. a
   * paragraph inside a table cell) and produces fresh localIds. In practice
   * the other `noMeaningfulEffect` conditions (`|textCharacterDelta| <= 1`)
   * rarely hold simultaneously for nested rewrites, so the gap is low-impact.
   */ const anyAffectedLocalIdDisappearedPostApply = [
        ...affectedLocalIds
    ].some((id)=>pre.byLocalId.has(id) && !post.byLocalId.has(id));
    // CCI-16970: replaceDoc replaces the entire document with HTML-streamed
    // content that goes through an HTML→ADF parser, which always assigns fresh
    // localIds to every node. As a result:
    //   • All pre-session localIds disappear from the post-doc, regardless of
    //     how much content the model actually preserved.
    //   • `affectedLocalIds` is always empty for replaceDoc (it has no
    //     `targetLocalId`).
    // Running the localId-based removal loop below would therefore flag every
    // pre-doc node as "unintendedly removed" on every replaceDoc session —
    // a guaranteed false positive even when the model faithfully rewrote the
    // entire document.
    //
    // Instead, for replaceDoc sessions we skip the localId loops entirely and
    // use a proportional text-loss check: the model genuinely truncated the
    // document only when the post-doc retains less than 70% of the pre-doc
    // text length.
    //
    // Threshold validation: tested against 11 production examples —
    //   7 false positives all had ≥96% text retention (well above 70%)
    //   4 true positives all had ≤52% text retention (well below 70%)
    // A 70% threshold cleanly separates the two populations.
    const hasReplaceDoc = (0, $dh538.fg)('platform_editor_ai_normalized_telemetry_patch1') && toolCalls.some((tc)=>tc.commandType === 'replaceDoc');
    let removedNodeCount = 0;
    let unintendedRegionRemoved = false;
    if (hasReplaceDoc) // Proportional text-loss check for replaceDoc sessions.
    // Only meaningful when the pre-doc had text to begin with; empty
    // documents are silently skipped to avoid division-by-zero edge cases.
    {
        if (pre.totalTextLength > 0 && post.totalTextLength < pre.totalTextLength * $66ee3dc21d67414d$export$55aaf9e829063b88) {
            unintendedRegionRemoved = true;
            // Use the pre-doc top-level count so dashboards can see how many
            // nodes were effectively dropped (the post-doc nodes are all new).
            removedNodeCount = pre.totalNodesTopLevel;
        }
    } else {
        for (const [localId] of pre.byLocalId)if (!post.byLocalId.has(localId)) {
            removedNodeCount += 1;
            if (!affectedLocalIds.has(localId)) unintendedRegionRemoved = true;
        }
        // Account for unlabelled top-level nodes (no `localId` attr).
        // These can't be targeted by any tool call (every command keys off
        // `localId`), so a net drop in unlabelled-node count is by definition
        // unintended collateral damage. Tracking it here keeps
        // `removedNodeCount` consistent with `totalNodeDelta` and surfaces
        // the most clearly-anomalous removals on the `unintendedRegionRemoved`
        // flag.
        //
        // Known limitation: an equal-count swap (one unlabelled node removed
        // AND one unlabelled node added in the same session) is invisible to
        // this counter. Detecting it would require position/content matching,
        // which the analyzer intentionally avoids for cost reasons. Net delta
        // is sufficient for current dashboard needs.
        // Unlabelled-node accounting uses the top-level count: only top-level
        // nodes are keyed in `byLocalId`, so the comparison must be against
        // `totalNodesTopLevel` to keep the subtraction meaningful.
        const preUnlabelledCount = pre.totalNodesTopLevel - pre.byLocalId.size;
        const postUnlabelledCount = post.totalNodesTopLevel - post.byLocalId.size;
        if (postUnlabelledCount < preUnlabelledCount) {
            const unlabelledRemoved = preUnlabelledCount - postUnlabelledCount;
            removedNodeCount += unlabelledRemoved;
            unintendedRegionRemoved = true;
        }
    }
    // Modification detection uses total text-length inequality as a cheap
    // proxy for "this node's text changed". A `±1` character tolerance is
    // applied per node to absorb ProseMirror normalisation artefacts
    // (single trailing whitespace, newline, punctuation injection/strip
    // on block close) — same rationale as the session-wide
    // `noMeaningfulEffect` derivation. Same-length rewrites are still a
    // silent false negative — see the JSDoc on
    // `OutcomeAnalysis.unintendedRegionModified` for the known limitation.
    let unintendedRegionModified = false;
    for (const [localId, preRecord] of pre.byLocalId){
        const postRecord = post.byLocalId.get(localId);
        if (postRecord === undefined) continue;
        if (Math.abs(preRecord.textLength - postRecord.textLength) > 1 && !affectedLocalIds.has(localId)) {
            unintendedRegionModified = true;
            break;
        }
    }
    // Recursive count for `noMeaningfulEffect` — catches depth-only changes
    // (blank column added, empty rows removed, nested reorders). See CCI-16816.
    const totalNodeDelta = post.totalNodesRecursive - pre.totalNodesRecursive;
    // Top-level count for `intentEffectMismatch` — the heuristic's ±1
    // tolerance was tuned to top-level scale; recursive would be too noisy.
    const topLevelNodeDelta = post.totalNodesTopLevel - pre.totalNodesTopLevel;
    const intent = $66ee3dc21d67414d$var$inferSessionIntent(toolCalls);
    const intentEffectMismatch = $66ee3dc21d67414d$var$detectIntentEffectMismatch(intent, topLevelNodeDelta, totalNodeDelta, anyAffectedLocalIdDisappearedPostApply);
    // Multiset equality on per-node fingerprints. Catches attribute-only
    // changes and compositional swaps that node count + text length miss.
    let attrSignaturesEqual = pre.attrFingerprints.size === post.attrFingerprints.size;
    if (attrSignaturesEqual) {
        for (const [fingerprint, preCount] of pre.attrFingerprints)if (post.attrFingerprints.get(fingerprint) !== preCount) {
            attrSignaturesEqual = false;
            break;
        }
    }
    return {
        totalNodeDelta: totalNodeDelta,
        removedNodeCount: removedNodeCount,
        textCharacterDelta: post.totalTextLength - pre.totalTextLength,
        affectedLocalIds: affectedLocalIds,
        unintendedRegionModified: unintendedRegionModified,
        unintendedRegionRemoved: unintendedRegionRemoved,
        protectedContentRemoved: false,
        intentEffectMismatch: intentEffectMismatch,
        attrSignaturesEqual: attrSignaturesEqual,
        anyAffectedLocalIdDisappearedPostApply: anyAffectedLocalIdDisappearedPostApply
    };
}


/**
 * Classifies an error caught by the orchestrator's apply pipeline into one of
 * three normalized symptom strings, used by `fireToolCallApplyFailed` to drive
 * the shared `attributeError` routing table.
 *
 * The classification is intentionally conservative: definitive ProseMirror
 * `ReplaceError` instances and message-pattern-matched ADF schema validation
 * errors are routed to specific symptoms; anything ambiguous falls back to the
 * generic `apply_failed`, which routes to `unknown`/`low` so dashboards do not
 * incorrectly attribute fault to either layer.
 *
 * Pure function — no side effects, no logging, no external dependencies.
 */ /**
 * Patterns thrown by `prosemirror-model`'s `Node.fromJSON` /
 * `Mark.fromJSON` / `Fragment.fromJSON` when the incoming ADF describes a
 * node-type, mark-type, content-type, or shape that the local schema cannot
 * accept. These are caused by the *incoming* model output, not by the
 * orchestrator's apply logic — so they route to backend-quality attribution.
 *
 * See prosemirror-model/dist/index.cjs throw-sites for the canonical list.
 */ /* eslint-disable require-unicode-regexp -- The orchestrator's tsconfig
   targets ES5, which does not support the `u` flag in regex literals
   (TS1501). None of these patterns use Unicode-specific features, so
   the flag is not needed at runtime. */ const $c9fd3f5978c61ad6$var$ADF_SCHEMA_ERROR_PATTERNS = [
    /^Invalid content for node type/,
    /^There is no (?:node|mark) type/,
    /^Invalid mark data for /,
    /^Empty text nodes are not allowed/,
    /^Invalid input for (?:Mark|Node|Fragment|Slice)\.fromJSON/,
    /^Invalid collection of marks for node /,
    /^Invalid text node in JSON/
];
/**
 * `RangeError` messages emitted by `prosemirror-model` and
 * `prosemirror-transform` from transaction-mechanics throw sites
 * (positions, replace/wrap/lift/join validation, slice resolution).
 *
 * Anything matching this list is a frontend apply-logic concern.
 *
 * Anything that is a `RangeError` but does NOT match either this list
 * OR the ADF schema list above is treated as ambiguous — native JS
 * also throws `RangeError` for non-PM reasons (e.g. "Maximum call
 * stack size exceeded", "Invalid array length", `Intl` constructor
 * failures, third-party libraries) and we deliberately route those
 * to `apply_failed` (`unknown`/`low`) so dashboards do not
 * misattribute them to either layer.
 */ const $c9fd3f5978c61ad6$var$PM_TRANSACTION_ERROR_PATTERNS = [
    /^Position [0-9]+ out of range/,
    /^Inserted content deeper than insertion position/,
    /^Cannot (?:insert|replace|delete|wrap|join|split|lift|unwrap)/i,
    /^Selected node can't be replaced by content/,
    /can't (?:join|wrap|fit|lift|split)/i,
    /^Removing non-flat range/,
    /^Cannot find a valid cursor position/,
    /^Wrap (?:depth|range) /,
    /^Lifted range/,
    /^Tried to (?:lift|wrap|join|step)/,
    /^Step result has /,
    /^Invalid (?:position|step|content) for /
];
function $c9fd3f5978c61ad6$export$e36a42623b7e8456(error) {
    if (!(error instanceof Error)) return {
        symptom: 'apply_failed'
    };
    // `ReplaceError` is exported by prosemirror-model and extends `Error`.
    // We match by `.name === 'ReplaceError'` rather than `instanceof` to
    // avoid a runtime dependency on prosemirror-model and to remain robust
    // across multiple loaded copies of the module.
    if (error.name === 'ReplaceError') return {
        symptom: 'apply_failed_pm_error'
    };
    if (error instanceof RangeError) {
        for (const pattern of $c9fd3f5978c61ad6$var$ADF_SCHEMA_ERROR_PATTERNS){
            if (pattern.test(error.message)) return {
                symptom: 'apply_failed_adf_schema_error'
            };
        }
        for (const pattern of $c9fd3f5978c61ad6$var$PM_TRANSACTION_ERROR_PATTERNS){
            if (pattern.test(error.message)) return {
                symptom: 'apply_failed_pm_error'
            };
        }
    // Unmatched `RangeError` — could be a JS-engine error (e.g.
    // "Maximum call stack size exceeded"), an `Intl`/Date/Number
    // validation throw, or a third-party library throw. Route to
    // `apply_failed` so dashboards stay conservative and do not
    // misattribute non-PM faults to the apply layer.
    }
    return {
        symptom: 'apply_failed'
    };
}



/**
 * The set of command types whose targeted subtree is genuinely
 * removed from the doc. For these, descendant `localId`s of the
 * target are also expected to disappear from the post-apply snapshot
 * and must be added to the exclusion set so they don't fire
 * `unexpected_node_removal` spuriously.
 *
 * Commands like `moveNode`, `wrap`, and `wrapNode` are deliberately
 * NOT in this set: they relocate/nest the targeted subtree but the
 * descendants remain in the doc. If a descendant of a moved or
 * wrapped node disappears, that IS a genuine anomaly worth surfacing
 * — so we leave it to `unexpected_node_removal` to fire.
 */ const $74e3ba48f2f51a7a$var$COMMAND_TYPES_THAT_REMOVE_SUBTREE = new Set([
    'removeNode',
    'removeNodes',
    'replaceNode'
]);
function $74e3ba48f2f51a7a$export$30ebe6cd1aac119d(command, preApplyDoc) {
    const ids = new Set();
    switch(command.type){
        case 'removeNode':
        case 'moveNode':
        case 'replaceNode':
            ids.add(command.localId);
            break;
        case 'removeNodes':
            for (const id of command.localIds)ids.add(id);
            break;
        case 'wrap':
        case 'wrapNode':
            ids.add(command.localId);
            break;
        default:
            break;
    }
    // Expand each direct target to include its descendant `localId`s
    // from the pre-apply doc, but ONLY for commands whose intent is to
    // remove the targeted subtree entirely. For moveNode/wrap/wrapNode
    // the subtree is preserved (relocated or nested), so its
    // descendants must still appear in the post-apply snapshot — if
    // they don't, that is a genuine anomaly we want to surface.
    if (preApplyDoc !== undefined && ids.size > 0 && $74e3ba48f2f51a7a$var$COMMAND_TYPES_THAT_REMOVE_SUBTREE.has(command.type)) {
        // Snapshot the direct targets up-front because we're about to
        // mutate `ids` while iterating.
        const directTargets = Array.from(ids);
        for (const targetId of directTargets){
            const result = (0, $009cb14caceb5527$export$1bd732ee2c8aaeb)(preApplyDoc, targetId);
            if (!result) continue;
            result.node.descendants((descendant)=>{
                const descendantLocalId = descendant.attrs?.localId;
                if (typeof descendantLocalId === 'string' && descendantLocalId.length > 0) ids.add(descendantLocalId);
                return true;
            });
        }
    }
    return ids;
}






function $a561bee60676cdb0$export$c48ec1bf46060d54(commandsToProcess) {
    const mergedCommands = [];
    for (const command of commandsToProcess){
        const lastCommand = mergedCommands[mergedCommands.length - 1];
        // Check if we can merge the current command with the last one
        if (command.type === 'streamCommand' && lastCommand && lastCommand.type === 'streamCommand' && command.actionId === lastCommand.actionId) lastCommand.chunk = command.chunk;
        else // Otherwise, just push the command to mergedCommands
        mergedCommands.push(command);
    }
    return mergedCommands;
}


function $d96f5329afc42f98$export$6c44330c7facd24b(promise, options) {
    const { timeout: timeout, onTimeout: onTimeout, onCleanup: onCleanup } = options;
    let timeoutHandle;
    let timeoutResolve;
    let isCompleted = false;
    // Function to start/restart the timeout
    const resetTimeout = ()=>{
        if (isCompleted) return;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        timeoutHandle = setTimeout(()=>{
            if (!isCompleted) {
                onTimeout();
                timeoutResolve?.();
            }
        }, timeout);
    };
    const timeoutPromise = new Promise((resolve)=>{
        timeoutResolve = resolve;
    });
    resetTimeout();
    // Race the original promise against the timeout
    const wrappedPromise = Promise.race([
        promise,
        timeoutPromise
    ]).finally(()=>{
        isCompleted = true;
        if (timeoutHandle) clearTimeout(timeoutHandle);
        onCleanup?.();
    });
    return {
        resetTimeout: resetTimeout,
        promise: wrappedPromise
    };
}



var $6jPem = parcelRequire("6jPem");

function $76ccf77dd7d8e539$export$ab173b3d1046c711(adfResponse, type, schema) {
    if (!adfResponse || type !== 'insertNodeAfter') return {
        updatedResponse: adfResponse,
        localId: undefined
    };
    const indexMap = [];
    let newLocalId = crypto.randomUUID();
    const depthToCheckAgainst = 0;
    // First pass just to get the node to update
    (0, $6jPem.traverse)(adfResponse, {
        any: (_n, _p, index, depth)=>{
            if (depth === depthToCheckAgainst) indexMap.push(index);
        }
    });
    // Update the localId of the last node
    let localIdUpdated = false;
    const newAdfResponse = (0, $6jPem.traverse)({
        ...adfResponse
    }, {
        any: (node, _p, index, depth)=>{
            if (depth === depthToCheckAgainst && indexMap[indexMap.length - 1] === index && !!schema?.nodes[node.type]?.spec?.attrs?.localId) {
                localIdUpdated = true;
                if (!!node?.attrs?.localId) newLocalId = node?.attrs?.localId;
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        localId: newLocalId
                    }
                };
            }
        }
    });
    return {
        updatedResponse: newAdfResponse ? newAdfResponse : adfResponse,
        localId: localIdUpdated ? newLocalId : undefined
    };
}






var $ks2lK = parcelRequire("ks2lK");

const $d4e9e31242338f4c$export$9e6d85a71b01d30 = (api)=>()=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let selection;
            if ((0, $bI3mS.isEmptyDocument)(tr.doc)) selection = (0, $ks2lK.Selection).atEnd(tr.doc);
            else {
                const $pos = tr.doc.resolve(tr.doc.content.size);
                tr.insert($pos.pos, tr.doc.type.schema.nodes.paragraph.create());
                selection = (0, $ks2lK.TextSelection).create(tr.doc, $pos.pos + 1);
            }
            if (!selection) throw new Error('Failed to create selection');
            api?.aiExperience?.actions.tagAsAIStreamingTransformation(tr);
            tr.setSelection(selection).scrollIntoView();
            return tr;
        });
    };






var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $9MzzS = parcelRequire("9MzzS");





const $c2ca03eb7fbe6fb1$var$nodeNamesToSkipInsertParagraph = [
    'listItem',
    'taskItem',
    'decisionItem'
];
const $c2ca03eb7fbe6fb1$export$d4ccce03e5361e34 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node, parent: parent })=>{
                if (node.type.name === 'tableRow' && parent) {
                    const tableMap = (0, $LmqWp.TableMap).get(parent);
                    const $pos = tr.doc.resolve(pos);
                    const tableStart = $pos.start($pos.depth);
                    const rect = tableMap.findCell(pos - tableStart + 1);
                    const tableContext = {
                        map: tableMap,
                        table: parent,
                        tableStart: tableStart
                    };
                    (0, $9MzzS.addRow)(tr, tableContext, rect.bottom);
                    const $newPos = tr.doc.resolve(pos);
                    const table = $newPos.node($newPos.depth);
                    const newTableMap = (0, $LmqWp.TableMap).get(table);
                    // Not considering merged cells
                    const cells = newTableMap.mapByRow[rect.bottom];
                    const selection = (0, $7XFGZ.CellSelection).rowSelection(tr.doc.resolve(cells[0] + tableStart), tr.doc.resolve(cells[cells.length - 1] + tableStart));
                    tr.setSelection(selection).scrollIntoView();
                } else if ($c2ca03eb7fbe6fb1$var$nodeNamesToSkipInsertParagraph.includes(node.type.name) && parent) {
                    /**
						 * Not creating new paragraph node when inserting node after list item.
						 * Because when inserting new list item, it will add new list item in new list.
						 */ const selection = (0, $ks2lK.TextSelection).create(tr.doc, pos + node.nodeSize);
                    tr.setSelection(selection).scrollIntoView();
                } else {
                    let insertPos = Math.min(pos + node.nodeSize, tr.doc.content.size);
                    while(insertPos < tr.doc.content.size){
                        const $pos = tr.doc.resolve(insertPos);
                        let nextNode = null;
                        // For top-level nodes (depth 0 = document), check document children directly
                        // For nested nodes, use nodeAfter which works at higher depths
                        if ($pos.depth === 0) {
                            // At document root level, find the next top-level child
                            const childIndex = $pos.indexAfter(0);
                            if (childIndex < tr.doc.childCount) nextNode = tr.doc.child(childIndex);
                        } else // For nested structures, nodeAfter works correctly
                        nextNode = $pos.nodeAfter;
                        // Skip nodes without localId (from previous AI insertions)
                        // This prevents sequential insertions from overriding each other
                        if (nextNode && !nextNode.attrs.localId) insertPos += nextNode.nodeSize;
                        else break;
                    }
                    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') insertPos--;
                    if ((0, $1oCLl.expValEquals)('platform_editor_ai_fix_insert_after_selection', 'isEnabled', true)) {
                        if (insertPos + 1 <= tr.doc.content.size) tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                        const selection = (0, $ks2lK.TextSelection).create(tr.doc, Math.min(insertPos + 1, tr.doc.content.size));
                        tr.setSelection(selection).scrollIntoView();
                    } else {
                        tr.insert(insertPos, tr.doc.type.schema.nodes.paragraph.create());
                        const selection = (0, $ks2lK.TextSelection).create(tr.doc, insertPos + 1);
                        tr.setSelection(selection).scrollIntoView();
                    }
                }
            }, // Inserting after should always look for the last node with a matching localid. This will ensure that we
            // always insert AFTER.
            true);
        });
    };






const $221cde67568b69a7$export$1226208ece997066 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos })=>{
                const selection = new (0, $ks2lK.TextSelection)(tr.doc.resolve(pos));
                tr.setSelection(selection).scrollIntoView();
            });
        });
    };


















const $c7b498e2e9179941$var$doesNodeContain = ({ start: start, nodeSize: nodeSize }, pos)=>pos > start && pos < start + nodeSize;
const $c7b498e2e9179941$var$unsupportedTableStructureNodeTypes = new Set([
    'tableRow',
    'tableCell',
    'tableHeader'
]);
const $c7b498e2e9179941$var$isUnsupportedTableStructureNode = (nodeTypeName)=>$c7b498e2e9179941$var$unsupportedTableStructureNodeTypes.has(nodeTypeName);
const $c7b498e2e9179941$var$isValidRelationship = (relationship)=>relationship === 'before' || relationship === 'after';
const $c7b498e2e9179941$var$getFragmentTypes = (node)=>node.content.content.map((child)=>child.type.name);
const $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics = ({ api: api, reason: reason, sourceNodeType: sourceNodeType, anchorNodeType: anchorNodeType, sourceParentNodeType: sourceParentNodeType, destinationParentNodeType: destinationParentNodeType, parentNodeType: parentNodeType, fragments: fragments })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).INVALID_COMMAND_FOUND,
        actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            success: false,
            repaired: false,
            errorMessage: 'moveNodeValidationFailed',
            validationReason: reason,
            sourceNodeType: sourceNodeType,
            anchorNodeType: anchorNodeType,
            sourceParentNodeType: sourceParentNodeType,
            destinationParentNodeType: destinationParentNodeType,
            parentNodeType: parentNodeType,
            fragments: fragments
        }
    });
};
const $c7b498e2e9179941$export$731ead7592859425 = (api)=>(command)=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_ai_move_node', 'isEnabled', true)) return false;
        return api.core.actions.execute(({ tr: tr })=>{
            const reportMissingLocalId = (localId)=>{
                // `findNodeByLocalId` owns the existing LOCAL_ID_NOT_FOUND analytics payload,
                // so we intentionally re-run it on miss even though we already did a pure lookup.
                (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, localId, ()=>{});
            };
            const nodeToMove = (0, $009cb14caceb5527$export$1bd732ee2c8aaeb)(tr.doc, command.localId);
            if (!nodeToMove) {
                reportMissingLocalId(command.localId);
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'sourceNotFound'
                });
                return null;
            }
            const anchorNode = (0, $009cb14caceb5527$export$1bd732ee2c8aaeb)(tr.doc, command.anchorLocalId);
            if (!anchorNode) {
                reportMissingLocalId(command.anchorLocalId);
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'anchorNotFound',
                    sourceNodeType: nodeToMove.node.type.name
                });
                return null;
            }
            if (command.localId === command.anchorLocalId) {
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'sameNode',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if (!$c7b498e2e9179941$var$isValidRelationship(command.relationship)) {
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidRelationship',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if ($c7b498e2e9179941$var$isUnsupportedTableStructureNode(nodeToMove.node.type.name) || $c7b498e2e9179941$var$isUnsupportedTableStructureNode(anchorNode.node.type.name)) {
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'unsupportedTableStructure',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            if ($c7b498e2e9179941$var$doesNodeContain({
                start: nodeToMove.pos,
                nodeSize: nodeToMove.node.nodeSize
            }, anchorNode.pos)) {
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'anchorInsideSource',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name
                });
                return null;
            }
            const $sourcePos = tr.doc.resolve(nodeToMove.pos);
            const sourceIndex = $sourcePos.index();
            if (!$sourcePos.parent.canReplace(sourceIndex, sourceIndex + 1, (0, $5SAOw.Fragment).empty)) {
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidSourceParent',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name,
                    sourceParentNodeType: $sourcePos.parent.type.name,
                    parentNodeType: $sourcePos.parent.type.name
                });
                return null;
            }
            const slice = tr.doc.slice(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize, false);
            const insertPos = command.relationship === 'before' ? anchorNode.pos : anchorNode.pos + anchorNode.node.nodeSize;
            const validationTransform = new (0, $aXG5V.Transform)(tr.doc);
            validationTransform.delete(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize);
            const mappedInsertPos = validationTransform.mapping.map(insertPos);
            const $mappedInsertPos = validationTransform.doc.resolve(mappedInsertPos);
            const insertIndex = $mappedInsertPos.index();
            if (!$mappedInsertPos.parent.canReplace(insertIndex, insertIndex, slice.content)) {
                $c7b498e2e9179941$var$fireInvalidMoveNodeAnalytics({
                    api: api,
                    reason: 'invalidDestination',
                    sourceNodeType: nodeToMove.node.type.name,
                    anchorNodeType: anchorNode.node.type.name,
                    destinationParentNodeType: $mappedInsertPos.parent.type.name,
                    parentNodeType: $mappedInsertPos.parent.type.name,
                    fragments: $c7b498e2e9179941$var$getFragmentTypes(slice.content.firstChild ?? nodeToMove.node)
                });
                return null;
            }
            api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                isFinal: true
            });
            tr.delete(nodeToMove.pos, nodeToMove.pos + nodeToMove.node.nodeSize);
            const appliedInsertPos = tr.mapping.map(insertPos);
            tr.replace(appliedInsertPos, appliedInsertPos, slice);
            if ((0, $ks2lK.NodeSelection).isSelectable(nodeToMove.node)) tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, appliedInsertPos));
            else tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(appliedInsertPos)));
            tr.scrollIntoView();
            return tr;
        });
    };



const $32edc2d4989fa97a$export$9a6ccf2338830d60 = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
                tr.delete(pos, pos + node.nodeSize).scrollIntoView();
            });
        });
    };



const $5938e2deecbf4aa1$export$b932a8906dc70a6a = (api)=>(command)=>{
        const removeNode = (0, $32edc2d4989fa97a$export$9a6ccf2338830d60)(api);
        for (const localId of command.localIds)removeNode({
            type: 'removeNode',
            localId: localId
        });
        return true;
    };









const $909a39db2548dac9$export$8077407ea1dae01f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            return (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ pos: pos, node: node })=>{
                let selection = null;
                if ((0, $ks2lK.NodeSelection).isSelectable(node)) selection = (0, $ks2lK.NodeSelection).create(tr.doc, pos);
                else {
                    const role = node.type.spec.tableRole;
                    if (role === 'cell' || role === 'header_cell') selection = (0, $7XFGZ.CellSelection).create(tr.doc, pos);
                    else if (role === 'row') {
                        // There's always a cell after the row
                        const $cell = tr.doc.resolve(pos + 1);
                        selection = (0, $7XFGZ.CellSelection).rowSelection($cell, $cell, true);
                    } else {
                        const $pos = tr.doc.resolve(pos);
                        const $end = tr.doc.resolve(pos + node.nodeSize);
                        selection = (0, $ks2lK.TextSelection).between($pos, $end);
                    }
                }
                if (selection) tr.setSelection(selection).scrollIntoView();
            });
        });
    };








const $6f8f17a8a71e25be$export$4e08a85ccc8f26d0 = (api)=>(_command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            if ((0, $dh538.fg)('platform_editor_ai_replace_doc_use_all_selection')) return tr.setSelection(new (0, $ks2lK.AllSelection)(tr.doc)).scrollIntoView();
            const $start = tr.doc.resolve(0);
            const $end = tr.doc.resolve(tr.doc.content.size);
            return tr.setSelection((0, $ks2lK.TextSelection).between($start, $end)).scrollIntoView();
        });
    };






const $834280e13ce7e027$var$getValidAttributes = (attrs, nodeSpec)=>{
    const validAttrs = {};
    for(const key in attrs)if (nodeSpec.attrs?.hasOwnProperty(key)) validAttrs[key] = attrs[key];
    return validAttrs;
};
const $834280e13ce7e027$export$3c4e918a3d6ca42f = (api)=>(command)=>{
        return api.core.actions.execute(({ tr: tr })=>{
            let shouldExecute = false;
            (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                if (node) {
                    const attrs = command.attrs;
                    if (!attrs || typeof attrs !== 'object') return;
                    const validAttrs = $834280e13ce7e027$var$getValidAttributes(attrs, node.type.spec);
                    node.type.spec.attrs;
                    api.aiExperience?.actions.tagAsAIStreamingTransformation(tr, {
                        isFinal: true
                    });
                    tr.setNodeMarkup(pos, node.type, {
                        ...node.attrs,
                        ...validAttrs
                    });
                    tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(pos)));
                    shouldExecute = true;
                }
            });
            return shouldExecute ? tr : null;
        });
    };



var $3KVX0 = parcelRequire("3KVX0");


var $4rpi6 = parcelRequire("4rpi6");





var $cX9xt = parcelRequire("cX9xt");














const $f350631d999bc8ec$var$panelTypes = new (0, $3KVX0.default)((0, $4rpi6.panel).props.attrs.props.panelType.values);
function $f350631d999bc8ec$var$wrapChild(fragment, type, attrs) {
    if (!fragment.firstChild) return null;
    const wrappingNodeTypes = type.contentMatch.findWrapping(fragment.firstChild.type);
    let currentChildNodes = null;
    if (wrappingNodeTypes) {
        currentChildNodes = fragment.content;
        for(let i = wrappingNodeTypes.length - 1; i >= 0; i--){
            const wrappingNodeType = wrappingNodeTypes[i];
            const nextChildNode = wrappingNodeType.createAndFill(null, currentChildNodes);
            if (nextChildNode) currentChildNodes = [
                nextChildNode
            ];
            else {
                currentChildNodes = null;
                break;
            }
        }
    }
    if (currentChildNodes) return type.createAndFill(attrs, currentChildNodes);
    return null;
}
function $f350631d999bc8ec$var$findPosForNode(node, $to) {
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        if (ancestor.type.contentMatch.matchType(node.type)) return $to.after(depth + 1);
    }
    return null;
}
function $f350631d999bc8ec$var$getAncestorTypes($to) {
    const ancestors = [];
    for(let depth = $to.depth; depth >= 0; depth--){
        const ancestor = $to.node(depth);
        ancestors.push(ancestor.type.name);
    }
    return ancestors;
}
function $f350631d999bc8ec$var$getChildTypes(fragment) {
    return fragment.content.map((node)=>node.type.name);
}
const $f350631d999bc8ec$export$2c6212a0adabc271 = (api)=>(command)=>{
        let success = false;
        let error;
        let repaired = false;
        let ancestors = [];
        let fragments = [];
        api.core.actions.execute(({ tr: tr })=>{
            try {
                (0, $009cb14caceb5527$export$aadcc3ba2430b)(api, tr, command.localId, ({ node: node, pos: pos })=>{
                    const $from = tr.doc.resolve(pos);
                    const $to = tr.doc.resolve(pos + node.nodeSize);
                    const range = $from.blockRange($to);
                    if (range) {
                        const type = command.wrapperType === 'panel' && (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cX9xt.pickPanelTypeForInsertion)(range.$from) : tr.doc.type.schema.nodes[command.wrapperType];
                        const attrs = command.wrapperAttrs;
                        // TODO: EDITOR-1371 - Validate attributes for all nodes
                        if (command.wrapperType === 'panel' && attrs.panelType !== undefined) {
                            const panelType = command.wrapperAttrs.panelType;
                            const panelTypeResult = $f350631d999bc8ec$var$panelTypes.search(panelType);
                            if (panelTypeResult.length) attrs.panelType = panelTypeResult[0].item;
                            else attrs.panelType = 'info';
                        }
                        try {
                            // NOTE: `wrapping` will be empty ([]) when it fits directly
                            const wrapping = (0, $aXG5V.findWrapping)(range, type, attrs);
                            if (wrapping !== null) {
                                tr.wrap(range, wrapping).scrollIntoView();
                                success = true;
                            } else {
                                const slice = tr.doc.slice(range.$from.pos, range.$to.pos);
                                const fragment = slice.content;
                                let node = type.createAndFill(attrs, fragment);
                                if (!node) node = $f350631d999bc8ec$var$wrapChild(fragment, type, attrs);
                                if (node) {
                                    const insertPos = $f350631d999bc8ec$var$findPosForNode(node, $to);
                                    if (insertPos !== null) {
                                        tr.insert(insertPos, node).scrollIntoView();
                                        tr.replaceRange(range.$from.pos, range.$to.pos, (0, $5SAOw.Slice).empty);
                                        success = true;
                                        repaired = true;
                                    }
                                }
                                ancestors = $f350631d999bc8ec$var$getAncestorTypes($to);
                                fragments = $f350631d999bc8ec$var$getChildTypes(fragment);
                            }
                        } catch (e) {
                            error = e;
                            // TODO: EDITOR-1370 - Log the error
                            // eslint-disable-next-line no-console
                            console.error(e);
                        }
                    }
                });
                api.aiExperience.actions.tagAsAIStreamingTransformation(tr, {
                    isFinal: true
                });
            } catch (e) {
                error = e;
                // TODO: EDITOR-1370 - Log the error
                // eslint-disable-next-line no-console
                console.error(e);
            }
            return tr;
        });
        if (!success || repaired) {
            // Log the error
            const errorMessage = (0, $2QlXt.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) errorStack = error.stack || '';
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_COMMAND_FOUND,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXPERIENCE_APPLICATION,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    success: // Disable for now #hot-122604
                    // command,
                    success,
                    repaired: repaired,
                    ancestors: ancestors,
                    fragments: fragments,
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        }
        return success;
    };


function $748219bd4f4f1029$export$a0774277976bc21f(api) {
    return {
        replaceDoc: (0, $6f8f17a8a71e25be$export$4e08a85ccc8f26d0)(api),
        replaceNode: (0, $909a39db2548dac9$export$8077407ea1dae01f)(api),
        insertNodeBefore: (0, $221cde67568b69a7$export$1226208ece997066)(api),
        insertNodeAfter: (0, $c2ca03eb7fbe6fb1$export$d4ccce03e5361e34)(api),
        removeNode: (0, $32edc2d4989fa97a$export$9a6ccf2338830d60)(api),
        removeNodes: (0, $5938e2deecbf4aa1$export$b932a8906dc70a6a)(api),
        moveNode: (0, $c7b498e2e9179941$export$731ead7592859425)(api),
        appendNode: (0, $d4e9e31242338f4c$export$9e6d85a71b01d30)(api),
        appendNodeToEnd: (0, $d4e9e31242338f4c$export$9e6d85a71b01d30)(api),
        wrap: (0, $f350631d999bc8ec$export$2c6212a0adabc271)(api),
        wrapNode: (0, $f350631d999bc8ec$export$2c6212a0adabc271)(api),
        setAttrs: (0, $834280e13ce7e027$export$3c4e918a3d6ca42f)(api)
    };
}


/**
 * Returns the wire-name of the streaming command associated with a failed
 * apply attempt, suitable for the `commandType` attribute on
 * `tool_call_apply_failed` events.
 *
 * Prefers the active `StreamingCommand` (e.g. `'replaceNode'`,
 * `'appendNodeToEnd'`) when available, falling back to the queue-level
 * discriminant (`'streamCommand'`, `'endStream'`, `'initStream'`) and finally
 * to `'unknown'`.
 */ function $4c93be51fe49a367$var$extractCommandType(queuedCommand, activeCommand) {
    if (queuedCommand?.type === 'initStream') return queuedCommand.command.type;
    if (activeCommand?.type) return activeCommand.type;
    return queuedCommand?.type ?? 'unknown';
}
/**
 * Returns the `localId` of the node targeted by a failed apply attempt, if
 * one can be derived from the active command. Returns `undefined` for
 * commands that operate without a target node (e.g. `appendNodeToEnd`,
 * `getPageContent`) or when no command is in flight.
 */ function $4c93be51fe49a367$var$extractTargetLocalId(queuedCommand, activeCommand) {
    const command = queuedCommand?.type === 'initStream' ? queuedCommand.command : activeCommand;
    if (command && 'localId' in command && typeof command.localId === 'string') return command.localId;
    return undefined;
}
/**
 * Command types whose execution mutates the document. Used by the post-apply
 * outcome analyzer to decide whether `noMeaningfulEffect` should fire — a
 * session that ran nothing but read-only commands cannot be flagged for "no
 * meaningful effect" because no effect was ever requested.
 */ const $4c93be51fe49a367$var$MUTATING_COMMAND_TYPES = new Set([
    'append',
    'appendNode',
    'appendNodeToEnd',
    'replaceNode',
    'removeNode',
    'removeNodes',
    'setAttrs',
    'wrap',
    'wrapNode',
    'insertNodeBefore',
    'insertNodeAfter',
    'moveNode'
]);
/**
 * Returns the `localId` field for a streaming command that targets a
 * single existing node, or `undefined` for commands without one
 * (`appendNode`, `appendNodeToEnd`) or whose target uses a different
 * shape (`removeNodes` uses `localIds[]` plural, not a single `localId`).
 *
 * Used by the pre-apply target-resolution check so we only fire
 * `local_id_not_found` when the command actually expected a node
 * by ID.
 */ function $4c93be51fe49a367$var$getTargetLocalId(command) {
    if ('localId' in command && typeof command.localId === 'string') return command.localId;
    return undefined;
}
/**
 * Convert a `StreamingCommand` into the condensed `ToolCallRecord` shape
 * consumed by `analyzeOutcome`. Captures the command type and any localId
 * targets (single or list-shaped). Used to build the per-session tool-call
 * record so the analyzer can distinguish intentional removals/modifications
 * from collateral damage.
 */ function $4c93be51fe49a367$var$toToolCallRecord(command) {
    const targetLocalId = $4c93be51fe49a367$var$getTargetLocalId(command);
    const targetLocalIds = 'localIds' in command && Array.isArray(command.localIds) ? command.localIds.filter((id)=>typeof id === 'string') : undefined;
    return {
        commandType: command.type,
        ...targetLocalId !== undefined ? {
            targetLocalId: targetLocalId
        } : {},
        ...targetLocalIds !== undefined && targetLocalIds.length > 0 ? {
            targetLocalIds: targetLocalIds
        } : {}
    };
}
class $4c93be51fe49a367$export$f3feb8728b17a0a9 {
    isActorReady() {
        try {
            const currentState = this.api.aiExperience.sharedState.currentState();
            if (!(0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
                // Check if actor exists and is in streaming state
                const actor = this.api.aiExperience.actions.getAiExperienceActor();
                return actor && currentState?.isStreaming === true;
            }
            return currentState?.isStreaming === true;
        } catch  {
            return false;
        }
    }
    commandToProcess(commandToProcess) {
        const { type: type, actionId: actionId, chunk: chunk } = commandToProcess;
        if (type === 'initStream') return this.initStreamPromise(commandToProcess.command, commandToProcess.options);
        else if (type === 'endStream') return this.endExperiencePromise(commandToProcess);
        else return this.processStreamCommandPromise(actionId, chunk);
    }
    async processQueue() {
        if (this.processingQueue) return;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.processingQueue = true;
        let commandsToProcess = [
            ...this.queue
        ].filter((cmd)=>cmd.actionId === this.currentAction?.id);
        this.inProcessing = [
            ...new Set(commandsToProcess.map((cmd)=>cmd.actionId))
        ];
        this.queue = this.queue.filter((cmd)=>!commandsToProcess.includes(cmd));
        let currentCommand = null;
        try {
            commandsToProcess = (0, $a561bee60676cdb0$export$c48ec1bf46060d54)(commandsToProcess);
            for (const commandToProcess of commandsToProcess){
                currentCommand = commandToProcess;
                if (this.aborted.includes(commandToProcess.actionId)) {
                    // If we abort the last stream let's move onto the next stream
                    if (commandToProcess.type === 'endStream') this.resolvePendingQueue(true);
                    continue;
                }
                await this.wrapInTimeout(this.commandToProcess(commandToProcess), commandToProcess);
            }
        } catch (error) {
            if ((0, $1oCLl.expValEquals)('platform_editor_ai_fix_insert_after_selection', 'isEnabled', true)) {
                (0, $7b61ecd8bc5f3510$export$c20b86820b0850bf)({
                    api: this.api,
                    traceId: this.traceId,
                    command: currentCommand,
                    isCreateAction: this.currentAction?.isCreateAction,
                    error: error
                });
                // Fire the unified tool_call_anomaly event in parallel —
                // keeps the existing fireCommandError event flowing for
                // legacy dashboards while attribution-first dashboards
                // consume the new event.
                if ((0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true) && this.telemetryEventsEnabled) {
                    const { symptom: symptom } = (0, $c9fd3f5978c61ad6$export$e36a42623b7e8456)(error);
                    (0, $7b61ecd8bc5f3510$export$4d196ad3126dbf0c)({
                        api: this.api,
                        traceId: this.traceId,
                        commandType: $4c93be51fe49a367$var$extractCommandType(currentCommand, this.currentCommand),
                        targetLocalId: $4c93be51fe49a367$var$extractTargetLocalId(currentCommand, this.currentCommand),
                        errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error),
                        result: 'anomaly',
                        symptom: symptom
                    });
                }
            } else throw error;
        } finally{
            // Reset the processing queue flag
            this.processingQueue = false;
            const lastCommand = commandsToProcess.pop();
            this.inProcessing = [];
            if (lastCommand?.type === 'endStream') this.checkAndResolveEmptyQueue();
        }
        // If commands have been added to the queue during async operations, process them now
        if (this.queue.filter((cmd)=>cmd.actionId === this.currentAction?.id).length > 0) this.processQueue();
        else if (this.queue.length > 0) this.queueTimeout = setTimeout(()=>{
            this.logger.logError(`Current stream queue timed out while starting next`, {
                actionId: this.currentAction?.id ?? undefined
            });
            this.resolvePendingQueue(true);
            this.processQueue();
        }, this.CURRENT_QUEUE_TIMEOUT);
    }
    onEmptyQueue() {
        const promise = new Promise((resolve)=>{
            this.onEmptyQueueResolve = resolve;
        });
        this.checkAndResolveEmptyQueue();
        return promise;
    }
    async wrapInTimeout(promise, cmd) {
        const { promise: wrappedPromise, resetTimeout: resetTimeout } = (0, $d96f5329afc42f98$export$6c44330c7facd24b)(promise, {
            timeout: this.COMMAND_TIMEOUT,
            onTimeout: ()=>{
                this.logger.logError(`Stream command timed out ${cmd.type}`, {
                    actionId: cmd.actionId,
                    chunk: cmd.chunk
                });
            },
            onCleanup: ()=>{
                this.currentCommandTimeoutReset = null;
                if (cmd.type === 'endStream') this.checkAndResolveEmptyQueue();
                this.resolvePendingQueue();
            }
        });
        this.currentCommandTimeoutReset = resetTimeout;
        await wrappedPromise;
    }
    /**
   * End the AI experience
   */ endStreamCommand(actionId) {
        // duplicated endStreamCommand will kill accept reject screen prematurely
        if (this.endedActionIds.includes(actionId)) {
            this.logger.logPublic('End Stream Command Ignored', {
                actionId: actionId
            });
            return;
        }
        this.endedActionIds.push(actionId);
        if (this.endedActionIds.length > 10) this.endedActionIds.shift();
        this.logger.logPublic('End Stream Command', {
            actionId: actionId
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endCurrentStream'
        });
        this.processQueue();
    }
    endExperience() {
        // if it's isFinalStream
        // - when auto accept AI changes is on, editor-plugin-ai will end itself
        // - when auto accept AI changes is off, the accept reject screen will be shown
        // if it's not isFinalStream, the endAIExperience is used to kill a previous AI modal
        // - which can be the previous accept reject screen
        // - or the command palette screen (followed by rovo free-gen screen)
        if (!this.isFinalStream) {
            this.logger.logQueueState('End AI Experience');
            this.api.aiExperience.actions.endAIExperience();
        }
        this.isFinalStream = false;
        this.adfStreamer?.reset();
        this.streamFlowPacer?.reset();
        this.subscription?.();
    }
    resolvePendingQueue(timeout = false) {
        if (timeout || this.isPendingResolveQueue) {
            const currentAction = this.queue.find((cmd)=>cmd.type === 'initStream') ?? null;
            this.logger.logQueueState('Resolve Pending Queue', {
                actionId: currentAction?.actionId,
                reason: timeout ? 'timeout' : 'isPendingResolveQueue'
            });
            if (timeout && (0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) // Queue-stall timeout fired (no further commands arrived).
            // Idempotent via `fireSessionOutcomeOnce`'s once-per-session guard.
            this.fireSessionOutcomeOnce({
                lifecycleSymptom: 'session_timeout'
            });
            this.currentAction = currentAction ? {
                id: currentAction.actionId,
                isCreateAction: (currentAction.command.type === 'appendNode' || currentAction.command.type === 'appendNodeToEnd') && currentAction.command.streamingType === 'create',
                initialNode: (0, $009cb14caceb5527$export$b7b4fc0a0195a016)(this.api, // replaceDoc has no localId — only replaceNode needs one here.
                currentAction.command.type === 'replaceNode' && currentAction.command.localId),
                type: currentAction.command.type
            } : null;
            this.isPendingResolveQueue = false;
        }
    }
    checkAndResolveEmptyQueue() {
        if (this.queue.length === 0 && this.inProcessing.length === 0) this.onEmptyQueueResolve?.();
    }
    endNonStreamble() {
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.api.aiExperience.actions.dispatchAIEvent({
            type: 'complete',
            adfResponse: undefined
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            send({
                type: 'complete',
                markdown: '',
                adfResponse: undefined,
                cacheKey: '',
                modelInput: {}
            });
        }
    }
    async endExperiencePromise(command) {
        const { actionId: actionId, reason: reason } = command;
        this.logger.logQueueState('End Experience', {
            actionId: actionId,
            reason: reason
        });
        this.isPendingResolveQueue = reason === 'endCurrentStream';
        // should not check empty queue if the end command is triggered by the initStreamCommand
        // which is used to close a previous AI modal
        // because there are more commands to process even if the queue is empty
        // and this.isPendingResolveQueue will be reset, so use a different flag here
        const shouldCheckEmptyQueue = reason === 'endCurrentStream';
        const isStreamingCommand = !(this.currentAction?.type && !(0, $c127a9255266496a$export$f85aff2979b590a7)({
            type: this.currentAction?.type
        }));
        if (this.isStreaming && isStreamingCommand) {
            await this.processStreamCommandPromise(actionId, '', true);
            if (this.currentAction?.type === 'replaceNode') (0, $7b61ecd8bc5f3510$export$7535a054b27a27c4)({
                api: this.api,
                initialNode: this.currentAction.initialNode,
                lastDoc: this.adfStreamer?.getLastDoc()
            });
            this.scheduleDeferredNoDocChangeAnalytics();
        } else if (!isStreamingCommand) this.isFinalStream = true;
        return new Promise((resolve)=>{
            const endNow = ()=>{
                this.endExperience();
                // After we end the experience there are a number of React re-renders that occur immediately after
                // This causes the state to flick between streaming and not streaming, it's not pretty
                // but wrap this in a `requestAnimationFrame` to delay our check until this clears.
                // To fix this properly we probably need to decouple the state with React
                const checkStreaming = ()=>{
                    const resolveAndEndStream = ()=>{
                        resolve();
                        this.logger.logQueueState('End Experience Resolved', {
                            actionId: actionId,
                            reason: reason
                        });
                        this.resolvePendingQueue();
                        shouldCheckEmptyQueue && this.checkAndResolveEmptyQueue();
                    };
                    if (!isStreamingCommand) {
                        this.endNonStreamble();
                        resolveAndEndStream();
                        return;
                    }
                    if (!this.api.aiExperience?.sharedState.currentState()?.isStreaming) {
                        resolveAndEndStream();
                        return;
                    }
                    const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (!nextSharedState.isStreaming) {
                            unsubscribe();
                            resolveAndEndStream();
                        }
                    });
                };
                setTimeout(checkStreaming, 0);
            };
            // If we're not running the pacer or its a non-streamable command, end immediately
            if (!this.streamFlowPacer?.isRunning() || this.currentAction?.type && !(0, $c127a9255266496a$export$f85aff2979b590a7)({
                type: this.currentAction?.type
            })) endNow();
            else this.streamFlowPacer.onComplete(()=>{
                // Need to be careful not to end the experience too soon. We need to give the xstate and react time to process
                // the final stream events before we kill the experience. Otherwise you will see an unfinished stream in the doc.
                setTimeout(endNow, 100);
            });
        });
    }
    /**
   * Streams the AI experience
   */ /**
   * Called by the orchestrator plugin when the chunk strategy detects that
   * ADF schema content was rejected (e.g. blockCard inside listItem).
   * Fires a toolCallResult anomaly and suppresses the deferred success event.
   */ notifySchemaContentRejection(actionId, errorMessage) {
        if (this.toolCallResultFiredForCurrentCommand) return;
        const command = this.currentCommand;
        const traceId = this.traceId;
        if (!command || !traceId) return;
        this.toolCallResultFiredForCurrentCommand = true;
        (0, $7b61ecd8bc5f3510$export$4d196ad3126dbf0c)({
            api: this.api,
            traceId: traceId,
            commandType: command.type,
            result: 'anomaly',
            symptom: 'apply_failed_adf_schema_error',
            errorMessage: errorMessage
        });
    }
    queueStreamCommand(actionId, chunk) {
        this.logger.logPublic('Stream Command', {
            actionId: actionId,
            chunk: chunk
        });
        if (this.aborted.includes(actionId) || this.isAborted) {
            this.updateAbortedCache([
                actionId
            ]);
            return;
        }
        // Actor not ready, queue the command
        this.queue.push({
            type: 'streamCommand',
            actionId: actionId,
            chunk: chunk
        });
        if (this.isActorReady()) this.processQueue();
        else {
            // if there are multiple sequential queueStreamCommand calls
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api?.aiExperience.sharedState.onChange(()=>{
                if (this.isActorReady()) {
                    unsubscribe?.();
                    this.processQueue();
                }
            });
        }
    }
    hasChangedDocument(latestDoc) {
        if (!this.previousValidDoc && latestDoc) return true;
        const nodesAreNotEqual = !this.previousValidDoc?.doc || !latestDoc?.doc || !(0, $2pjJ5.areNodesEqualIgnoreAttrs)(this.previousValidDoc?.doc, latestDoc.doc);
        if (this.streamFlowPacer === null) {
            // replaceDoc is allowed to produce an empty document (e.g. "delete entire page"),
            // so we skip the isEmptyDocument guard for that action type.
            const isReplaceDoc = this.currentAction?.type === 'replaceDoc';
            if (isReplaceDoc) // For replaceDoc, latestDoc.doc may be undefined when the streamed content is
            // empty HTML (the adfStreamer returns undefined for empty input). We treat
            // "undefined → previous doc exists" as a change so the empty-page intent
            // is honoured — the final stream path will supply the empty-paragraph fallback.
            return Boolean(nodesAreNotEqual);
            return Boolean(nodesAreNotEqual && latestDoc.doc && !(0, $bI3mS.isEmptyDocument)(latestDoc.doc));
        }
        const latestCount = this.streamFlowPacer?.adfTextLen(latestDoc?.adfDoc);
        return Boolean(nodesAreNotEqual && latestDoc.adfDoc && this.previousValidDoc?.adfDoc && latestCount.chars > 0 && // Ensure we only stream changes if the stream flow pacer detects semantic changes
        !this.streamFlowPacer?.adfTextLen(this.previousValidDoc?.adfDoc).gte(latestCount));
    }
    createCallback(usePush) {
        if (usePush) return (evt)=>{
            const fullEvent = (0, $1xicG.normaliseAIExperienceEvent)(evt);
            this?.streamFlowPacer?.push(fullEvent);
        };
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return (evt)=>{
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        };
        // Legacy path: send to actor with padded defaults
        const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
        return (evt)=>{
            const payload = (0, $1xicG.normaliseAIExperienceEvent)(evt);
            send(payload);
        };
    }
    processStreamCommand(actionId, chunk, finalStream = false) {
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) this.streamFlowPacer?.setEmit((evt)=>{
            // While the stream flow pacer is doing work reset the timeout
            this.currentCommandTimeoutReset?.();
            this.api.aiExperience.actions.dispatchAIEvent(evt);
        });
        else {
            const { send: send } = this.api.aiExperience.actions.getAiExperienceActor();
            this.streamFlowPacer?.setEmit((evt)=>{
                // While the stream flow pacer is doing work reset the timeout
                this.currentCommandTimeoutReset?.();
                send(evt);
            });
        }
        // Bypass the pacer when noStream is set (e.g. pre-computed results from semantic tool calls)
        const noStream = (0, $1oCLl.expValEquals)('platform_editor_ai_no_stream_skip_pacer', 'isEnabled', true) && this.currentAction?.type && 'noStream' in this.currentAction && this.currentAction.noStream;
        const callback = this.createCallback(!!this.streamFlowPacer?.push && !noStream);
        // Initialize streamer if needed
        if (!this.adfStreamer) {
            const schema = this.api.core.sharedState.currentState()?.schema;
            this.adfStreamer = schema ? new (0, $4pSml.ADFStreamer)(schema, (0, $7b61ecd8bc5f3510$export$6dcba6b9d3966cf9)({
                api: this.api,
                isCreateAction: this.currentAction?.isCreateAction ?? false,
                traceId: this.traceId,
                promptVersion: this.promptVersion
            })) : undefined;
        }
        if (finalStream) {
            const lastDocResult = (0, $adc2c60cd4921249$export$7b6c9d9d26e2f428)(this.api, this.adfStreamer?.getLastDoc());
            let adfResponseBefore = lastDocResult.adfDoc;
            // replaceDoc with an empty value (e.g. "delete entire page") produces either no
            // ADF or a bare { type:"doc" } with no content from the streamer. Substitute a
            // minimal empty document so the downstream insertion path actually clears the
            // editor content rather than silently no-oping.
            const isFinalEffectivelyEmptyDoc = !adfResponseBefore || !adfResponseBefore.content || adfResponseBefore.content.length === 0;
            if (isFinalEffectivelyEmptyDoc && this.currentAction?.type === 'replaceDoc') adfResponseBefore = {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            };
            const schema = this.api.core.sharedState.currentState()?.schema;
            const { updatedResponse: updatedResponse, localId: localId } = (0, $76ccf77dd7d8e539$export$ab173b3d1046c711)(adfResponseBefore, this.currentAction?.type, schema);
            const adfResponse = updatedResponse;
            this.insertAfterQueueLocalId = localId;
            const repairSignals = this.adfStreamer?.endStreamingSession({
                hasProcessedFinalResponse: true
            });
            if (repairSignals && (0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) // A session may contain multiple streaming actions. Aggregate
            // repair signals across them so the final `sessionOutcome` event
            // correctly reflects the worst per-action outcome:
            // - `*Invalid`: OR — any invalid action means the session saw
            //   that layer fail at least once.
            // - `unrepaired*Count`: count actions whose invalid layer was
            //   NOT recovered. The session is only considered "fully
            //   repaired" if this count is zero. A naive OR over the
            //   per-action `*Repaired` flags would incorrectly mask a
            //   later irrecoverable failure when an earlier action had
            //   recovered.
            this.sessionRepairSignals = {
                anyJsonInvalid: this.sessionRepairSignals.anyJsonInvalid || repairSignals.finalJsonInvalid,
                anyAdfInvalid: this.sessionRepairSignals.anyAdfInvalid || repairSignals.finalAdfInvalid,
                unrepairedJsonCount: this.sessionRepairSignals.unrepairedJsonCount + (repairSignals.finalJsonInvalid && !repairSignals.finalJsonRepaired ? 1 : 0),
                unrepairedAdfCount: this.sessionRepairSignals.unrepairedAdfCount + (repairSignals.finalAdfInvalid && !repairSignals.finalAdfRepaired ? 1 : 0)
            };
            this.logger.logQueueState('Final Stream', {
                actionId: actionId,
                adf: adfResponse,
                finalStream: true
            });
            callback({
                type: 'complete',
                adfResponse: adfResponse
            });
            return true;
        }
        // Resetting because we are going to get full ADF as chunk
        this.adfStreamer?.reset();
        this.adfStreamer?.processChunk(chunk);
        const latestDoc = (0, $adc2c60cd4921249$export$7b6c9d9d26e2f428)(this.api, noStream ? this.adfStreamer?.getLastDoc() : this.adfStreamer?.getLastDocWithoutLastLeafNode());
        const changed = this.hasChangedDocument(latestDoc);
        this.previousValidDoc = latestDoc;
        // We compare the before/after docs because if nothing has changed then it will not trigger a react update (because the adfResponse needs to be different)
        // which means the chunkNumber will never update and the processStreamCommandPromise Promise will never resolve.
        // This cause the wrapInTimeout 1sec delay to occur before the next chunk is processed. This means we can end up in a situation
        // where we're recieving a lot of chunks, but nothing in the view is changed and everything starts taking a lot of time
        // because of the sequential 1sec failovers.
        if (changed) {
            // For replaceDoc with an empty value (e.g. "delete entire page"), the adfStreamer
            // returns either undefined or a bare { type:"doc" } with no content — fall back to
            // a minimal empty document so the editor content is actually cleared.
            const isEffectivelyEmptyDoc = !latestDoc.adfDoc || !latestDoc.adfDoc.content || latestDoc.adfDoc.content.length === 0;
            const streamAdfResponse = isEffectivelyEmptyDoc && this.currentAction?.type === 'replaceDoc' ? {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            } : latestDoc.adfDoc;
            callback({
                type: 'stream',
                adfResponse: streamAdfResponse
            });
            return true;
        }
        return false;
    }
    processStreamCommandPromise(actionId, chunk, finalStream = false) {
        this.logger.logQueueState('Streaming Command', {
            actionId: actionId,
            chunk: chunk,
            finalStream: finalStream
        });
        this.isStreaming = !finalStream;
        this.isFinalStream = finalStream;
        return new Promise((resolve)=>{
            // do not wrap the code in setTimeout, it will pause the streaming when the tab is in background
            const chunkBefore = this.api.aiExperience?.sharedState.currentState()?.chunkNumber;
            if (!this.processStreamCommand(actionId, chunk, finalStream)) {
                // If nothing was processed then we should be able to end immediately since we will never get a chuckNumber update
                // this means the next chunk can be processed straight away.
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            if (chunkBefore !== this.api.aiExperience?.sharedState.currentState()?.chunkNumber) {
                resolve();
                this.logger.logQueueState('Streaming Command Resolved', {
                    actionId: actionId,
                    chunk: chunk,
                    finalStream: finalStream
                });
                return;
            }
            // if there are multiple sequential queueStreamCommand calls and one of them timeout
            // and we assign the return value to this.subscription and call this.subscription
            // we won't be able to unsubscribe the corresponding right one
            // and will cause the callback to be called tons of times when state changes
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (nextSharedState?.chunkNumber !== prevSharedState?.chunkNumber) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState('Streaming Command Resolved', {
                        actionId: actionId,
                        chunk: chunk,
                        finalStream: finalStream
                    });
                }
            });
        });
    }
    /**
   * Streams the AI experience
   */ initStreamCommand(actionId, command, options) {
        this.logger.logPublic('Init Command', {
            actionId: actionId,
            command: command
        });
        this.isAborted = false;
        // Track tool call captured for analytics
        if ((0, $dh538.fg)('platform_editor_ai_tool_call_received_analytics')) (0, $7b61ecd8bc5f3510$export$2197bcc2a00f4a51)({
            api: this.api,
            command: command,
            actionId: actionId,
            traceId: this.traceId
        });
        if (!this.currentAction) this.currentAction = {
            id: actionId,
            isCreateAction: (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create',
            initialNode: (0, $009cb14caceb5527$export$b7b4fc0a0195a016)(this.api, // replaceDoc has no localId — only pass localId for replaceNode.
            command.type === 'replaceNode' && command.localId),
            type: command.type
        };
        // If we're already running end the stream and restart
        if (this.api.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.isRunning) this.queue.push({
            type: 'endStream',
            actionId: actionId,
            chunk: undefined,
            reason: 'endPreviousStream'
        });
        this.queue.push({
            type: 'initStream',
            actionId: actionId,
            chunk: undefined,
            command: command,
            options: options
        });
        this.processQueue();
    }
    applyCommand(command) {
        const insertAfterQueue = this.currentCommand?.type === 'insertNodeAfter' && command.type === 'insertNodeAfter' && command.localId === this.currentCommand?.localId;
        this.currentCommand = command;
        if ((0, $dh538.fg)('platform_editor_ai_normalized_telemetry_patch2')) this.toolCallResultFiredForCurrentCommand = false;
        this.docBeforeStreaming = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(this.api);
        let isSuccessful = true;
        // Apply-anomaly diagnostics: see runPre/PostApplyDiagnostics for
        // the symptoms detected. Gated to keep the snapshot/diff cost
        // (and any associated bookkeeping) out of the hot path entirely
        // when the experiment is off.
        const normalizedTelemetryEnabled = (0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true);
        // Record this tool call so end-of-session `analyzeOutcome` can
        // distinguish intentional removals/modifications from collateral
        // damage. Only collected when the experiment is on.
        if (normalizedTelemetryEnabled) this.sessionToolCalls.push($4c93be51fe49a367$var$toToolCallRecord(command));
        // The localId the apply path will actually attempt to act on.
        // `insertAfterQueue` commands rewrite the localId at apply time
        // so that consecutive `insertNodeAfter` calls chain correctly
        // (see the apply branch below). Diagnostics must use the same
        // effective localId so target-resolution checks match the apply
        // path's actual behaviour — otherwise we get false positives
        // (command.localId missing but insertAfterQueueLocalId valid) and
        // false negatives (the inverse).
        const effectiveTargetLocalId = normalizedTelemetryEnabled ? insertAfterQueue && this.insertAfterQueueLocalId ? this.insertAfterQueueLocalId : $4c93be51fe49a367$var$getTargetLocalId(command) : undefined;
        const preApplyResult = normalizedTelemetryEnabled ? this.runPreApplyDiagnostics(command, effectiveTargetLocalId) : undefined;
        // If we have subsequent "insertAfter" commands with the same localId, instead point to the end of the
        // previous insertion. This is because the AI will "insertAfter" in a logical order, but that puts the content
        // into the document backwards.
        if (insertAfterQueue && this.insertAfterQueueLocalId) // If for some reason the localId doesn't exist in the document fallback to the original stream command
        try {
            isSuccessful = this.streamingCommands[command.type]({
                ...command,
                localId: this.insertAfterQueueLocalId
            });
        } catch  {
            isSuccessful = this.streamingCommands[command.type](command);
        }
        else isSuccessful = this.streamingCommands[command.type](command);
        const postApplyAnomalyDetected = normalizedTelemetryEnabled && preApplyResult !== undefined && !preApplyResult.anomalyDetected ? this.runPostApplyDiagnostics(command, preApplyResult.preApplyLocalIds, effectiveTargetLocalId) : false;
        // Fire success only if no anomaly detected and not a streamable
        // command. Streamable commands defer success/anomaly to
        // checkAndFireNoDocumentChangeAnalytics once streaming completes, since
        // the doc change arrives via chunks after applyCommand returns.
        if (normalizedTelemetryEnabled && this.telemetryEventsEnabled) {
            const preApplyAnomalyDetected = preApplyResult?.anomalyDetected ?? false;
            if (!preApplyAnomalyDetected && !postApplyAnomalyDetected && !(0, $c127a9255266496a$export$f85aff2979b590a7)(command)) (0, $7b61ecd8bc5f3510$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'success'
            });
        }
        return isSuccessful;
    }
    /**
   * Apply-anomaly diagnostics: pre-apply phase. Snapshots full-depth
   * localIds and fires `local_id_not_found` if the command targets
   * a localId that doesn't exist. Returns the snapshot for reuse by the
   * post-apply phase.
   *
   * Caller is responsible for the experiment gate check, and for
   * computing `effectiveTargetLocalId` so it reflects what the apply
   * path will actually act on (e.g. the substituted
   * `insertAfterQueueLocalId` for chained `insertNodeAfter` calls).
   */ runPreApplyDiagnostics(command, effectiveTargetLocalId) {
        const preApplyLocalIds = (0, $009cb14caceb5527$export$a3fa3f6695d8b421)(this.docBeforeStreaming ?? undefined);
        // Use the live PM doc lookup (same walk every command uses) so
        // detection is ground-truth equivalent to the apply layer.
        if (effectiveTargetLocalId !== undefined && (0, $009cb14caceb5527$export$b7b4fc0a0195a016)(this.api, effectiveTargetLocalId) === undefined) {
            if (this.telemetryEventsEnabled) (0, $7b61ecd8bc5f3510$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'local_id_not_found',
                targetLocalId: effectiveTargetLocalId
            });
            return {
                anomalyDetected: true,
                preApplyLocalIds: preApplyLocalIds
            };
        }
        return {
            anomalyDetected: false,
            preApplyLocalIds: preApplyLocalIds
        };
    }
    /**
   * Apply-anomaly diagnostics: post-apply phase. Diffs the post-apply
   * full-depth localId snapshot against the pre-apply snapshot (both
   * built via `collectAllLocalIds`, so every depth is included) and
   * fires:
   * - `unexpected_node_removal` when nodes disappeared that the command
   *   wasn't supposed to remove/relocate. Reports
   *   `effectiveTargetLocalId` so the dashboard reader sees the localId
   *   the apply path actually acted on.
   * - `no_document_change` when a mutating command produced no document
   *   change at all.
   * Caches the post-apply snapshot for reuse by the next applyCommand.
   *
   * Caller is responsible for the experiment gate check, and for
   * computing `effectiveTargetLocalId` so it reflects what the apply
   * path actually acted on (see `runPreApplyDiagnostics`).
   */ runPostApplyDiagnostics(command, preApplyLocalIds, effectiveTargetLocalId) {
        const postApplyDoc = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(this.api);
        if (postApplyDoc === undefined) // Editor view unavailable post-apply (teardown race). Skip
        // the diff — can't distinguish "everything removed" from
        // "couldn't observe post-apply state".
        return false;
        // Full-depth snapshot so the diff catches collateral removals
        // nested inside layouts, expand blocks, panels, table cells, etc.
        const postApplyLocalIds = (0, $009cb14caceb5527$export$a3fa3f6695d8b421)(postApplyDoc);
        // Pass `docBeforeStreaming` so the helper can expand each direct
        // target to include its descendant `localId`s. Required since
        // the diff above (`collectAllLocalIds`) is full-depth — removing
        // a container would otherwise spuriously fire
        // `unexpected_node_removal` for every nested descendant.
        const explicitTargets = (0, $74e3ba48f2f51a7a$export$30ebe6cd1aac119d)(command, this.docBeforeStreaming ?? undefined);
        const removedLocalIds = [];
        preApplyLocalIds.forEach((id)=>{
            if (!postApplyLocalIds.has(id) && !explicitTargets.has(id)) removedLocalIds.push(id);
        });
        if (removedLocalIds.length > 0) {
            if (this.telemetryEventsEnabled) (0, $7b61ecd8bc5f3510$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'unexpected_node_removal',
                targetLocalId: effectiveTargetLocalId,
                removedLocalIds: removedLocalIds
            });
            return true;
        }
        // Streamable commands (`replaceNode`, `replaceDoc`,
        // `insertNodeBefore`, `insertNodeAfter`, `appendNode`,
        // `appendNodeToEnd`) are two-phase: the apply call only sets a
        // selection (and sometimes inserts a placeholder paragraph), and
        // the actual content change arrives later via streaming chunks.
        // At apply time the document has legitimately not changed yet, so
        // firing `no_document_change` here would produce false positives
        // for every streamable command. The deferred check fires from
        // `checkAndFireNoDocumentChangeAnalytics` in `endExperiencePromise`
        // once all stream chunks have been applied.
        if (!(0, $c127a9255266496a$export$f85aff2979b590a7)(command) && this.docBeforeStreaming && postApplyDoc.eq(this.docBeforeStreaming)) {
            if (this.telemetryEventsEnabled) (0, $7b61ecd8bc5f3510$export$4d196ad3126dbf0c)({
                api: this.api,
                traceId: this.traceId,
                commandType: command.type,
                result: 'anomaly',
                symptom: 'no_document_change'
            });
            return true;
        }
        return false;
    }
    initStream(command, options) {
        const applied = this.applyCommand(command);
        // If we couldn't apply the command (ie. broken localId) add it to the abort cache so we don't apply anymore commands
        if (!applied) {
            // Never start the stream and resolve immediately
            if (this.currentAction?.id) this.updateAbortedCache([
                this.currentAction?.id
            ]);
            return true;
        }
        this.streamFlowPacer?.reset();
        this.adfStreamer?.reset();
        // We have to set an empty callback before starting otherwise the flow pacer wont start. We need to cleanup the flow pacer
        // and make it more generic.
        this.streamFlowPacer?.setEmit(()=>{});
        this.streamFlowPacer?.start();
        // Fire a simple operational event measuring the gap between the backend
        // finishing its stream and the pacer finishing draining it (HTML+ lag).
        this.streamFlowPacer?.onPacerCompletionGap((info)=>{
            (0, $7b61ecd8bc5f3510$export$121949ee4a6ce5f6)({
                api: this.api,
                backendEndToPacerCompleteMs: info.backendEndToPacerCompleteMs,
                backlogCharsAtBackendEnd: info.backlogCharsAtBackendEnd,
                charsPerTickAtComplete: info.charsPerTickAtComplete,
                terminalType: info.terminalType,
                traceId: this.traceId
            });
        });
        const isCreate = (command.type === 'appendNode' || command.type === 'appendNodeToEnd') && command.streamingType === 'create';
        this.logger.logQueueState('Open AI Modal', {
            command: command
        });
        this.api.aiExperience.actions.openAIModal({
            invokedFrom: 'streamingApi',
            configItem: (0, $9Tkc6.UNSTABLE_configItems).freeGenerateAifcConfigItem,
            withStreamingHighlight: !isCreate,
            // don't show accept reject screen for staging first-time creation streaming
            withAcceptReject: !isCreate,
            hideLoadingScreen: ((0, $dh538.fg)('platform_editor_tmp_hide_loader') && options?.hideLoadingScreen) ?? false,
            traceId: this.traceId,
            singleInstrumentationId: this.singleInstrumentationId,
            isCreate: isCreate,
            promptVersion: this.promptVersion
        });
        if (!(0, $c127a9255266496a$export$f85aff2979b590a7)(command)) (0, $7b61ecd8bc5f3510$export$276ecd5322451ab4)({
            api: this.api,
            command: this.currentCommand,
            docBeforeStreaming: this.docBeforeStreaming,
            traceId: this.traceId
        });
        return false;
    }
    async initStreamPromise(command, options) {
        await new Promise((resolve)=>{
            this.logger.logQueueState(`Init Command ${command.type}`, {
                command: command
            });
            if (this.initStream(command, options)) {
                resolve();
                this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                    command: command
                });
                return;
            }
            const unsubscribe = this.api.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState.aiDecorationExperiencePluginState.isRunning) {
                    unsubscribe?.();
                    resolve();
                    this.logger.logQueueState(`Init Command Resolved ${command.type}`, {
                        command: command
                    });
                }
            });
        });
    }
    startSession(sessionId, traceId, singleInstrumentationId, promptVersion) {
        this.traceId = traceId;
        (0, $7b61ecd8bc5f3510$export$4b84cbb6abceadd2)({
            api: this.api,
            sessionId: sessionId,
            traceId: traceId,
            promptVersion: promptVersion
        });
        this.singleInstrumentationId = singleInstrumentationId;
        this.promptVersion = (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics') ? promptVersion : undefined;
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            this.resetSessionOutcomeState();
            // Capture the doc as it was before any streaming command runs.
            // `analyzeOutcome` will diff this against the post-session doc
            // at end-of-session to compute structural-delta fields.
            this.preSessionDoc = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(this.api);
        }
        this.logger.logPublic('Start Session', {
            sessionId: sessionId,
            singleInstrumentationId: singleInstrumentationId
        });
    }
    queueEndSession(sessionId) {
        this.logger.logPublic('Queue End Session', {
            sessionId: sessionId
        });
    }
    endSession(sessionId) {
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) {
            this.runPostApplyOutcomeAnalysis();
            this.fireSessionOutcomeOnce();
        }
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        this.promptVersion = undefined;
        this.currentCommand = undefined;
        this.logger.logPublic('End Session', {
            sessionId: sessionId
        });
    }
    /**
   * Fire the authoritative `sessionOutcome` analytics event for the current
   * session. Idempotent — calling this multiple times within the same session
   * results in at most a single event being fired.
   *
   * If `lifecycleSymptom` is supplied, it overrides any repair-derived
   * symptom and forces `outcome_class: 'failure'` — a session that never
   * reached end-of-stream cannot be a success.
   */ fireSessionOutcomeOnce(options = {}) {
        if (this.sessionOutcomeFired) return;
        this.sessionOutcomeFired = true;
        const { lifecycleSymptom: lifecycleSymptom } = options;
        const { anyJsonInvalid: anyJsonInvalid, anyAdfInvalid: anyAdfInvalid, unrepairedJsonCount: unrepairedJsonCount, unrepairedAdfCount: unrepairedAdfCount } = this.sessionRepairSignals;
        // Derive the session-level repair-signal contract reported on the
        // outcome event:
        // - `finalJsonInvalid` / `finalAdfInvalid`: did any action see that
        //   layer become invalid at all?
        // - `finalJsonRepaired` / `finalAdfRepaired`: was every invalid
        //   occurrence in the session recovered? (i.e. AND over the per-action
        //   `repaired` flags for actions where invalid=true). False when the
        //   layer was never invalid, matching the per-action semantic.
        const finalJsonInvalid = anyJsonInvalid;
        const finalAdfInvalid = anyAdfInvalid;
        const finalJsonRepaired = anyJsonInvalid && unrepairedJsonCount === 0;
        const finalAdfRepaired = anyAdfInvalid && unrepairedAdfCount === 0;
        // Post-apply analysis flags. Read from the analyzer result computed
        // in `runPostApplyOutcomeAnalysis`. Each flag drives one suspicious-
        // signal event AND (if the session would otherwise have succeeded)
        // upgrades the outcome class to `success_but_suspicious`.
        //
        // `noMeaningfulEffect` only counts when the session actually ran a
        // mutating tool call — a read-only session that happens to leave
        // the doc unchanged is not suspicious, it's expected.
        const analysis = this.lastOutcomeAnalysis;
        const hadMutatingToolCall = this.sessionToolCalls.some((tc)=>$4c93be51fe49a367$var$MUTATING_COMMAND_TYPES.has(tc.commandType));
        const unintendedRegionRemoved = analysis !== undefined && analysis.unintendedRegionRemoved;
        const unintendedRegionModified = analysis !== undefined && analysis.unintendedRegionModified;
        // `textCharacterDelta` tolerance: we treat ±1 character as
        // negligible because the apply layer can legitimately inject or
        // strip a single trailing whitespace / newline / punctuation
        // character during ProseMirror normalisation (e.g. closing a block
        // node, collapsing adjacent whitespace, trimming a trailing space
        // the model emitted). Strict equality to 0 would generate
        // false-positive `noMeaningfulEffect` events for sessions whose
        // only effect was a one-character normalisation artefact. A wider
        // tolerance would risk hiding real (but tiny) edits.
        //
        // `attrSignaturesEqual` catches attribute-only edits (e.g. cell
        // background, panel type, heading level) that node count + text
        // length miss. See CCI-16816.
        // CCI-16968: when a replaceNode creates replacement nodes with fresh
        // localIds, the targeted node disappears from the post-doc top-level
        // snapshot. In that case the totalNodeDelta and textCharacterDelta
        // metrics are coincidentally 0/±1 even though real content was
        // rewritten — the content just moved to a new localId. Suppress
        // noMeaningfulEffect when any targeted top-level node is absent from
        // the post-doc (the replacement genuinely happened).
        const noMeaningfulEffect = analysis !== undefined && hadMutatingToolCall && analysis.totalNodeDelta === 0 && Math.abs(analysis.textCharacterDelta) <= 1 && analysis.attrSignaturesEqual && !analysis.anyAffectedLocalIdDisappearedPostApply;
        const intentEffectMismatch = analysis !== undefined && analysis.intentEffectMismatch;
        // Outcome class derivation per the design doc (Phase 1 + 3):
        // - failure                : any layer (ADF or JSON) was invalid and
        //                            could not be repaired, OR the session
        //                            ended via a lifecycle event (abort /
        //                            timeout)
        // - success_with_repairs   : a layer was invalid but every invalid
        //                            occurrence was recovered
        // - clean_success          : no repair signals fired at all
        // - success_but_suspicious : the session would otherwise have been
        //                            clean_success or success_with_repairs
        //                            but the post-apply analyzer flagged
        //                            one or more suspicious signals
        // `failure` is never overridden by a suspicious signal — an
        // unrecovered apply error is more important than "looks fishy".
        const adfFailed = finalAdfInvalid && !finalAdfRepaired;
        const jsonFailed = finalJsonInvalid && !finalJsonRepaired;
        const anySuspiciousSignal = unintendedRegionRemoved || unintendedRegionModified || noMeaningfulEffect || intentEffectMismatch;
        let outcomeClass;
        if (lifecycleSymptom !== undefined || adfFailed || jsonFailed) outcomeClass = 'failure';
        else if (anySuspiciousSignal) outcomeClass = 'success_but_suspicious';
        else if (finalAdfRepaired || finalJsonRepaired) outcomeClass = 'success_with_repairs';
        else outcomeClass = 'clean_success';
        // Compute a small histogram of command types to help debug
        // no-effect sessions ("what was being attempted?"). Keys are
        // orchestrator command-type constants (not user content). Scoped
        // deliberately to `noMeaningfulEffect` sessions — avoids inflating
        // every sessionOutcome payload with histogram data that is only
        // useful when the session produced no meaningful change.
        let commandTypeCounts;
        if (noMeaningfulEffect) {
            commandTypeCounts = {};
            for (const tc of this.sessionToolCalls)commandTypeCounts[tc.commandType] = (commandTypeCounts[tc.commandType] ?? 0) + 1;
        }
        // True when any of the suspicious signals that fired came from a
        // heuristic rather than a backend-supplied label. Currently always
        // true for `unintendedRegionModified` (text-length proxy) and
        // `intentEffectMismatch` (intent inferred from tool-call mix).
        // Lets dashboards filter the noisier inferred signals out of
        // headline KPIs.
        const heuristicInferred = unintendedRegionModified || intentEffectMismatch ? true : undefined;
        // Pick the worst (symptom, detectionLayer) we observed: lifecycle >
        // unrecovered failure > successful repair > clean. `detectionLayer`
        // names where the symptom was *first surfaced* (parser for repair
        // signals, orchestrator for apply / lifecycle), not where this
        // event is fired. Unmapped pairs fall back to `unknown`/`low`.
        let detectionLayer = 'orchestrator';
        let symptom;
        if (lifecycleSymptom !== undefined) {
            // Lifecycle symptoms are orchestrator-owned (abort / timeout).
            detectionLayer = 'orchestrator';
            symptom = lifecycleSymptom;
        } else if (adfFailed) {
            // The orchestrator surfaced an unrecovered ADF schema failure
            // when it tried to apply the streamed ADF.
            detectionLayer = 'orchestrator';
            symptom = 'apply_failed_adf_schema_error';
        } else if (jsonFailed) {
            // Parser-layer detection. There is no dedicated routing-table
            // entry for an unrecovered JSON failure today; we still attach
            // the symptom so dashboards can see it, and it routes to
            // `unknown`/`low` until the routing table grows an entry
            // covering this case.
            detectionLayer = 'parser';
            symptom = 'final_json_invalid';
        } else if (finalAdfRepaired) {
            // ADF repair is the higher-severity success signal — checked
            // before JSON repair so a session that observed both still
            // surfaces the more impactful symptom (ADF/high) rather than
            // the weaker JSON/medium one. Preserves the "worst observed
            // signal wins" invariant.
            detectionLayer = 'parser';
            symptom = 'final_adf_invalid';
        } else if (finalJsonRepaired) {
            detectionLayer = 'parser';
            symptom = 'final_json_repaired';
        } else if (anySuspiciousSignal) {
            // Pick the highest-severity suspicious signal observed — worst
            // signal wins, matching the same invariant used for repair/failure
            // signals above. The four signals are checked in severity order:
            // unintendedRegionRemoved (content disappeared) > unintendedRegionModified
            // (content changed unexpectedly) > noMeaningfulEffect (no net change) >
            // intentEffectMismatch (structural delta contradicts inferred intent).
            detectionLayer = 'post_apply';
            if (unintendedRegionRemoved) symptom = 'unexpected_content_removal';
            else if (unintendedRegionModified) symptom = 'unintended_text_modification';
            else if (noMeaningfulEffect) symptom = 'no_meaningful_effect';
            else // intentEffectMismatch
            symptom = 'semantic_mismatch';
        }
        if (!this.telemetryEventsEnabled) return;
        (0, $7b61ecd8bc5f3510$export$f31b302ceb439402)({
            api: this.api,
            traceId: this.traceId,
            outcomeClass: outcomeClass,
            detectionLayer: detectionLayer,
            symptom: symptom,
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired,
            // Forward the post-apply analyzer flags so dashboards can see
            // "what happened" and "why it was suspicious" on a single
            // event. Each is `undefined` when the analyzer didn't run
            // (e.g. session aborted before any apply).
            ...analysis !== undefined ? {
                unintendedRegionRemoved: unintendedRegionRemoved,
                unintendedRegionModified: unintendedRegionModified,
                noMeaningfulEffect: noMeaningfulEffect,
                intentEffectMismatch: intentEffectMismatch,
                // Raw deltas — only attached when the corresponding
                // suspicious flag is true, to avoid forwarding
                // meaningless zeros on clean sessions.
                ...unintendedRegionRemoved ? {
                    removedNodeCount: analysis.removedNodeCount,
                    totalNodeDelta: analysis.totalNodeDelta,
                    // Indicates whether unintendedRegionRemoved used
                    // backend-supplied selectionLocalIds (precise) or
                    // the proxy fallback. Backend plumbing arrives with
                    // CCI-15978; until then always false.
                    selectionLocalIdsAvailable: false
                } : {},
                ...unintendedRegionModified ? {
                    textCharacterDelta: analysis.textCharacterDelta
                } : {}
            } : {},
            ...commandTypeCounts !== undefined ? {
                commandTypeCounts: commandTypeCounts
            } : {},
            ...heuristicInferred !== undefined ? {
                heuristicInferred: heuristicInferred
            } : {}
        });
    }
    /**
   * Schedules the `no_document_change` toolCallAnomaly check for streamable commands.
   *
   * The check must not run immediately after `processStreamCommandPromise` resolves
   * because `handleFinalize` (which commits the final content via two `view.dispatch`
   * calls) runs in a later `view.update()` cycle triggered by `endAIExperience`.
   * Firing immediately gives a stale pre-finalize doc — a guaranteed false positive.
   *
   * Instead we subscribe to `aiExperience.sharedState` and fire only after
   * `isStreaming` transitions to `false`, which happens after `handleFinalize`'s
   * commit transaction has landed and `getPmDoc()` is accurate.
   *
   * No-op when:
   * - The normalized telemetry experiment is disabled.
   * - `aiExperience` plugin is absent (streaming state machine unavailable).
   */ scheduleDeferredNoDocChangeAnalytics() {
        if (!(0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true) || !this.telemetryEventsEnabled || !this.api.aiExperience || this.toolCallResultFiredForCurrentCommand && (0, $dh538.fg)('platform_editor_ai_normalized_telemetry_patch2')) return;
        const capturedCommand = this.currentCommand;
        const capturedDocBeforeStreaming = this.docBeforeStreaming;
        const capturedTraceId = this.traceId;
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = this.api.aiExperience.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState != null && !nextSharedState.isStreaming) {
                this.pendingNoDocChangeUnsubscribe?.();
                this.pendingNoDocChangeUnsubscribe = undefined;
                if (!(this.toolCallResultFiredForCurrentCommand && (0, $dh538.fg)('platform_editor_ai_normalized_telemetry_patch2'))) (0, $7b61ecd8bc5f3510$export$276ecd5322451ab4)({
                    api: this.api,
                    command: capturedCommand,
                    docBeforeStreaming: capturedDocBeforeStreaming,
                    traceId: capturedTraceId
                });
            }
        });
    }
    /**
   * Reset session-outcome bookkeeping so the next session starts from a clean
   * slate. Called from `startSession`, `destroy`, and `abort`.
   */ resetSessionOutcomeState() {
        this.sessionRepairSignals = {
            anyJsonInvalid: false,
            anyAdfInvalid: false,
            unrepairedJsonCount: 0,
            unrepairedAdfCount: 0
        };
        this.sessionOutcomeFired = false;
        // Post-apply outcome analyzer state. Cleared so the next session
        // starts with an empty tool-call record and no stale analysis.
        this.sessionToolCalls = [];
        this.lastOutcomeAnalysis = undefined;
        this.preSessionDoc = undefined;
    }
    /**
   * Compute the structural-delta analysis for the just-completed session
   * and stash it on `lastOutcomeAnalysis`. Called from `endSession`
   * (gated). `fireSessionOutcomeOnce` reads `lastOutcomeAnalysis` to
   * derive the `success_but_suspicious` outcome class and to fire the
   * three suspicious-signal session-scope events.
   *
   * Skips silently if either the pre-session or post-session doc is
   * unavailable (e.g. editor view torn down mid-stream) — partial-data
   * analysis would produce misleading deltas.
   */ runPostApplyOutcomeAnalysis() {
        const postDoc = (0, $839bfdacc8d0b035$export$6bf900bab6a4720d)(this.api);
        if (this.preSessionDoc === undefined || postDoc === undefined) return;
        this.lastOutcomeAnalysis = (0, $66ee3dc21d67414d$export$9aa9db1056f785bc)({
            preSessionAdf: this.preSessionDoc.toJSON(),
            postSessionAdf: postDoc.toJSON(),
            toolCalls: this.sessionToolCalls
        });
    }
    destroy() {
        this.queue = [];
        this.adfStreamer = undefined;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
        this.promptVersion = undefined;
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = undefined;
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) this.resetSessionOutcomeState();
    }
    /**
   * Abort the current streaming and end the experience
   * This is a hard abort and will clear the queue
   * This will only restart the experience when initStreamCommand is called again
   */ abort() {
        this.logger.logPublic('Abort');
        // Fire BEFORE any state teardown so `traceId` and
        // `singleInstrumentationId` are still set and the event can be
        // correlated in dashboards (matches the timeout / clean-drain paths).
        // We deliberately do NOT reset `sessionOutcomeFired` here — the
        // guard must persist through any follow-up `endSession` / timeout
        // for this same session; the next `startSession()` resets it.
        if ((0, $1oCLl.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) this.fireSessionOutcomeOnce({
            lifecycleSymptom: 'session_aborted'
        });
        this.pendingNoDocChangeUnsubscribe?.();
        this.pendingNoDocChangeUnsubscribe = undefined;
        const currentQueue = this.queue.map((cmd)=>cmd.actionId);
        this.queue = [];
        // Add new aborted action IDs to end of array
        this.updateAbortedCache([
            ...new Set(currentQueue),
            ...this.inProcessing
        ]);
        this.isAborted = true;
        this.endExperience();
        this.isPendingResolveQueue = false;
        if (this.queueTimeout) clearTimeout(this.queueTimeout);
        this.currentAction = null;
        this.isFinalStream = false;
        this.currentCommand = undefined;
        this.traceId = undefined;
        this.singleInstrumentationId = undefined;
    }
    updateAbortedCache(actionIds) {
        this.aborted = [
            ...new Set([
                ...this.aborted,
                ...actionIds
            ])
        ];
        const maxAbortedCacheLength = 5;
        if (this.aborted.length > maxAbortedCacheLength) this.aborted = this.aborted.slice(-maxAbortedCacheLength);
    }
    constructor(api, streamFlowPacer = null, telemetryEventsEnabled = false){
        this.api = api;
        this.streamFlowPacer = streamFlowPacer;
        this.telemetryEventsEnabled = telemetryEventsEnabled;
        this.queue = [];
        this.adfStreamer = void 0;
        this.streamingCommands = void 0;
        this.currentCommand = undefined;
        this.docBeforeStreaming = undefined;
        this.isStreaming = false;
        this.isFinalStream = false;
        this.aborted = [];
        this.subscription = null;
        this.previousValidDoc = null;
        this.logger = void 0;
        this.endedActionIds = [];
        this.currentAction = null;
        this.insertAfterQueueLocalId = undefined;
        /**
     * The traceId received in response header from AI api call
     * This is used to trace the AI experience through the backend to frontend.
     */ this.traceId = undefined;
        /**
     * The singleInstrumentationId for tracking the AI experience
     * This is used to correlate events across multiple stream processing passes
     */ this.singleInstrumentationId = undefined;
        /**
     * The promptVersion from action metadata
     * This is used to track which version of the prompt was used for analytics
     */ this.promptVersion = undefined;
        /**
     * Aggregated repair signals across every streaming action in the current
     * session, used to fire the authoritative `sessionOutcome` event exactly
     * once per session.
     *
     * `*Invalid` aggregates with OR (any action that observed an invalid layer
     * marks the session as having seen an invalid layer).
     *
     * `*UnrepairedCount` counts how many actions had an invalid layer that was
     * NOT recovered. From these we derive a correct session-level "repaired"
     * value as: `*Invalid && *UnrepairedCount === 0` — i.e. every invalid
     * occurrence in the session was recovered.
     *
     * This avoids a misleading `success_with_repairs` classification when an
     * earlier action repaired successfully but a later action failed to repair:
     * a naive OR over `*Repaired` would incorrectly flatten the irrecoverable
     * failure into a success.
     */ this.sessionRepairSignals = {
            anyJsonInvalid: false,
            anyAdfInvalid: false,
            unrepairedJsonCount: 0,
            unrepairedAdfCount: 0
        };
        /**
     * Tracks whether the `sessionOutcome` analytics event has already been fired
     * for the active session. Ensures the event fires at most once per session.
     */ this.sessionOutcomeFired = false;
        /** Cleanup handle for the deferred no_document_change analytics subscription. Cleared in abort/destroy. */ this.pendingNoDocChangeUnsubscribe = undefined;
        /**
     * Set to true when a toolCallResult event has already been fired for the current
     * command (e.g. apply_failed_adf_schema_error from repair signals). Prevents
     * scheduleDeferredNoDocChangeAnalytics from firing a second toolCallResult for
     * the same command.
     */ this.toolCallResultFiredForCurrentCommand = false;
        /**
     * Per-session record of every tool call processed by `applyCommand`.
     * Consumed at end-of-session by `analyzeOutcome` to compute
     * `affectedLocalIds`. Reset at all session boundaries. Only populated
     * when the `platform_editor_ai_normalized_telemetry` experiment is on.
     */ this.sessionToolCalls = [];
        /**
     * The most recent `analyzeOutcome` result, computed at end-of-session.
     * Read by `fireSessionOutcomeOnce` (added by CCI-15893) to enrich the
     * `sessionOutcome` event with structural-delta fields. Undefined until
     * the first end-of-session analysis runs in the active lifetime, and
     * reset at all session boundaries.
     */ this.lastOutcomeAnalysis = undefined;
        /**
     * Snapshot of the editor document at session start, captured by
     * `startSession`. Consumed at end-of-session by `analyzeOutcome` as
     * `preSessionAdf`. Distinct from `docBeforeStreaming`, which is
     * reassigned per command for the per-command repair-signal pipeline.
     * Reset at all session boundaries. Only populated when the
     * `platform_editor_ai_normalized_telemetry` experiment is on.
     */ this.preSessionDoc = undefined;
        this.processingQueue = false;
        this.inProcessing = [];
        this.queueTimeout = null;
        // This is only used *if* we have started receiving values with a different
        // action id (new stream) and we have nothing left in the current stream (ie. it hasn't finished)
        // Really this shouldn't be hit since this would only happen on the edge when we're wrapping up the old stream
        // and starting the next early
        this.CURRENT_QUEUE_TIMEOUT = 5000;
        this.currentCommandTimeoutReset = null;
        this.onEmptyQueueResolve = null;
        // 2 seconds - this is the maximum time to process a command before we abort it and continue
        // This can be longer if for example if a lot of commands have been processed, but the stream flow
        // pacer has a backlog (particularly for elements with lots of attributes / marks etc) and hasn't had
        // a chance to emit yet
        this.COMMAND_TIMEOUT = 2000;
        this.isPendingResolveQueue = false;
        this.isAborted = false;
        this.logger = new (0, $127e6d5334706012$export$21e6cc849c1dc1ab)(api);
        this.streamingCommands = (0, $748219bd4f4f1029$export$a0774277976bc21f)(api);
    }
}


const $15f96a0d1cd67d4c$export$4010adcbb216eb38 = ({ api: api, config: config })=>{
    if (!api) throw new Error('api is not defined');
    let streamQueue;
    // Only allow one session to be active at a time
    let sessionId = null;
    // Tracking variables for debugging session lifecycle issues
    let hasSessionBeenStarted = false;
    let isEndingSession = false;
    let lastEndedSessionId = null;
    let endSessionCallCount = 0;
    let sessionAborted = false;
    const streamFlowPacer = (0, $19e1d609df7dfc8f$export$9ea8217d5ec56f82)(config?.streamFlowPacerEnabled);
    const telemetryEventsEnabled = config?.telemetryEventsEnabled === true;
    return {
        name: 'aiStreamingOrchestrator',
        actions: {
            startSession: (traceId, params)=>{
                sessionId = crypto.randomUUID() ?? (0, $fO7hX.uuid).generate();
                hasSessionBeenStarted = true;
                sessionAborted = false;
                streamQueue = new (0, $4c93be51fe49a367$export$f3feb8728b17a0a9)(api, streamFlowPacer, telemetryEventsEnabled);
                streamQueue.startSession(sessionId, traceId, params?.singleInstrumentationId, (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics') ? params?.promptVersion : undefined);
                // agentInfo is already gated by the platform_editor_agent_mentions experiment
                // in update-command-processor — it will be undefined when the experiment is off,
                // so no additional gate is needed here.
                api.aiExperience.actions.startSession(sessionId, traceId, (0, $dh538.fg)('platform_editor_ai_promptversion_in_analytics') ? params?.promptVersion : undefined, params?.agentInfo);
                return sessionId;
            },
            endSession: async (error)=>{
                // In the session abort we end the session and no longer need to run this
                // On a new session we reset the state so this is safe to ignore
                if (sessionAborted) return;
                if (sessionId === null) {
                    (0, $7b61ecd8bc5f3510$export$8b7d4483ec260574)({
                        api: api,
                        sessionStarted: hasSessionBeenStarted,
                        endSessionCallCount: endSessionCallCount,
                        lastEndedSessionId: lastEndedSessionId,
                        isDoubleCall: isEndingSession
                    });
                    throw new Error(`endSession requires a session to be started first!`);
                }
                endSessionCallCount++;
                isEndingSession = true;
                const currentSessionId = sessionId;
                try {
                    streamQueue?.queueEndSession(currentSessionId);
                    if (error) {
                        if ((0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api.aiExperience.actions.dispatchAIEvent({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                        else {
                            const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                            send({
                                type: 'error',
                                errorInfo: {
                                    failureReason: error.failureReason,
                                    statusCode: error.statusCode
                                }
                            });
                        }
                    }
                    // Since `endSession` is going to be called after all the actions are invoked
                    // so we can basically wait for the queue to be empty
                    await streamQueue?.onEmptyQueue();
                    streamQueue?.endSession(currentSessionId);
                    // https://atlassian.slack.com/archives/C0962DYFLRL/p1759397599541949?thread_ts=1759366160.706849&cid=C0962DYFLRL
                    // streamQueue?.destroy();
                    api.aiExperience.actions.endSession(currentSessionId, {
                        type: error ? 'error' : 'finished'
                    });
                    hasSessionBeenStarted = false;
                    lastEndedSessionId = currentSessionId;
                    sessionId = null;
                } finally{
                    isEndingSession = false;
                }
            },
            abortSession: ()=>{
                // abortSession can be called multiple times from multiple command handlers
                if (!sessionId) return;
                const sessionToEnd = sessionId;
                lastEndedSessionId = sessionToEnd;
                sessionId = null;
                streamQueue?.abort();
                if (sessionToEnd) {
                    api.aiExperience.actions.endSession(sessionToEnd, {
                        type: 'abort'
                    });
                    sessionAborted = true;
                }
            },
            initAction: (command, options)=>{
                if (sessionId === null) throw new Error('initAction requires a session to be started first!');
                const actionId = crypto.randomUUID();
                streamQueue?.initStreamCommand(actionId, command, options);
                return actionId;
            },
            // We are sending the full document as a chunk for create actions
            streamValue: (actionId, chunk)=>{
                // Use the queue manager to handle streaming
                // This will either process immediately if actor is ready, or queue for later
                streamQueue?.queueStreamCommand(actionId, chunk);
            },
            // HTML+ v2 incremental tool-call streaming contract:
            // Each chunk is a full snapshot of the value, not a delta.
            //
            // IMPORTANT — REPLACE-NOT-APPEND INVARIANT:
            // At the queue layer this is currently equivalent to `streamValue`
            // because `streamCommandQueue.ts#processStreamCommand` resets the
            // internal ADFStreamer accumulator on every processed chunk before
            // parsing. **Two distinct public actions (`streamValue` and
            // `replaceValue`) depend on this single internal behaviour.** If
            // `streamValue` is ever migrated to append semantics for the v1
            // path, this `replaceValue` body MUST be rewired to a dedicated
            // `queueReplaceCommand` (or equivalent) on `StreamCommandQueue`
            // that preserves the replace-on-snapshot guarantee, otherwise v2
            // callers (`ToolCallProcessorV2`) will silently break — each
            // snapshot would be appended to the previous one instead of
            // replacing it, producing duplicated / concatenated ADF.
            //
            // See `streamCommandQueue.ts#processStreamCommand` for the
            // implementation detail this invariant relies on.
            replaceValue: (actionId, fullValue)=>{
                streamQueue?.queueStreamCommand(actionId, fullValue);
            },
            notifySchemaContentRejection: (actionId, errorMessage)=>{
                if ((0, $dh538.fg)('platform_editor_ai_normalized_telemetry_patch2')) streamQueue?.notifySchemaContentRejection(actionId, errorMessage);
            },
            finishAction: (actionId, error)=>{
                if (error) {
                    if ((0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api.aiExperience.actions.dispatchAIEvent({
                        type: 'error',
                        errorInfo: {
                            failureReason: error.failureReason,
                            statusCode: error.statusCode
                        }
                    });
                    else {
                        const { send: send } = api.aiExperience.actions.getAiExperienceActor();
                        send({
                            type: 'error',
                            errorInfo: {
                                failureReason: error.failureReason,
                                statusCode: error.statusCode
                            }
                        });
                    }
                }
                streamQueue?.endStreamCommand(actionId);
            }
        },
        usePluginHook: ()=>{
            const prevStreamPausedRef = (0, $42omo.useRef)(undefined);
            (0, $6qdjm.usePluginStateEffect)(api, [
                'aiExperience'
            ], ({ aiExperienceState: aiExperienceState })=>{
                const streamPaused = aiExperienceState?.aiSessionPluginState?.streamPaused;
                if (streamPaused !== prevStreamPausedRef.current) {
                    if (streamPaused) streamFlowPacer?.pause();
                    else streamFlowPacer?.resume();
                    prevStreamPausedRef.current = streamPaused;
                }
            }, {
                disabled: !(0, $1oCLl.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
            });
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    streamQueue?.destroy();
                };
            }, []);
        }
    };
};
module.exports["aiStreamingOrchestratorPlugin"] = $15f96a0d1cd67d4c$export$4010adcbb216eb38;

});


//# sourceMappingURL=FullPageEditorComponent.1dae0c01.js.map
